import { isNil, isEmpty, get, has, cloneDeep } from 'lodash';
import { Injectable, NgModule } from '@angular/core';
import { of } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const SVG_NS = 'http://www.w3.org/2000/svg';
// TODO: following REGEX can't match the translate(x) which happen ONLY in IE when y pos is 0
/** @type {?} */
const TRANSLATE_PATTERN = new RegExp(/^(.*?)translate\(\s*([-]?(\d*\.)?\d+),?\s*([-]?(\d*\.)?\d+)\)(.*)$/);
/** @type {?} */
const TRANSLATE_PATTERN_PREFIX = 1;
/** @type {?} */
const TRANSLATE_PATTERN_X_INDEX = 2;
/** @type {?} */
const TRANSLATE_PATTERN_Y_INDEX = 4;
/** @type {?} */
const TRANSLATE_PATTERN_SUFFIX = 1;
class ElementPositionRange {
}
class ParagraphMap {
}
class TextSvgConfig {
}
TextSvgConfig.PARAGRAPH_HEIGHT_OFFSET = 5;
TextSvgConfig.DEFAULT_FONT_SIZE = '8';
TextSvgConfig.BOLD_FONT_WEIGHT = '700';
TextSvgConfig.DEFAULT_LINE_HEIGHT = 1.375;
TextSvgConfig.DEFAULT_PADDING_PERCENTAGE = 6;
class LetterDimensions {
}
LetterDimensions.LENGTH = 792;
LetterDimensions.LENGTH_CONTENT = 680;
LetterDimensions.WIDTH = 612;
LetterDimensions.WIDTH_CONTENT = 540;
LetterDimensions.LANDSCAPE_WIDTH_CONTENT = 720;
LetterDimensions.LANDSCAPE_HEIGHT_CONTENT = 495;
LetterDimensions.NILE_LENGTH_CONTENT = 715;
class LayoutDimensions {
}
LayoutDimensions.CHARACTERISTICS_TABLE_HEIGHT = 610;
var BoxModelConstants;
(function (BoxModelConstants) {
    BoxModelConstants.BORDER_GROUP_CLASS = 'report-box-model-border-group';
    BoxModelConstants.DEFAULT_BORDER_COLOR = 'black';
})(BoxModelConstants || (BoxModelConstants = {}));
/** @type {?} */
const DEFAULT_CONDENSED_TEXT_CLASSES = ['text-condensed-light'];
/** @type {?} */
const DEFAULT_MULTI_COLUMNS_TEXT_PADDING = 40;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HighChartsSVGUtil {
    /**
     * @param {?} charts
     * @return {?}
     */
    static getSVGAndConvertToG(charts) {
        /** @type {?} */
        const hcWrapper = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        /** @type {?} */
        let xCoordinate = 0;
        charts.forEach((/**
         * @param {?} chart
         * @return {?}
         */
        chart => {
            /** @type {?} */
            const svgHtml = new DOMParser().parseFromString(chart.getSVG(), 'text/xml');
            /** @type {?} */
            const svg = svgHtml.querySelector('svg');
            /** @type {?} */
            const chartContainer = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
            chartContainer.setAttribute('transform', `translate(${xCoordinate}, 0)`);
            chartContainer.appendChild(svg);
            hcWrapper.appendChild(chartContainer);
            xCoordinate += Number(svg.getAttribute('width'));
        }));
        return hcWrapper;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const TextHighlightingCases = {
    NOT_FOUND: 0,
    INLINE: 1,
    OVERLINE: 2,
};
TextHighlightingCases[TextHighlightingCases.NOT_FOUND] = 'NOT_FOUND';
TextHighlightingCases[TextHighlightingCases.INLINE] = 'INLINE';
TextHighlightingCases[TextHighlightingCases.OVERLINE] = 'OVERLINE';
class LineComposer {
    /**
     * @param {?} boldWordsRangeArray
     */
    constructor(boldWordsRangeArray) {
        this.boldWordsRangeArray = boldWordsRangeArray;
        this.totalCharCount = 0;
    }
    /**
     * @param {?} text
     * @param {?} element
     * @param {?=} isBold
     * @return {?}
     */
    static generateTSpanAndAppend(text, element, isBold) {
        /** @type {?} */
        const tspanElem = (/** @type {?} */ (document.createElementNS(SVG_NS, 'tspan')));
        if (isBold) {
            // This is a hacky way to get the font rendered in Batik
            tspanElem.setAttribute('font-family', 'FortBold');
            tspanElem.setAttribute('font-weight', 'bold');
            // tspanElem.setAttribute('font-weight', TextSvgConfig.BOLD_FONT_WEIGHT);
            tspanElem.setAttribute('fill', '#000000');
        }
        /** @type {?} */
        const div = document.createElement('div');
        div.innerHTML = text;
        /** @type {?} */
        const parsedText = div.textContent || div.innerText || '';
        tspanElem.textContent = parsedText;
        element.appendChild(tspanElem);
        return element;
    }
    /**
     * @return {?}
     */
    getCurrentRange() {
        return this.boldWordsRangeArray[0];
    }
    /**
     * @param {?} line
     * @return {?}
     */
    checkCase(line) {
        if (isNil(this.boldWordsRangeArray[0])) {
            return;
        }
        /** @type {?} */
        const absoluteCharCountStart = this.totalCharCount;
        /** @type {?} */
        const absoluteCharCountEnd = this.totalCharCount + line.length;
        /** @type {?} */
        const currentRange = this.boldWordsRangeArray[0];
        if (this.isInline(absoluteCharCountStart, absoluteCharCountEnd, currentRange)) {
            return TextHighlightingCases.INLINE;
        }
        else if (this.isOverline(absoluteCharCountStart, absoluteCharCountEnd, currentRange)) {
            return TextHighlightingCases.OVERLINE;
        }
        else if (this.isNotFoundInline) {
            return TextHighlightingCases.NOT_FOUND;
        }
        return;
    }
    /**
     * @private
     * @param {?} lineStart
     * @param {?} lineEnd
     * @param {?} currentRange
     * @return {?}
     */
    isRangeStartInLine(lineStart, lineEnd, currentRange) {
        return currentRange.start >= lineStart && currentRange.start <= lineEnd;
    }
    /**
     * @private
     * @param {?} lineStart
     * @param {?} lineEnd
     * @param {?} currentRange
     * @return {?}
     */
    isRangeEndInLine(lineStart, lineEnd, currentRange) {
        return currentRange.end >= lineStart && currentRange.end <= lineEnd;
    }
    /**
     * @private
     * @param {?} lineStart
     * @param {?} lineEnd
     * @param {?} currentRange
     * @return {?}
     */
    isInline(lineStart, lineEnd, currentRange) {
        return this.isRangeStartInLine(lineStart, lineEnd, currentRange) && this.isRangeEndInLine(lineStart, lineEnd, currentRange);
    }
    /**
     * @private
     * @param {?} lineStart
     * @param {?} lineEnd
     * @param {?} currentRange
     * @return {?}
     */
    isOverline(lineStart, lineEnd, currentRange) {
        return this.isRangeStartInLine(lineStart, lineEnd, currentRange) && !this.isRangeEndInLine(lineStart, lineEnd, currentRange);
    }
    /**
     * @private
     * @param {?} lineStart
     * @param {?} lineEnd
     * @param {?} currentRange
     * @return {?}
     */
    isNotFoundInline(lineStart, lineEnd, currentRange) {
        return !this.isRangeStartInLine(lineStart, lineEnd, currentRange) && !this.isRangeEndInLine(lineStart, lineEnd, currentRange);
    }
    /**
     * @param {?} lineCopy
     * @param {?} textElement
     * @return {?}
     */
    buildInline(lineCopy, textElement) {
        /** @type {?} */
        const tagText = lineCopy.substring(this.getCurrentRange().start - this.totalCharCount, this.getCurrentRange().end - this.totalCharCount);
        if (this.getCurrentRange().start - this.totalCharCount !== 0) {
            textElement = LineComposer.generateTSpanAndAppend(lineCopy.split(tagText)[0], textElement);
        }
        textElement = LineComposer.generateTSpanAndAppend(tagText, textElement, true);
        this.currentLine = lineCopy.substring(this.getCurrentRange().end - this.totalCharCount);
        this.totalCharCount = this.getCurrentRange().end;
        this.boldWordsRangeArray.shift();
        return textElement;
    }
    /**
     * @param {?} lineCopy
     * @param {?} textElement
     * @return {?}
     */
    buildOverline(lineCopy, textElement) {
        /** @type {?} */
        const tagText = lineCopy.substring(this.getCurrentRange().start - this.totalCharCount);
        if (this.getCurrentRange().start - this.totalCharCount !== 0) {
            textElement = LineComposer.generateTSpanAndAppend(lineCopy.split(tagText)[0], textElement);
        }
        textElement = LineComposer.generateTSpanAndAppend(tagText, textElement, true);
        this.currentLine = lineCopy.substring(this.getCurrentRange().end - this.totalCharCount);
        this.totalCharCount = this.totalCharCount + lineCopy.length;
        this.boldWordsRangeArray[0].start = this.totalCharCount + 1;
        return textElement;
    }
    /**
     * @param {?} lineCopy
     * @param {?} textElement
     * @return {?}
     */
    buildNotFound(lineCopy, textElement) {
        textElement = LineComposer.generateTSpanAndAppend(lineCopy, textElement);
        this.totalCharCount += lineCopy.length;
        this.currentLine = '';
        return textElement;
    }
    /**
     * @param {?} line
     * @param {?} textElement
     * @return {?}
     */
    buildLine(line, textElement) {
        this.currentLine = line;
        if (isEmpty(this.boldWordsRangeArray)) {
            textElement.textContent = this.currentLine;
            this.totalCharCount += 1; // to account for extra space lost during line break
            return textElement;
        }
        while (this.currentLine.length > 0) {
            if (isEmpty(this.boldWordsRangeArray)) {
                textElement = LineComposer.generateTSpanAndAppend(this.currentLine, textElement);
                return textElement;
            }
            /** @type {?} */
            const condition = this.checkCase(this.currentLine);
            switch (condition) {
                case TextHighlightingCases.INLINE:
                    textElement = this.buildInline(this.currentLine, textElement);
                    break;
                case TextHighlightingCases.OVERLINE:
                    textElement = this.buildOverline(this.currentLine, textElement);
                    break;
                case TextHighlightingCases.NOT_FOUND:
                    textElement = this.buildNotFound(this.currentLine, textElement);
                    break;
            }
        }
        this.totalCharCount += 1; // to account for extra space lost during line break
        return textElement;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhantomSVGText {
    /**
     * @param {?=} text
     * @param {?=} attrs
     * @param {?=} textElement
     */
    constructor(text = '', attrs = {}, textElement) {
        this.text = text;
        this.attrs = attrs;
        if (!textElement) {
            this.textElement = (/** @type {?} */ (document.createElementNS(SVG_NS, 'text')));
            this.textElement.setAttribute('x', '0');
            this.textElement.setAttribute('y', '0');
            Object.keys(attrs).forEach((/**
             * @param {?} attr
             * @return {?}
             */
            attr => this.textElement.setAttribute(attr, attrs[attr])));
            this.textElement.textContent = text;
        }
        else {
            this.textElement = textElement;
        }
        this.svg = (/** @type {?} */ (document.createElementNS(SVG_NS, 'svg')));
        this.svg.appendChild(this.textElement);
        document.body.appendChild(this.svg);
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} text
     * @return {THIS}
     */
    setText(text) {
        (/** @type {?} */ (this)).textElement.textContent = text;
        return (/** @type {?} */ (this));
    }
    /**
     * @return {?}
     */
    getText() {
        return this.textElement.textContent;
    }
    /**
     * @return {?}
     */
    getWidth() {
        if (this.textElement.textContent === '') {
            return 0;
        }
        if (typeof this.textElement.getComputedTextLength !== 'undefined') {
            return this.textElement.getComputedTextLength();
        }
        return this.textElement.getBBox().width;
    }
    /**
     * @return {?}
     */
    getCharacterCount() {
        return this.textElement.textContent.length;
    }
    /**
     * @return {?}
     */
    destroy() {
        document.body.removeChild(this.svg);
        this.svg = null;
        this.textElement = null;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
class ContentBox {
    /**
     * @param {?} element
     * @param {?} width
     * @param {?} height
     */
    constructor(element, width, height) {
        this.element = element;
        this.width = width;
        this.height = height;
        if (typeof width !== 'number' || width < 0) {
            throw new Error('Illegal width');
        }
        if (typeof height !== 'number' || height < 0) {
            throw new Error('Illegal width');
        }
        // if (element && (height === 0 || width === 0)) {
        // 	throw new Error('Empty elements can\'t have content attached!');
        // }
        if (!element && (height > 0 && width > 0)) {
            throw new Error('Empty elements can\'t have content attached!');
        }
    }
    /**
     * @return {?}
     */
    isEmpty() {
        return this.width <= 0 || this.height <= 0 || !this.element;
    }
}
ContentBox.EMPTY = new ContentBox(null, 0, 0);
/**
 * @template T
 */
class PublicContentBox extends ContentBox {
    /**
     * @param {?} element
     * @param {?} width
     * @param {?} height
     * @param {?} constraints
     */
    constructor(element, width, height, constraints) {
        super(element, width, height);
        this.constraints = constraints;
    }
}
PublicContentBox.EMPTY = new PublicContentBox(null, 0, 0, null);
/**
 * @template T
 */
class ContentBoxBuilder {
    /**
     * @template U
     * @param {?} c
     * @return {?}
     */
    static with(c) {
        /** @type {?} */
        const builder = new ContentBoxBuilder();
        builder.element = c.element;
        builder.width = c.width;
        builder.height = c.height;
        return builder;
    }
    /**
     * @param {?} dWidth
     * @param {?} dHeight
     * @return {?}
     */
    addDimensions(dWidth, dHeight) {
        this.height += dHeight;
        this.width += dWidth;
        return this;
    }
    /**
     * @return {?}
     */
    get() {
        return new ContentBox(this.element, this.width, this.height);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Alignment;
(function (Alignment) {
    let Horizontal;
    (function (Horizontal) {
        Horizontal[Horizontal["Left"] = 0] = "Left";
        Horizontal[Horizontal["Center"] = 1] = "Center";
        Horizontal[Horizontal["Right"] = 2] = "Right";
    })(Horizontal = Alignment.Horizontal || (Alignment.Horizontal = {}));
    let Vertical;
    (function (Vertical) {
        Vertical[Vertical["Top"] = 0] = "Top";
        Vertical[Vertical["Middle"] = 1] = "Middle";
        Vertical[Vertical["Bottom"] = 2] = "Bottom";
    })(Vertical = Alignment.Vertical || (Alignment.Vertical = {}));
})(Alignment || (Alignment = {}));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An object mimicking a CSS file, where the key would represent a class name and the value would represent
 * a partial of `IClassList` properties. To get an idea of the supported properties, refer `IClassList`
 * or visit https://www.w3.org/TR/SVGTiny12/attributeTable.html.
 *
 * If there is a common property defined in two classes, the order of precedence will the lowest class first
 * to the top.
 * @type {?}
 */
const CLASS_LIST = {
    'text-defaults': { 'font-size': 8, 'font-family': 'FortBook', 'font-weight': '400', fill: '#000' },
    'text-7': { 'font-size': 7 },
    'text-7.8': { 'font-size': 7.8 },
    'text-8': {},
    'text-9': { 'font-size': 9 },
    'text-9.5': { 'font-size': 9.5 },
    'text-10': { 'font-size': 10 },
    'text-10.5': { 'font-size': 10.5 },
    'text-11': { 'font-size': 11 },
    'text-12': { 'font-size': 12 },
    'text-13': { 'font-size': 13 },
    'text-14': { 'font-size': 14 },
    'text-15': { 'font-size': 15 },
    'text-16': { 'font-size': 16 },
    'text-18': { 'font-size': 18 },
    'text-20': { 'font-size': 20 },
    'text-22': { 'font-size': 22 },
    'text-24': { 'font-size': 24 },
    'text-27': { 'font-size': 27 },
    'text-30': { 'font-size': 30 },
    'text-regular': {},
    'text-condensed-light': { 'font-family': 'FortCondensedLight', 'font-weight': '300' },
    'text-bold': { 'font-family': 'FortBold', 'font-weight': 'bold' },
    'text-condensed-bold': { 'font-family': 'FortCondensedBold', 'font-weight': '700' },
    'text-extra-bold': { 'font-family': 'FortExtraBold', 'font-weight': '800' },
    'text-italic': { 'font-family': 'FortBookItalic', 'font-style': 'italic' },
    'text-white': { fill: '#FFFFFF' },
    'text-grey': { fill: '#4A4A4A' },
    'text-neutral-grey': { fill: '#616161' },
    'text-orange': { fill: '#f28400' },
    'text-pale-grey': { fill: '#a9a9a9' },
    'text-st-table-green': { fill: '#008B5C' },
    'text-st-table-red': { fill: '#C00B28' },
    'text-black': { fill: '#000' },
    'text-san-juan': { fill: '#455761' },
    'text-cobalt': { fill: '#034EA2' },
    'text-aubergine': { fill: '#231F20' },
    'text-carrot-orange': { fill: '#f8971d' },
    'text-pigment-green': { fill: '#009a3d' },
    'text-green-cyan': { fill: '#009941' },
    'text-blue-lagoon': { fill: '#00677F' },
    'text-deep-magenta': { fill: '#5d326c' },
    'text-olive-drab': { fill: '#722287' },
    'text-deep-cyan-blue': { fill: '#073586' },
    'text-pacific-blue': { fill: '#41b6e6' },
    'text-watercourse': { fill: '#006747' },
    'text-strong-green-cyan': { fill: '#009639' },
    'text-sapphire': { fill: '#0F2D5D' },
    'text-strong-cyan': { fill: '#27afaf' },
    'text-gainsboro': { fill: '#dddddd' },
    'text-brilliant-rose': { fill: '#772654' },
    'text-purple': { fill: '#6E3FA3' },
    'text-hyperlink': { fill: '#0000EE' },
    'text-avenir-bold': { 'font-family': 'AvenirNextLTPro-Bold' },
    'text-avenir-demi': { 'font-family': 'AvenirNextLTPro-Demi' },
    'text-avenir-italic': { 'font-family': 'AvenirNextLTPro-Italic' },
    'text-avenir-light': { 'font-family': 'AvenirNextLTPro-Light' },
    'text-avenir-regular': { 'font-family': 'AvenirNextLTPro-Regular' },
    heading: { 'font-family': 'FortExtraBold', 'font-size': 24, 'font-weight': '600' }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SVGUtils {
    /**
     * @param {?} element
     * @param {?=} attrs
     * @return {?}
     */
    static applyAttributes(element, attrs = {}) {
        Object.keys(attrs).forEach((/**
         * @param {?} attr
         * @return {?}
         */
        attr => element.setAttribute(attr, attrs[attr])));
    }
    /**
     * @template T
     * @param {?} leftOffset
     * @param {?} topOffset
     * @param {?} content
     * @return {?}
     */
    static updateTranslate(leftOffset, topOffset, content) {
        if (isNaN(leftOffset) || isNaN(topOffset)) {
            throw new Error(`Both supplied offset values have to be valid numbers left ${leftOffset} top ${topOffset}`);
        }
        /** @type {?} */
        let prefix = '';
        /** @type {?} */
        let suffix = '';
        if (leftOffset !== 0 || topOffset !== 0) {
            /** @type {?} */
            const transformValue = content.getAttribute('transform');
            // FIXME transform may have other properties that would be lost
            /** @type {?} */
            let translateX = leftOffset ? leftOffset : 0;
            /** @type {?} */
            let translateY = topOffset ? topOffset : 0;
            if (transformValue) {
                /** @type {?} */
                const translateMatches = TRANSLATE_PATTERN.exec(transformValue);
                prefix = translateMatches[TRANSLATE_PATTERN_PREFIX];
                suffix = translateMatches[TRANSLATE_PATTERN_SUFFIX];
                /** @type {?} */
                const existingXOffset = Number.parseFloat(translateMatches[TRANSLATE_PATTERN_X_INDEX]);
                if (!Number.isNaN(existingXOffset)) {
                    translateX += existingXOffset;
                }
                /** @type {?} */
                const existingYOffset = Number.parseFloat(translateMatches[TRANSLATE_PATTERN_Y_INDEX]);
                if (!Number.isNaN(existingXOffset)) {
                    translateY += existingYOffset;
                }
            }
            /** @type {?} */
            const translateXString = translateX
                .toFixed(2)
                .replace(/0+$/, '')
                .replace(/[.]$/, '');
            /** @type {?} */
            const translateYString = translateY
                .toFixed(2)
                .replace(/0+$/, '')
                .replace(/[.]$/, '');
            content.setAttribute('transform', `${prefix}translate(${translateXString}, ${translateYString})${suffix}`);
        }
        return content;
    }
    /**
     * @return {?}
     */
    static enableEditMode() {
        SVGUtils.editMode = true;
    }
    /**
     * @return {?}
     */
    static disableEditMode() {
        SVGUtils.editMode = false;
    }
    /**
     * @param {?} contentBox
     * @param {?} contentKey
     * @param {?} defaultValue
     * @param {?} contentProvider
     * @return {?}
     */
    static setupEditMode(contentBox, contentKey, defaultValue, contentProvider) {
        if (contentProvider && SVGUtils.editMode && contentKey && contentBox.element) {
            /** @type {?} */
            const g = document.createElement('g');
            /** @type {?} */
            const rect = document.createElement('rect');
            rect.setAttribute('width', String(contentBox.width));
            rect.setAttribute('height', String(contentBox.height));
            rect.setAttribute('fill', 'rgba(255,255,0,1)');
            g.appendChild(rect);
            /** @type {?} */
            const text = document.createElement('text');
            g.appendChild(text);
            text.setAttribute('style', 'font-size:10px; font-weight:bold; fill:#00f;');
            text.innerHTML = `<tspan dy="1em"> EDIT: ${contentKey}</tspan>`;
            if (SVGUtils.editModeDecorator) {
                SVGUtils.editModeDecorator.decorate(text, contentProvider, contentKey, defaultValue);
            }
            contentBox.element.appendChild(g);
        }
    }
    /**
     * @param {?} decorator
     * @return {?}
     */
    static setEditModeDecorator(decorator) {
        SVGUtils.editModeDecorator = decorator;
    }
}
SVGUtils.editMode = false;
SVGUtils.editModeDecorator = null;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TextSVGRendererError extends Error {
    /**
     * @param {?} message
     */
    constructor(message) {
        super(message);
    }
}
class TextSvgRendererUtils {
    /**
     * Given an array of strings and the required alignments, it returns an SVGTextElement block of text
     * @param {?} lines
     * @param {?} width
     * @param {?} height
     * @param {?} hAlignment
     * @param {?} vAlignment
     * @param {?} lineHeight
     * @param {?=} paddingPercentage
     * @param {?=} offset
     * @param {?=} boldWordsRangeArray
     * @return {?}
     */
    static constructParagraph(lines, width, height, hAlignment, vAlignment, lineHeight, paddingPercentage, offset, boldWordsRangeArray) {
        if (!offset) {
            offset = 0;
        }
        /** @type {?} */
        let textYOffset = 0;
        /** @type {?} */
        const bottomPadding = 0.25;
        /** @type {?} */
        const sidePaddingOffset = paddingPercentage ? width / 100 * (paddingPercentage / 4) : 0;
        /** @type {?} */
        const textBuilder = new LineComposer(boldWordsRangeArray);
        /** @type {?} */
        const svgTspanElementArray = lines.map((/**
         * @param {?} line
         * @param {?} idx
         * @param {?} allLines
         * @return {?}
         */
        (line, idx, allLines) => {
            /** @type {?} */
            let textElement = (/** @type {?} */ (document.createElementNS(SVG_NS, 'tspan')));
            textElement = textBuilder.buildLine(line, textElement);
            switch (vAlignment) {
                case Alignment.Vertical.Top:
                    textElement.setAttribute('dy', TextSvgRendererUtils.calcTopOffset(lineHeight, idx)
                        .toFixed(2)
                        .replace(/0+$/, '')
                        .replace(/[.]$/, '') + 'em');
                    textElement.setAttribute('x', `0`);
                    break;
                case Alignment.Vertical.Middle:
                    textElement.setAttribute('y', `${TextSvgRendererUtils.calcCenteredOffset(lineHeight, idx, allLines.length)}em`);
                    textElement.setAttribute('x', `0`);
                    textYOffset = height / 2;
                    break;
                case Alignment.Vertical.Bottom:
                    /** @type {?} */
                    const offset = TextSvgRendererUtils.calcBottomOffset(lineHeight, idx, allLines.length) - bottomPadding;
                    textElement.setAttribute('y', `${offset}em`);
                    textElement.setAttribute('x', `0`);
                    textYOffset = height;
                    break;
            }
            return textElement;
        }));
        /** @type {?} */
        const textWrapper = (/** @type {?} */ (document.createElementNS(SVG_NS, 'text')));
        svgTspanElementArray.forEach((/**
         * @param {?} element
         * @return {?}
         */
        element => {
            textWrapper.appendChild(element);
        }));
        // define horizontal alignment
        switch (hAlignment) {
            case Alignment.Horizontal.Left:
                textWrapper.setAttribute('text-anchor', 'start');
                SVGUtils.updateTranslate(sidePaddingOffset + offset, textYOffset, textWrapper);
                break;
            case Alignment.Horizontal.Center:
                textWrapper.setAttribute('text-anchor', 'middle');
                SVGUtils.updateTranslate((width + offset) / 2, textYOffset, textWrapper);
                break;
            case Alignment.Horizontal.Right:
                textWrapper.setAttribute('text-anchor', 'end');
                SVGUtils.updateTranslate(width + offset - sidePaddingOffset, textYOffset, textWrapper);
        }
        return textWrapper;
    }
    /**
     * @param {?} lineHeight
     * @param {?} i
     * @param {?} numberOfLines
     * @return {?}
     */
    static calcCenteredOffset(lineHeight, i, numberOfLines) {
        /** @type {?} */
        const offset = numberOfLines % 2 ? 0.5 : lineHeight - (lineHeight - 1) / 2;
        return (i - Math.floor(numberOfLines / 2)) * lineHeight + offset;
    }
    /**
     * @param {?} lineHeight
     * @param {?} i
     * @param {?} numberOfLines
     * @return {?}
     */
    static calcBottomOffset(lineHeight, i, numberOfLines) {
        return lineHeight * (1 - numberOfLines) + i * lineHeight;
    }
    /**
     * @param {?} lineHeight
     * @param {?} i
     * @return {?}
     */
    static calcTopOffset(lineHeight, i) {
        if (lineHeight > 1) {
            return i === 0 ? lineHeight - lineHeight / 3 : lineHeight;
        }
        else {
            return lineHeight;
        }
    }
    /**
     * Given text and available width, return the text wrapped to the next line if required. Returns an array of strings, where each element is a line
     * @param {?} text
     * @param {?} width
     * @param {?} attrs
     * @param {?} phantomText
     * @param {?} height
     * @param {?=} lineHeight
     * @param {?=} paddingPercentage
     * @param {?=} boldWordsIndexes
     * @return {?}
     */
    static svgTextWrap(text, width, attrs, phantomText, height, lineHeight = TextSvgConfig.DEFAULT_LINE_HEIGHT, paddingPercentage, boldWordsIndexes) {
        /** @type {?} */
        const padding = paddingPercentage ? width / 100 * paddingPercentage : 0;
        width = width - padding; // for extra padding
        // for extra padding
        /** @type {?} */
        const words = text.split(/\s+/);
        /** @type {?} */
        let lines = [];
        /** @type {?} */
        const lineWidths = [];
        /** @type {?} */
        let currentLine = [];
        /** @type {?} */
        let minWordsBeforeWrap = 0;
        /** @type {?} */
        let maxLines;
        /** @type {?} */
        const unwrappedWidth = phantomText.getWidth();
        // do height logic if it has been passed in
        if (height) {
            /** @type {?} */
            const fontSize = attrs && attrs['font-size'] ? parseInt(attrs['font-size'], 10) : parseInt(TextSvgConfig.DEFAULT_FONT_SIZE, 10);
            maxLines = Math.floor(height / TextSvgRendererUtils.estimateHeight(1, fontSize, lineHeight));
        }
        // only do wrapping logic if needed
        if (unwrappedWidth < width) {
            lines = [text];
            lineWidths.push(unwrappedWidth);
        }
        else {
            if (words > 3) {
                // skip words before attempting to wrap
                /** @type {?} */
                const estimatedWidthPerWord = unwrappedWidth / words.length;
                minWordsBeforeWrap = width / estimatedWidthPerWord * 0.66;
            }
            /** @type {?} */
            let idx = 0;
            /** @type {?} */
            let currentLineWidth = 0;
            /** @type {?} */
            let currentAdditionalBoldWidth = 0;
            words.forEach((/**
             * @param {?} word
             * @param {?} index
             * @return {?}
             */
            (word, index) => {
                // If we have a height constraint, check if it's the last line
                if (maxLines !== undefined && lines.length + 1 >= maxLines) {
                    /** @type {?} */
                    const textWithEllipsis = TextSvgRendererUtils.svgTextEllipsis(TextSvgRendererUtils.getStringToEllipse(idx, words), width, attrs);
                    lines.push(textWithEllipsis);
                    lineWidths.push(width);
                    return [lines, lineWidths];
                }
                else {
                    if (currentLine.length < minWordsBeforeWrap) {
                        currentLine.push(word);
                    }
                    else {
                        const [newLineWidth, newAdditionalBoldWidth] = TextSvgRendererUtils.calculateNewLineWidth(phantomText, currentAdditionalBoldWidth, currentLine, word, boldWordsIndexes.includes(index));
                        if (newLineWidth > width && currentLine.length) {
                            lines.push(currentLine.join(' '));
                            currentLine = [word];
                            lineWidths.push(currentLineWidth);
                            phantomText.setText(word);
                            currentLineWidth = phantomText.getWidth();
                            currentAdditionalBoldWidth = newAdditionalBoldWidth - currentAdditionalBoldWidth;
                        }
                        else {
                            currentLine.push(word);
                            currentLineWidth = newLineWidth;
                            currentAdditionalBoldWidth = newAdditionalBoldWidth;
                        }
                    }
                }
                idx += 1;
            }));
            lines.push(currentLine.join(' '));
            lineWidths.push(currentLineWidth);
            if (lines[0] === '') {
                lines.shift();
                lineWidths.shift();
            }
        }
        return [lines, lineWidths];
    }
    /**
     * @private
     * @param {?} phantomText
     * @param {?} previousBoldWidth
     * @param {?} currentLine
     * @param {?} newWord
     * @param {?} isNewWordBold
     * @return {?}
     */
    static calculateNewLineWidth(phantomText, previousBoldWidth, currentLine, newWord, isNewWordBold) {
        // Modifier is the 3rd standard deviation of bold font divided by regular font variation taken from a large sample - Avg = 1.0396, StDev = 0.0047 (1.0396 + 0.0047 * 3).
        /** @type {?} */
        const BOLD_FONT_WIDTH_MODIFIER = 1.0537;
        /** @type {?} */
        let newLineWidth = 0;
        /** @type {?} */
        let newAdditionalBoldWidth = previousBoldWidth;
        /** @type {?} */
        const newLine = [...currentLine, newWord];
        phantomText.setText(newLine.join(' '));
        newLineWidth = phantomText.getWidth();
        if (isNewWordBold) {
            phantomText.setText(`${newWord}`);
            /** @type {?} */
            const additionalWidthInBold = phantomText.getWidth() * BOLD_FONT_WIDTH_MODIFIER - phantomText.getWidth();
            newAdditionalBoldWidth += additionalWidthInBold;
            newLineWidth = newLineWidth + newAdditionalBoldWidth;
        }
        return [newLineWidth, newAdditionalBoldWidth];
    }
    /**
     * @private
     * @param {?} idx
     * @param {?} words
     * @return {?}
     */
    static getStringToEllipse(idx, words) {
        /** @type {?} */
        const ellipsisStartIdx = idx - 1 >= 0 ? idx - 1 : 0;
        return words.slice(ellipsisStartIdx, words.length).join(' ');
    }
    /**
     * Given text and available width, either return the full text or its truncated form with ellipsis. Use sparingly due to performance impact in IE
     * @private
     * @param {?} text
     * @param {?} width
     * @param {?} attrs
     * @return {?}
     */
    static svgTextEllipsis(text, width, attrs) {
        /** @type {?} */
        const phantomElement = new PhantomSVGText(text, attrs);
        /** @type {?} */
        const elementWidth = phantomElement.getWidth();
        // if the text exceeds the given width, truncate it until it fits
        if (elementWidth > width) {
            // recursive function to add/remove 1 letter from the text and re-test if the word fits in the width
            /** @type {?} */
            const textLength = phantomElement.getCharacterCount();
            /** @type {?} */
            const diff = elementWidth - width;
            if (diff > 30) {
                // if the text is much bigger than the width, make an educated guess of what the truncated text length should be
                /** @type {?} */
                const pxPerChar = elementWidth / textLength;
                /** @type {?} */
                const estimatedLength = Math.floor(width / pxPerChar) - 2;
                phantomElement.setText(text.slice(0, estimatedLength) + '...');
                /** @type {?} */
                const nextElementWidth = phantomElement.getWidth();
                // then fine-tune the result by adding/removing characters
                TextSvgRendererUtils.adjustWidth(phantomElement, text, estimatedLength, nextElementWidth > width ? -1 : 1, width);
            }
            else {
                // otherwise just remove characters one by one until it fits
                TextSvgRendererUtils.adjustWidth(phantomElement, text, textLength, -1, width);
            }
            /** @type {?} */
            const nextText = phantomElement.getText();
            return nextText;
        }
        return text;
    }
    /**
     * @private
     * @param {?} el
     * @param {?} text
     * @param {?} prevLength
     * @param {?} direction
     * @param {?} width
     * @return {?}
     */
    static adjustWidth(el, text, prevLength, direction, width) {
        el.setText(text.slice(0, prevLength + direction) + '...');
        /** @type {?} */
        const elWidth = el.getWidth();
        if ((direction > 0 && elWidth < width) || (direction < 0 && elWidth > width)) {
            TextSvgRendererUtils.adjustWidth(el, text, prevLength + direction, direction, width);
        }
        else {
            el.setText(text.slice(0, prevLength) + '...');
        }
    }
    /**
     * Estimates text height
     * @param {?} numOfLines
     * @param {?} fontSize in pixels
     * @param {?} lineHeight in em
     * @return {?}
     */
    static estimateHeight(numOfLines, fontSize, lineHeight) {
        return fontSize * lineHeight * numOfLines;
    }
    /**
     * @param {?} svgStr
     * @return {?}
     */
    static createDOMFromSVGStr(svgStr) {
        // Explicitly fail on empty string
        if (svgStr === '') {
            throw new TextSVGRendererError('Cannot createDOMFromSVGStr from empty string');
        }
        return new DOMParser().parseFromString(svgStr, 'image/svg+xml');
    }
    /**
     * @param {?} text
     * @param {?=} attrs
     * @param {?=} width
     * @param {?=} height
     * @param {?=} padding
     * @param {?=} hAlign
     * @param {?=} vAlign
     * @param {?=} useFullWidth
     * @param {?=} useFullHeight
     * @param {?=} lineHeight
     * @return {?}
     */
    static generateWithHTML(text, attrs = { 'font-size': TextSvgConfig.DEFAULT_FONT_SIZE }, width, height, padding = 0, hAlign = Alignment.Horizontal.Left, vAlign = Alignment.Vertical.Top, useFullWidth = true, useFullHeight = true, lineHeight = TextSvgConfig.DEFAULT_LINE_HEIGHT) {
        /** @type {?} */
        const strippedText = TextSvgRendererUtils.stripUnsupportedHTMLTags(text);
        /** @type {?} */
        const paragraphMapArray = TextSvgRendererUtils.splitByParagraphs(strippedText);
        /** @type {?} */
        const gParagraph = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        /** @type {?} */
        let remainingHeight = height;
        /** @type {?} */
        let runningHeight = 0;
        /** @type {?} */
        let yOffset = 0;
        vAlign = useFullHeight ? vAlign : Alignment.Vertical.Top;
        /** @type {?} */
        const phantomText = new PhantomSVGText('', Object.assign(Object.assign({}, CLASS_LIST['text-defaults']), attrs));
        try {
            /** @type {?} */
            const wrappedText = paragraphMapArray.map((/**
             * @param {?} paragraph
             * @return {?}
             */
            paragraph => {
                phantomText.setText(paragraph.withoutHTML);
                /** @type {?} */
                const textWrap = TextSvgRendererUtils.svgTextWrap(paragraph.withoutHTML, width, attrs, phantomText, height - yOffset, lineHeight, padding, TextSvgRendererUtils.getBoldWordsIndex(paragraph.withHTML));
                return [textWrap[0], textWrap[1], paragraph];
            }));
            /** @type {?} */
            const actualWidth = useFullWidth ? Math.max(...wrappedText.map((/**
             * @param {?} data
             * @return {?}
             */
            data => Math.max(...((/** @type {?} */ (data[1]))))))) : width;
            wrappedText.forEach((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                /** @type {?} */
                const pMap = (/** @type {?} */ (data[2]));
                /** @type {?} */
                const paragraphLines = (/** @type {?} */ (data[0]));
                /** @type {?} */
                const map = TextSvgRendererUtils.mapBoldWords(pMap.withHTML);
                /** @type {?} */
                const paragraph = TextSvgRendererUtils.constructParagraph(paragraphLines, actualWidth, height - yOffset, hAlign, vAlign, lineHeight, padding, null, map);
                // Setting attributes passed in from attrs
                Object.keys(attrs).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                key => {
                    paragraph.setAttribute(key, attrs[key]);
                }));
                if (yOffset > 0) {
                    /** @type {?} */
                    const paragraphWrapper = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
                    SVGUtils.updateTranslate(0, yOffset, paragraphWrapper);
                    paragraphWrapper.appendChild(paragraph);
                    gParagraph.appendChild(paragraphWrapper);
                }
                else {
                    gParagraph.appendChild(paragraph);
                }
                /** @type {?} */
                const paragraphHeight = TextSvgRendererUtils.estimateHeight(paragraphLines.length, attrs['font-size'] ? parseInt(attrs['font-size'], 10) : CLASS_LIST['text-defaults']['font-size'], lineHeight);
                runningHeight += paragraphHeight;
                if (remainingHeight) {
                    remainingHeight -= paragraphHeight;
                }
                yOffset += paragraphHeight;
            }));
            return new ContentBox(gParagraph, actualWidth, runningHeight);
        }
        finally {
            phantomText.destroy();
        }
    }
    /**
     * @param {?} paragraph
     * @return {?}
     */
    static splitByParagraphs(paragraph) {
        /** @type {?} */
        const paragraphArray = [];
        // Split for <p></p> or <br>
        paragraph.split(/<\/p>|<br\/?>/gm).forEach((/**
         * @param {?} block
         * @return {?}
         */
        block => {
            /** @type {?} */
            const blockWithHTML = block.replace(/<\/?p>/g, '').replace(/&nbsp;/g, ' ');
            // removing b tags
            /** @type {?} */
            const parsedText = blockWithHTML.replace(/<\/?b>/g, '');
            paragraphArray.push({
                withoutHTML: parsedText,
                withHTML: blockWithHTML
            });
        }));
        return paragraphArray.filter((/**
         * @param {?} pMap
         * @return {?}
         */
        pMap => pMap.withoutHTML !== ''));
    }
    /**
     * @private
     * @param {?} stringWithHTML
     * @return {?}
     */
    static mapBoldWords(stringWithHTML) {
        /** @type {?} */
        const rangeArray = [];
        /** @type {?} */
        let pointer = 0;
        /** @type {?} */
        let virtualPointer = 0;
        /** @type {?} */
        let stringBuffer = stringWithHTML;
        while (stringBuffer.search('<b>') >= 0) {
            /** @type {?} */
            const pointerAtIterationStart = pointer;
            /** @type {?} */
            const oldPointer = virtualPointer;
            /** @type {?} */
            const start = stringBuffer.search('<b>') + oldPointer;
            pointer = stringBuffer.search('<b>') + pointer;
            if (stringBuffer.search('</b>') >= 0) {
                /** @type {?} */
                const end = stringBuffer.search('</b>') - 3 + oldPointer;
                pointer = pointer - start + end + 7;
                virtualPointer = end;
                rangeArray.push((/** @type {?} */ ({
                    start: start,
                    end: end
                })));
                stringBuffer = stringBuffer.substring(pointer - pointerAtIterationStart);
            }
        }
        return rangeArray;
    }
    /**
     * @private
     * @param {?} stringWithHTML
     * @return {?}
     */
    static getBoldWordsIndex(stringWithHTML) {
        /** @type {?} */
        let numOfTagsEncountered = 0;
        /** @type {?} */
        const boldWordsIndexes = [];
        // put a space between non-whitespace characters and tag beginning/end
        /** @type {?} */
        const withHTMLArray = stringWithHTML
            .replace(/[\S]<|>[\S]/g, (/**
         * @param {?} match
         * @return {?}
         */
        match => {
            return match.split('').join(' ');
        }))
            .split(/\s+/);
        /** @type {?} */
        let isInBoldTag = false;
        withHTMLArray.forEach((/**
         * @param {?} word
         * @param {?} index
         * @return {?}
         */
        (word, index) => {
            if (word === '<b>' || word === '<strong>') {
                numOfTagsEncountered += 1;
                isInBoldTag = true;
            }
            else if (word === '</b>' || word === '</strong>') {
                numOfTagsEncountered += 1;
                isInBoldTag = false;
            }
            else if (isInBoldTag) {
                boldWordsIndexes.push(index - numOfTagsEncountered);
            }
        }));
        return boldWordsIndexes;
    }
    /**
     * @private
     * @param {?} text
     * @return {?}
     */
    static stripUnsupportedHTMLTags(text) {
        // Match with any HTML tag except for b, strong, p, br
        /** @type {?} */
        const UNSUPPORTED_HTML_TAG_REGEX = /\<(?!b|\/b|strong|\/strong|br|\/br|p|\/p)[A-Za-z_/]+[A-Za-z0-9_/'"=\-,.;:# ]*\>/g;
        /** @type {?} */
        const strippedText = text
            .replace(UNSUPPORTED_HTML_TAG_REGEX, '')
            // replace strong to b, use regex to replace all
            .replace(/<strong>/g, '<b>')
            .replace(/<\/strong>/g, '</b>');
        return strippedText;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DomCalcElement {
    /**
     * @param {?} parent
     * @param {?} attrs
     */
    constructor(parent, attrs) {
        this.parent = parent;
        this.attrs = attrs;
        this.textElement = (/** @type {?} */ (document.createElementNS(SVG_NS, 'text')));
        SVGUtils.applyAttributes(this.textElement, attrs);
        parent.appendChild(this.textElement);
        this.size = Number.parseInt(this.attrs['font-size'], 10);
    }
    /**
     * @param {?} text
     * @return {?}
     */
    getHeight(text) {
        return this.size;
    }
    /**
     * @param {?} text
     * @return {?}
     */
    getWidth(text) {
        if (text === '') {
            return 0;
        }
        this.textElement.textContent = text;
        if (typeof this.textElement.getComputedTextLength !== 'undefined') {
            return this.textElement.getComputedTextLength();
        }
        return this.textElement.getBBox().width;
    }
}
/**
 * DomTextSizeStrategy is a TextSizeStrategy which uses DOM and bbox to calculate the text width,
 * whilst it is very accurate it is also very expensive to run and causes performance issues on IE.
 */
class DomTextSizeStrategy {
    constructor() {
        this.resolvers = new Map();
        this.svg = (/** @type {?} */ (document.createElementNS(SVG_NS, 'svg')));
        document.body.appendChild(this.svg);
        this.svg.setAttribute('style', 'visibility:hidden');
    }
    /**
     * @private
     * @param {?} attrs
     * @return {?}
     */
    getResolver(attrs) {
        /** @type {?} */
        const key = this.getAttrKey(attrs);
        if (!this.resolvers.has(key)) {
            this.resolvers.set(key, new DomCalcElement(this.svg, this.getFinalAttrs(attrs)));
        }
        return this.resolvers.get(key);
    }
    /**
     * @private
     * @param {?} attrs
     * @return {?}
     */
    getAttrKey(attrs) {
        /** @type {?} */
        const keys = Object.keys(attrs).sort();
        return keys.map((/**
         * @param {?} key
         * @return {?}
         */
        key => `${key}=${attrs[key]}`)).join(',');
    }
    /**
     * @private
     * @param {?} attrs
     * @return {?}
     */
    getFinalAttrs(attrs) {
        return Object.assign(Object.assign({}, CLASS_LIST['text-defaults']), attrs);
    }
    /**
     * @param {?} text
     * @param {?} attr
     * @return {?}
     */
    calculateWidth(text, attr) {
        /** @type {?} */
        const resolver = this.getResolver(attr);
        return resolver.getWidth(text);
    }
    /**
     * @param {?} text
     * @param {?} attr
     * @return {?}
     */
    calculateHeight(text, attr) {
        /** @type {?} */
        const resolver = this.getResolver(attr);
        return resolver.getHeight(text);
    }
    /**
     * @return {?}
     */
    destroy() {
        document.body.removeChild(this.svg);
        this.svg = null;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class HtmlTextElem {
    /**
     * @param {?=} attributes
     */
    constructor(attributes = {}) {
        this.attributes = attributes;
    }
}
class HtmlSpace extends HtmlTextElem {
    /**
     * @param {?} acc
     * @return {?}
     */
    write(acc) {
        throw new Error('Method not implemented.');
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getHeight(strategy) {
        return 8;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getWidth(strategy) {
        return strategy.calculateWidth(' ', this.attributes);
    }
}
class HtmlNewLine extends HtmlTextElem {
    /**
     * @param {?} acc
     * @return {?}
     */
    write(acc) {
        throw new Error('Method not implemented.');
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getHeight(strategy) {
        return 8;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getWidth(strategy) {
        return 0;
    }
}
class HtmlClassStart extends HtmlTextElem {
    /**
     * @param {?} clazz
     * @param {?=} attributes
     */
    constructor(clazz, attributes = {}) {
        super(attributes);
        this.clazz = clazz;
    }
    /**
     * @param {?} acc
     * @return {?}
     */
    write(acc) {
        throw new Error('Method not implemented.');
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getHeight(strategy) {
        return 0;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getWidth(strategy) {
        return 0;
    }
}
class HtmlClassEnd extends HtmlTextElem {
    /**
     * @param {?} clazz
     * @param {?=} attributes
     */
    constructor(clazz, attributes = {}) {
        super(attributes);
        this.clazz = clazz;
    }
    /**
     * @param {?} acc
     * @return {?}
     */
    write(acc) {
        throw new Error('Method not implemented.');
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getHeight(strategy) {
        return 0;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getWidth(strategy) {
        return 0;
    }
}
class HtmlWord extends HtmlTextElem {
    /**
     * @param {?} word
     * @param {?=} attributes
     */
    constructor(word, attributes = {}) {
        super(attributes);
        this.word = word;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getHeight(strategy) {
        return 8;
    }
    /**
     * @param {?} strategy
     * @return {?}
     */
    getWidth(strategy) {
        return strategy.calculateWidth(this.word, this.attributes);
    }
    /**
     * @param {?} acc
     * @return {?}
     */
    write(acc) {
        throw new Error('Method not implemented.');
    }
}
class HtmlTextParser {
    /**
     * @param {?} input
     * @param {?} attrs
     * @return {?}
     */
    parse(input, attrs) {
        /** @type {?} */
        const result = [];
        if (input) {
            input = input.replace(new RegExp('\\s+', 'g'), ' ');
            /** @type {?} */
            const parser = new DOMParser();
            /** @type {?} */
            const doc = parser.parseFromString(input, 'text/html');
            if (doc.hasChildNodes() && doc.childNodes[0].hasChildNodes() && doc.childNodes[0].childNodes[1].hasChildNodes()) {
                /** @type {?} */
                const nodes = doc.childNodes[0].childNodes[1].childNodes;
                Array.from(nodes).forEach((/**
                 * @param {?} node
                 * @return {?}
                 */
                node => {
                    result.push(...this.resolve(node, attrs));
                }));
            }
        }
        return result;
    }
    /**
     * @private
     * @param {?} node
     * @param {?} attributes
     * @return {?}
     */
    resolve(node, attributes) {
        /** @type {?} */
        const result = [];
        /** @type {?} */
        const newAttributes = Object.assign({}, attributes);
        switch (node.nodeType) {
            case Node.TEXT_NODE:
                /** @type {?} */
                const value = node.nodeValue;
                /** @type {?} */
                let start = 0;
                /** @type {?} */
                let word = value[0].match(/[^\s]/) !== null;
                for (let i = 0; i < value.length; i++) {
                    /** @type {?} */
                    const n = Boolean(value[i].match(/[^\s]/));
                    if (n !== word) {
                        if (n) {
                            result.push(new HtmlSpace(newAttributes));
                        }
                        else {
                            result.push(new HtmlWord(value.substr(start, i - start), newAttributes));
                        }
                        word = n;
                        start = i;
                    }
                }
                if (word) {
                    result.push(new HtmlWord(value.substr(start, value.length - start), newAttributes));
                }
                else {
                    result.push(new HtmlSpace(newAttributes));
                }
                break;
            case Node.ELEMENT_NODE:
                /** @type {?} */
                let clazz;
                /** @type {?} */
                const fontFamilyValue = get(attributes, 'font-family');
                if (fontFamilyValue && fontFamilyValue.includes('FortCondensed')) {
                    clazz = 'text-condensed-bold';
                }
                if (node.nodeName === 'STRONG' || node.nodeName === 'B') {
                    if (!clazz) {
                        clazz = 'text-bold';
                    }
                    Object.assign(newAttributes, CLASS_LIST[clazz]);
                    result.push(new HtmlClassStart(clazz, newAttributes));
                }
                if (node.nodeName === 'BR') {
                    result.push(new HtmlNewLine(newAttributes));
                }
                // can add a span element with up to one valid class from the CLASS_LIST
                if (node.nodeName === 'SPAN') {
                    if (node instanceof HTMLSpanElement) {
                        /** @type {?} */
                        const classList = node.classList;
                        /** @type {?} */
                        const classToApply = classList[0];
                        if (CLASS_LIST[classToApply]) {
                            clazz = classToApply;
                            Object.assign(newAttributes, CLASS_LIST[classToApply]);
                            result.push(new HtmlClassStart(clazz, newAttributes));
                        }
                    }
                }
                Array.from(node.childNodes).forEach((/**
                 * @param {?} node
                 * @return {?}
                 */
                node => {
                    result.push(...this.resolve(node, newAttributes));
                }));
                if (node.nodeName === 'STRONG' || node.nodeName === 'B') {
                    result.push(new HtmlClassEnd(clazz, newAttributes));
                }
                if (node.nodeName === 'P') {
                    result.push(new HtmlNewLine(newAttributes));
                }
                if (node.nodeName === 'SPAN') {
                    if (clazz) {
                        result.push(new HtmlClassEnd(clazz, newAttributes));
                    }
                }
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MultiCharMapCondensed = {
    "\"J": -0.9599990844726562,
    "\"T": 0.160003662109375,
    "\"V": 0.1999969482421875,
    "\"W": 0.23999786376953125,
    "\"Y": 0.12000274658203125,
    "\"Z": 0.1999969482421875,
    "\"g": -0.1999969482421875,
    "\"v": 0.12000274658203125,
    "\"w": 0.12000274658203125,
    "\"y": 0.0800018310546875,
    "&A": 0.1999969482421875,
    "&J": 0.23999786376953125,
    "&T": -0.31999969482421875,
    "&X": 0.1999969482421875,
    "&Y": -0.23999786376953125,
    "&Z": 0.1999969482421875,
    "&x": 0.12000274658203125,
    "&y": 0.0800018310546875,
    "'J": -0.9599990844726562,
    "'T": 0.160003662109375,
    "'V": 0.1999969482421875,
    "'W": 0.23999786376953125,
    "'Y": 0.12000274658203125,
    "'Z": 0.1999969482421875,
    "'g": -0.1999969482421875,
    "'v": 0.12000274658203125,
    "'w": 0.12000274658203125,
    "'y": 0.0800018310546875,
    "(A": 0.1999969482421875,
    "(J": 0.1999969482421875,
    "(T": 0.160003662109375,
    "(V": 0.12000274658203125,
    "(W": 0.12000274658203125,
    "(X": 0.12000274658203125,
    "(Y": 0.12000274658203125,
    "(a": -0.12000274658203125,
    "(j": 0.31999969482421875,
    "(u": -0.12000274658203125,
    "(x": 0.1999969482421875,
    "*A": -0.1999969482421875,
    "*J": -0.839996337890625,
    "*T": 0.1999969482421875,
    "*V": 0.1999969482421875,
    "*W": 0.1999969482421875,
    "*a": -0.12000274658203125,
    "*v": 0.12000274658203125,
    "*w": 0.12000274658203125,
    "*y": 0.0800018310546875,
    ",*": -0.12000274658203125,
    ",?": -0.23999786376953125,
    ",A": 0.1999969482421875,
    ",C": -0.23999786376953125,
    ",G": -0.23999786376953125,
    ",J": 0.1999969482421875,
    ",O": -0.23999786376953125,
    ",Q": -0.23999786376953125,
    ",T": -0.5999984741210938,
    ",U": -0.31999969482421875,
    ",V": -0.40000152587890625,
    ",W": -0.40000152587890625,
    ",X": 0.04000091552734375,
    ",Y": -0.6399993896484375,
    ",Z": 0.1999969482421875,
    ",\\": -0.279998779296875,
    ",f": -0.0800018310546875,
    ",j": 0.12000274658203125,
    ",s": 0.04000091552734375,
    ",t": -0.31999969482421875,
    ",u": -0.12000274658203125,
    ",v": -0.23999786376953125,
    ",w": -0.23999786376953125,
    ",y": -0.1999969482421875,
    ",z": 0.12000274658203125,
    "-X": -0.23999786376953125,
    "-Y": -0.31999969482421875,
    "-f": 0.12000274658203125,
    "-y": 0.0800018310546875,
    ".*": -0.12000274658203125,
    ".?": -0.23999786376953125,
    ".A": 0.1999969482421875,
    ".C": -0.23999786376953125,
    ".G": -0.23999786376953125,
    ".J": 0.1999969482421875,
    ".O": -0.23999786376953125,
    ".Q": -0.23999786376953125,
    ".T": -0.5999984741210938,
    ".U": -0.31999969482421875,
    ".V": -0.40000152587890625,
    ".W": -0.40000152587890625,
    ".X": 0.04000091552734375,
    ".Y": -0.6399993896484375,
    ".Z": 0.1999969482421875,
    ".\\": -0.279998779296875,
    ".f": -0.0800018310546875,
    ".j": 0.12000274658203125,
    ".s": 0.04000091552734375,
    ".t": -0.31999969482421875,
    ".u": -0.12000274658203125,
    ".v": -0.23999786376953125,
    ".w": -0.23999786376953125,
    ".y": -0.1999969482421875,
    ".z": 0.12000274658203125,
    "//": -0.9199981689453125,
    "/A": -0.44000244140625,
    "/J": -0.720001220703125,
    "/S": -0.04000091552734375,
    "/T": 0.31999969482421875,
    "/V": 0.1999969482421875,
    "/W": 0.1999969482421875,
    "/X": 0.1999969482421875,
    "/Y": 0.23999786376953125,
    "/Z": 0.12000274658203125,
    "/a": -0.44000244140625,
    "/c": -0.44000244140625,
    "/d": -0.44000244140625,
    "/e": -0.44000244140625,
    "/f": -0.12000274658203125,
    "/g": -0.31999969482421875,
    "/m": -0.44000244140625,
    "/n": -0.44000244140625,
    "/o": -0.44000244140625,
    "/p": -0.44000244140625,
    "/q": -0.44000244140625,
    "/r": -0.44000244140625,
    "/s": -0.44000244140625,
    "/t": -0.12000274658203125,
    "/u": -0.44000244140625,
    "/x": -0.1999969482421875,
    "/z": -0.23999786376953125,
    ":A": 0.1999969482421875,
    ":J": 0.1999969482421875,
    ":Y": -0.1999969482421875,
    ":Z": 0.1999969482421875,
    ":f": 0.12000274658203125,
    ":j": 0.23999786376953125,
    ":v": 0.12000274658203125,
    ":w": 0.12000274658203125,
    ":y": 0.12000274658203125,
    ":z": 0.0800018310546875,
    ";A": 0.1999969482421875,
    ";J": 0.1999969482421875,
    ";Y": -0.1999969482421875,
    ";Z": 0.1999969482421875,
    ";f": 0.12000274658203125,
    ";j": 0.23999786376953125,
    ";v": 0.12000274658203125,
    ";w": 0.12000274658203125,
    ";y": 0.12000274658203125,
    ";z": 0.0800018310546875,
    "?.": -0.23999786376953125,
    "@T": -0.31999969482421875,
    "@Y": -0.3600006103515625,
    "A)": 0.1999969482421875,
    "A*": -0.1999969482421875,
    "A,": 0.1999969482421875,
    "A.": 0.1999969482421875,
    "A/": 0.23999786376953125,
    "A:": 0.1999969482421875,
    "A;": 0.1999969482421875,
    "A?": -0.31999969482421875,
    "AA": 0.23999786376953125,
    "AC": -0.04000091552734375,
    "AG": -0.04000091552734375,
    "AJ": 0.23999786376953125,
    "AO": -0.04000091552734375,
    "AQ": -0.04000091552734375,
    "AS": 0.160003662109375,
    "AT": -0.31999969482421875,
    "AV": -0.1999969482421875,
    "AW": -0.0800018310546875,
    "AX": 0.160003662109375,
    "AY": -0.279998779296875,
    "AZ": 0.23999786376953125,
    "A\\": -0.48000335693359375,
    "A_": 0.40000152587890625,
    "Aa": 0.04000091552734375,
    "Ag": 0.04000091552734375,
    "Ai": 0.04000091552734375,
    "Aj": 0.04000091552734375,
    "As": 0.12000274658203125,
    "Au": 0.04000091552734375,
    "Ax": 0.12000274658203125,
    "Az": 0.12000274658203125,
    "B,": -0.1999969482421875,
    "B.": -0.1999969482421875,
    "B?": 0.04000091552734375,
    "B@": -0.1999969482421875,
    "BC": -0.04000091552734375,
    "BG": -0.04000091552734375,
    "BJ": -0.12000274658203125,
    "BO": -0.04000091552734375,
    "BQ": -0.04000091552734375,
    "BX": -0.04000091552734375,
    "BY": -0.160003662109375,
    "B\\": -0.1999969482421875,
    "B]": -0.12000274658203125,
    "B_": -0.160003662109375,
    "Ba": -0.04000091552734375,
    "Bu": -0.04000091552734375,
    "Bv": 0.04000091552734375,
    "Bw": 0.04000091552734375,
    "By": 0.04000091552734375,
    "C,": -0.04000091552734375,
    "C.": -0.04000091552734375,
    "C?": 0.12000274658203125,
    "CA": 0.0800018310546875,
    "CC": -0.160003662109375,
    "CG": -0.160003662109375,
    "CJ": -0.04000091552734375,
    "CO": -0.160003662109375,
    "CQ": -0.160003662109375,
    "CV": 0.04000091552734375,
    "CW": 0.04000091552734375,
    "CX": -0.12000274658203125,
    "CY": -0.0800018310546875,
    "CZ": 0.0800018310546875,
    "C_": 0.0800018310546875,
    "Cc": 0.04000091552734375,
    "Cd": 0.04000091552734375,
    "Ce": 0.04000091552734375,
    "Co": 0.04000091552734375,
    "Cq": 0.04000091552734375,
    "Cs": 0.0800018310546875,
    "D,": -0.23999786376953125,
    "D.": -0.23999786376953125,
    "DA": -0.04000091552734375,
    "DC": -0.0800018310546875,
    "DG": -0.0800018310546875,
    "DJ": -0.31999969482421875,
    "DO": -0.0800018310546875,
    "DQ": -0.0800018310546875,
    "DT": -0.12000274658203125,
    "DV": -0.04000091552734375,
    "DX": -0.12000274658203125,
    "DY": -0.160003662109375,
    "D\\": -0.1999969482421875,
    "D_": -0.23999786376953125,
    "Du": -0.04000091552734375,
    "Dv": 0.12000274658203125,
    "Dw": 0.12000274658203125,
    "Dx": -0.12000274658203125,
    "Dy": 0.12000274658203125,
    "E)": 0.0800018310546875,
    "E?": 0.04000091552734375,
    "EA": 0.1999969482421875,
    "EC": -0.12000274658203125,
    "EG": -0.12000274658203125,
    "EJ": 0.0800018310546875,
    "EO": -0.12000274658203125,
    "EQ": -0.12000274658203125,
    "ET": 0.04000091552734375,
    "EV": 0.0800018310546875,
    "EW": 0.0800018310546875,
    "EZ": 0.0800018310546875,
    "E]": 0.0800018310546875,
    "E_": 0.23999786376953125,
    "Ec": -0.0800018310546875,
    "Ed": -0.0800018310546875,
    "Ee": -0.0800018310546875,
    "Eo": -0.0800018310546875,
    "Ep": -0.04000091552734375,
    "Eq": -0.0800018310546875,
    "Et": -0.04000091552734375,
    "Eu": -0.12000274658203125,
    "Ey": -0.04000091552734375,
    "E}": 0.0800018310546875,
    "F\"": 0.23999786376953125,
    "F&": -0.0800018310546875,
    "F'": 0.23999786376953125,
    "F)": 0.0800018310546875,
    "F,": -0.48000335693359375,
    "F.": -0.48000335693359375,
    "F/": -0.48000335693359375,
    "F?": 0.23999786376953125,
    "FA": -0.160003662109375,
    "FJ": -0.6399993896484375,
    "FT": 0.1999969482421875,
    "FV": 0.1999969482421875,
    "FW": 0.1999969482421875,
    "FX": -0.04000091552734375,
    "FY": 0.12000274658203125,
    "FZ": 0.04000091552734375,
    "F\\": 0.1999969482421875,
    "F]": 0.12000274658203125,
    "F_": -0.31999969482421875,
    "Fa": -0.160003662109375,
    "Fc": -0.12000274658203125,
    "Fd": -0.12000274658203125,
    "Fe": -0.12000274658203125,
    "Fg": -0.04000091552734375,
    "Fm": -0.04000091552734375,
    "Fn": -0.04000091552734375,
    "Fo": -0.12000274658203125,
    "Fp": -0.04000091552734375,
    "Fq": -0.12000274658203125,
    "Fr": -0.04000091552734375,
    "Ft": 0.0800018310546875,
    "Fu": -0.0800018310546875,
    "Fv": 0.0800018310546875,
    "Fw": 0.0800018310546875,
    "Fx": -0.04000091552734375,
    "Fy": 0.0800018310546875,
    "Fz": -0.0800018310546875,
    "F}": 0.0800018310546875,
    "G?": -0.04000091552734375,
    "GA": 0.12000274658203125,
    "GS": 0.0800018310546875,
    "GT": -0.0800018310546875,
    "GY": -0.160003662109375,
    "G\\": -0.1999969482421875,
    "G_": 0.0800018310546875,
    "Gs": 0.12000274658203125,
    "G}": 0.04000091552734375,
    "J,": -0.23999786376953125,
    "J.": -0.31999969482421875,
    "JJ": -0.12000274658203125,
    "JX": -0.04000091552734375,
    "J_": -0.23999786376953125,
    "Jv": 0.04000091552734375,
    "Jw": 0.04000091552734375,
    "Jy": 0.04000091552734375,
    "K!": 0.04000091552734375,
    "K\"": 0.1999969482421875,
    "K'": 0.1999969482421875,
    "K)": 0.23999786376953125,
    "K,": 0.0800018310546875,
    "K-": -0.1999969482421875,
    "K.": 0.0800018310546875,
    "K/": 0.31999969482421875,
    "K:": 0.0800018310546875,
    "K;": 0.0800018310546875,
    "K?": 0.04000091552734375,
    "KA": 0.1999969482421875,
    "KC": -0.0800018310546875,
    "KG": -0.0800018310546875,
    "KJ": 0.1999969482421875,
    "KO": -0.0800018310546875,
    "KQ": -0.0800018310546875,
    "KT": 0.0800018310546875,
    "KU": -0.12000274658203125,
    "KV": 0.0800018310546875,
    "KW": 0.0800018310546875,
    "KX": 0.0800018310546875,
    "KZ": 0.160003662109375,
    "K]": 0.12000274658203125,
    "K_": 0.3600006103515625,
    "Kc": -0.0800018310546875,
    "Kd": -0.0800018310546875,
    "Ke": -0.0800018310546875,
    "Kf": -0.0800018310546875,
    "Ko": -0.0800018310546875,
    "Kq": -0.0800018310546875,
    "Kt": -0.0800018310546875,
    "Ku": -0.04000091552734375,
    "Kv": -0.12000274658203125,
    "Kw": -0.12000274658203125,
    "Kx": 0.0800018310546875,
    "Ky": -0.12000274658203125,
    "K}": 0.12000274658203125,
    "L\"": -0.6800003051757812,
    "L'": -0.6800003051757812,
    "L)": 0.12000274658203125,
    "L*": -0.839996337890625,
    "L-": -0.1999969482421875,
    "L/": 0.0800018310546875,
    "L?": -0.48000335693359375,
    "LA": 0.279998779296875,
    "LC": -0.279998779296875,
    "LG": -0.279998779296875,
    "LJ": 0.160003662109375,
    "LO": -0.279998779296875,
    "LQ": -0.279998779296875,
    "LS": -0.04000091552734375,
    "LT": -0.6800003051757812,
    "LU": -0.160003662109375,
    "LV": -0.55999755859375,
    "LW": -0.44000244140625,
    "LX": 0.0800018310546875,
    "LY": -0.8000030517578125,
    "LZ": 0.160003662109375,
    "L\\": -1.0800018310546875,
    "L_": 0.279998779296875,
    "La": -0.04000091552734375,
    "Lc": -0.04000091552734375,
    "Ld": -0.04000091552734375,
    "Le": -0.04000091552734375,
    "Lo": -0.04000091552734375,
    "Lq": -0.04000091552734375,
    "Ls": 0.0800018310546875,
    "Lt": -0.23999786376953125,
    "Lu": -0.12000274658203125,
    "Lv": -0.12000274658203125,
    "Lw": -0.12000274658203125,
    "Lx": 0.0800018310546875,
    "Ly": -0.160003662109375,
    "Lz": 0.04000091552734375,
    "L}": 0.12000274658203125,
    "O,": -0.23999786376953125,
    "O.": -0.23999786376953125,
    "OA": -0.04000091552734375,
    "OC": -0.0800018310546875,
    "OG": -0.0800018310546875,
    "OJ": -0.31999969482421875,
    "OO": -0.0800018310546875,
    "OQ": -0.0800018310546875,
    "OT": -0.12000274658203125,
    "OV": -0.04000091552734375,
    "OX": -0.12000274658203125,
    "OY": -0.160003662109375,
    "O\\": -0.1999969482421875,
    "O_": -0.23999786376953125,
    "Ou": -0.04000091552734375,
    "Ov": 0.12000274658203125,
    "Ow": 0.12000274658203125,
    "Ox": -0.12000274658203125,
    "Oy": 0.12000274658203125,
    "P&": -0.0800018310546875,
    "P)": -0.0800018310546875,
    "P*": 0.1999969482421875,
    "P,": -0.6399993896484375,
    "P.": -0.6399993896484375,
    "P/": -0.44000244140625,
    "P?": 0.12000274658203125,
    "P@": -0.12000274658203125,
    "PA": -0.279998779296875,
    "PJ": -0.9599990844726562,
    "PS": -0.04000091552734375,
    "PT": -0.04000091552734375,
    "PV": 0.0800018310546875,
    "PW": 0.0800018310546875,
    "PX": -0.3600006103515625,
    "PY": -0.0800018310546875,
    "PZ": -0.0800018310546875,
    "P]": -0.0800018310546875,
    "P_": -0.6800003051757812,
    "Pa": -0.160003662109375,
    "Pc": -0.160003662109375,
    "Pd": -0.160003662109375,
    "Pe": -0.160003662109375,
    "Pf": 0.0800018310546875,
    "Pg": -0.160003662109375,
    "Pm": -0.04000091552734375,
    "Pn": -0.04000091552734375,
    "Po": -0.160003662109375,
    "Pp": -0.04000091552734375,
    "Pq": -0.160003662109375,
    "Pr": -0.04000091552734375,
    "Ps": -0.04000091552734375,
    "Pt": 0.160003662109375,
    "Pu": -0.12000274658203125,
    "Pv": 0.1999969482421875,
    "Pw": 0.1999969482421875,
    "Py": 0.12000274658203125,
    "Pz": -0.04000091552734375,
    "P}": -0.0800018310546875,
    "Q,": -0.23999786376953125,
    "Q.": -0.23999786376953125,
    "QA": -0.04000091552734375,
    "QC": -0.0800018310546875,
    "QG": -0.0800018310546875,
    "QJ": -0.31999969482421875,
    "QO": -0.0800018310546875,
    "QQ": -0.0800018310546875,
    "QT": -0.12000274658203125,
    "QV": -0.04000091552734375,
    "QX": -0.12000274658203125,
    "QY": -0.160003662109375,
    "Q\\": -0.1999969482421875,
    "Q_": -0.23999786376953125,
    "Qu": -0.04000091552734375,
    "Qv": 0.12000274658203125,
    "Qw": 0.12000274658203125,
    "Qx": -0.12000274658203125,
    "Qy": 0.12000274658203125,
    "R)": 0.12000274658203125,
    "R*": 0.12000274658203125,
    "R?": 0.12000274658203125,
    "RA": 0.0800018310546875,
    "RY": -0.12000274658203125,
    "R_": 0.279998779296875,
    "Rc": -0.04000091552734375,
    "Rd": -0.04000091552734375,
    "Re": -0.04000091552734375,
    "Rg": -0.04000091552734375,
    "Ro": -0.04000091552734375,
    "Rq": -0.04000091552734375,
    "Rt": 0.12000274658203125,
    "Ru": -0.04000091552734375,
    "Rv": 0.160003662109375,
    "Rw": 0.160003662109375,
    "Ry": 0.12000274658203125,
    "S,": -0.04000091552734375,
    "S.": -0.04000091552734375,
    "SA": 0.04000091552734375,
    "SC": -0.04000091552734375,
    "SG": -0.04000091552734375,
    "SJ": -0.04000091552734375,
    "SO": -0.04000091552734375,
    "SQ": -0.04000091552734375,
    "ST": -0.12000274658203125,
    "SX": -0.04000091552734375,
    "SY": -0.12000274658203125,
    "S_": 0.0800018310546875,
    "Sa": -0.04000091552734375,
    "Sc": 0.04000091552734375,
    "Sd": 0.04000091552734375,
    "Se": 0.04000091552734375,
    "So": 0.04000091552734375,
    "Sq": 0.04000091552734375,
    "T\"": 0.23999786376953125,
    "T&": -0.0800018310546875,
    "T'": 0.23999786376953125,
    "T)": 0.160003662109375,
    "T*": 0.1999969482421875,
    "T,": -0.48000335693359375,
    "T.": -0.5999984741210938,
    "T/": -0.48000335693359375,
    "T?": 0.1999969482421875,
    "T@": -0.31999969482421875,
    "TA": -0.31999969482421875,
    "TC": -0.12000274658203125,
    "TG": -0.12000274658203125,
    "TJ": -0.720001220703125,
    "TO": -0.12000274658203125,
    "TQ": -0.12000274658203125,
    "TT": 0.23999786376953125,
    "TV": 0.23999786376953125,
    "TW": 0.23999786376953125,
    "TY": 0.160003662109375,
    "TZ": 0.04000091552734375,
    "T\\": 0.23999786376953125,
    "T]": 0.160003662109375,
    "T_": -0.31999969482421875,
    "Ta": -0.31999969482421875,
    "Tc": -0.3600006103515625,
    "Td": -0.3600006103515625,
    "Te": -0.3600006103515625,
    "Tf": -0.0800018310546875,
    "Tg": -0.31999969482421875,
    "Tm": -0.31999969482421875,
    "Tn": -0.31999969482421875,
    "To": -0.3600006103515625,
    "Tp": -0.31999969482421875,
    "Tq": -0.3600006103515625,
    "Tr": -0.31999969482421875,
    "Ts": -0.48000335693359375,
    "Tu": -0.40000152587890625,
    "Tv": -0.1999969482421875,
    "Tw": -0.1999969482421875,
    "Tx": -0.31999969482421875,
    "Ty": -0.1999969482421875,
    "Tz": -0.1999969482421875,
    "T}": 0.160003662109375,
    "U,": -0.23999786376953125,
    "U.": -0.31999969482421875,
    "UJ": -0.12000274658203125,
    "UX": -0.04000091552734375,
    "U_": -0.23999786376953125,
    "Uv": 0.04000091552734375,
    "Uw": 0.04000091552734375,
    "Uy": 0.04000091552734375,
    "V!": 0.04000091552734375,
    "V\"": 0.1999969482421875,
    "V'": 0.1999969482421875,
    "V)": 0.12000274658203125,
    "V*": 0.1999969482421875,
    "V,": -0.40000152587890625,
    "V.": -0.40000152587890625,
    "V/": -0.1999969482421875,
    "V?": 0.31999969482421875,
    "VA": -0.1999969482421875,
    "VC": -0.04000091552734375,
    "VG": -0.04000091552734375,
    "VJ": -0.3600006103515625,
    "VO": -0.04000091552734375,
    "VQ": -0.04000091552734375,
    "VS": 0.04000091552734375,
    "VT": 0.23999786376953125,
    "VV": 0.12000274658203125,
    "VW": 0.12000274658203125,
    "VX": -0.04000091552734375,
    "VY": 0.04000091552734375,
    "V\\": 0.23999786376953125,
    "V]": 0.12000274658203125,
    "V_": -0.23999786376953125,
    "Va": -0.0800018310546875,
    "Vc": -0.12000274658203125,
    "Vd": -0.12000274658203125,
    "Ve": -0.12000274658203125,
    "Vf": 0.160003662109375,
    "Vg": -0.04000091552734375,
    "Vm": -0.04000091552734375,
    "Vn": -0.04000091552734375,
    "Vo": -0.12000274658203125,
    "Vp": -0.04000091552734375,
    "Vq": -0.12000274658203125,
    "Vr": -0.04000091552734375,
    "Vs": -0.04000091552734375,
    "Vt": 0.12000274658203125,
    "Vu": -0.12000274658203125,
    "Vv": 0.23999786376953125,
    "Vw": 0.23999786376953125,
    "Vx": 0.12000274658203125,
    "Vy": 0.12000274658203125,
    "V}": 0.12000274658203125,
    "W!": 0.04000091552734375,
    "W\"": 0.23999786376953125,
    "W'": 0.23999786376953125,
    "W)": 0.12000274658203125,
    "W*": 0.1999969482421875,
    "W,": -0.3600006103515625,
    "W.": -0.40000152587890625,
    "W/": -0.1999969482421875,
    "W?": 0.31999969482421875,
    "WA": -0.0800018310546875,
    "WJ": -0.31999969482421875,
    "WS": 0.04000091552734375,
    "WT": 0.23999786376953125,
    "WV": 0.12000274658203125,
    "WW": 0.12000274658203125,
    "WX": -0.04000091552734375,
    "WY": 0.04000091552734375,
    "W\\": 0.23999786376953125,
    "W]": 0.12000274658203125,
    "W_": -0.23999786376953125,
    "Wa": -0.04000091552734375,
    "Wc": -0.12000274658203125,
    "Wd": -0.12000274658203125,
    "We": -0.12000274658203125,
    "Wf": 0.160003662109375,
    "Wg": -0.04000091552734375,
    "Wm": -0.04000091552734375,
    "Wn": -0.04000091552734375,
    "Wo": -0.12000274658203125,
    "Wp": -0.04000091552734375,
    "Wq": -0.12000274658203125,
    "Wr": -0.04000091552734375,
    "Wt": 0.160003662109375,
    "Wu": -0.04000091552734375,
    "Wv": 0.1999969482421875,
    "Ww": 0.1999969482421875,
    "Wx": 0.12000274658203125,
    "Wy": 0.1999969482421875,
    "W}": 0.12000274658203125,
    "X!": 0.04000091552734375,
    "X)": 0.12000274658203125,
    "X,": 0.04000091552734375,
    "X-": -0.23999786376953125,
    "X.": 0.04000091552734375,
    "X/": 0.1999969482421875,
    "X?": 0.04000091552734375,
    "XA": 0.160003662109375,
    "XC": -0.12000274658203125,
    "XG": -0.12000274658203125,
    "XJ": 0.12000274658203125,
    "XO": -0.12000274658203125,
    "XQ": -0.12000274658203125,
    "XU": -0.04000091552734375,
    "XV": -0.04000091552734375,
    "XW": -0.04000091552734375,
    "XY": -0.04000091552734375,
    "XZ": 0.0800018310546875,
    "X\\": 0.1999969482421875,
    "X]": 0.12000274658203125,
    "X_": 0.31999969482421875,
    "Xx": 0.04000091552734375,
    "X}": 0.12000274658203125,
    "Y\"": 0.12000274658203125,
    "Y&": -0.23999786376953125,
    "Y'": 0.12000274658203125,
    "Y)": 0.12000274658203125,
    "Y,": -0.6399993896484375,
    "Y-": -0.31999969482421875,
    "Y.": -0.6399993896484375,
    "Y/": -0.3600006103515625,
    "Y:": -0.1999969482421875,
    "Y;": -0.1999969482421875,
    "Y?": 0.1999969482421875,
    "Y@": -0.3600006103515625,
    "YA": -0.279998779296875,
    "YC": -0.160003662109375,
    "YG": -0.160003662109375,
    "YJ": -0.5999984741210938,
    "YO": -0.160003662109375,
    "YQ": -0.160003662109375,
    "YT": 0.160003662109375,
    "YV": 0.04000091552734375,
    "YW": 0.04000091552734375,
    "YX": -0.04000091552734375,
    "YY": 0.0800018310546875,
    "Y\\": 0.23999786376953125,
    "Y]": 0.12000274658203125,
    "Y_": -0.720001220703125,
    "Ya": -0.48000335693359375,
    "Yb": -0.04000091552734375,
    "Yc": -0.44000244140625,
    "Yd": -0.44000244140625,
    "Ye": -0.44000244140625,
    "Yf": -0.12000274658203125,
    "Yg": -0.40000152587890625,
    "Yh": -0.04000091552734375,
    "Yi": -0.0800018310546875,
    "Yj": -0.0800018310546875,
    "Yk": -0.04000091552734375,
    "Yl": -0.04000091552734375,
    "Ym": -0.3600006103515625,
    "Yn": -0.3600006103515625,
    "Yo": -0.44000244140625,
    "Yp": -0.3600006103515625,
    "Yq": -0.44000244140625,
    "Yr": -0.3600006103515625,
    "Ys": -0.3600006103515625,
    "Yt": -0.0800018310546875,
    "Yu": -0.3600006103515625,
    "Yv": -0.0800018310546875,
    "Yw": -0.0800018310546875,
    "Yx": -0.160003662109375,
    "Yy": -0.12000274658203125,
    "Yz": -0.23999786376953125,
    "Y}": 0.12000274658203125,
    "Z\"": 0.1999969482421875,
    "Z'": 0.1999969482421875,
    "Z)": 0.12000274658203125,
    "Z*": 0.1999969482421875,
    "Z,": 0.1999969482421875,
    "Z.": 0.1999969482421875,
    "Z/": 0.23999786376953125,
    "Z:": 0.1999969482421875,
    "Z;": 0.1999969482421875,
    "Z?": 0.23999786376953125,
    "ZA": 0.23999786376953125,
    "ZJ": 0.160003662109375,
    "ZS": 0.0800018310546875,
    "ZT": 0.160003662109375,
    "ZV": 0.160003662109375,
    "ZW": 0.160003662109375,
    "ZX": 0.0800018310546875,
    "ZY": 0.160003662109375,
    "ZZ": 0.12000274658203125,
    "Z\\": 0.23999786376953125,
    "Z]": 0.12000274658203125,
    "Z_": 0.3600006103515625,
    "Za": 0.0800018310546875,
    "Zf": 0.0800018310546875,
    "Zu": -0.04000091552734375,
    "Zx": 0.1999969482421875,
    "Zz": 0.12000274658203125,
    "Z}": 0.23999786376953125,
    "[J": 0.12000274658203125,
    "[T": 0.160003662109375,
    "[V": 0.12000274658203125,
    "[W": 0.12000274658203125,
    "[X": 0.12000274658203125,
    "[Y": 0.12000274658203125,
    "[a": -0.12000274658203125,
    "[j": 0.3600006103515625,
    "[u": -0.12000274658203125,
    "[x": 0.12000274658203125,
    "\\A": 0.31999969482421875,
    "\\C": -0.1999969482421875,
    "\\G": -0.1999969482421875,
    "\\J": 0.31999969482421875,
    "\\O": -0.1999969482421875,
    "\\Q": -0.1999969482421875,
    "\\T": -0.48000335693359375,
    "\\V": -0.23999786376953125,
    "\\W": -0.23999786376953125,
    "\\X": 0.1999969482421875,
    "\\Y": -0.44000244140625,
    "\\Z": 0.23999786376953125,
    "\\f": -0.1999969482421875,
    "\\j": 0.31999969482421875,
    "\\u": -0.0800018310546875,
    "\\x": 0.1999969482421875,
    "\\z": 0.1999969482421875,
    "_A": 0.40000152587890625,
    "_C": -0.23999786376953125,
    "_G": -0.23999786376953125,
    "_J": 0.31999969482421875,
    "_O": -0.23999786376953125,
    "_Q": -0.23999786376953125,
    "_S": 0.0800018310546875,
    "_T": -0.31999969482421875,
    "_U": -0.23999786376953125,
    "_V": -0.23999786376953125,
    "_W": -0.23999786376953125,
    "_X": 0.31999969482421875,
    "_Y": -0.720001220703125,
    "_Z": 0.3600006103515625,
    "_g": 0.12000274658203125,
    "_j": 0.48000335693359375,
    "_p": 0.12000274658203125,
    "_t": -0.23999786376953125,
    "_u": -0.1999969482421875,
    "_x": 0.31999969482421875,
    "_y": 0.12000274658203125,
    "_z": 0.1999969482421875,
    "a\"": -0.12000274658203125,
    "a'": -0.12000274658203125,
    "a?": -0.3600006103515625,
    "a\\": -0.5999984741210938,
    "b?": -0.279998779296875,
    "b\\": -0.44000244140625,
    "bc": -0.04000091552734375,
    "bd": -0.04000091552734375,
    "be": -0.04000091552734375,
    "bo": -0.04000091552734375,
    "bq": -0.04000091552734375,
    "bx": -0.0800018310546875,
    "bz": -0.0800018310546875,
    "c?": -0.1999969482421875,
    "c\\": -0.1999969482421875,
    "ca": -0.04000091552734375,
    "cs": 0.04000091552734375,
    "cx": -0.0800018310546875,
    "e?": -0.31999969482421875,
    "e\\": -0.3600006103515625,
    "ea": -0.04000091552734375,
    "es": 0.04000091552734375,
    "ex": -0.0800018310546875,
    "f!": 0.1999969482421875,
    "f\"": 0.1999969482421875,
    "f'": 0.1999969482421875,
    "f)": 0.23999786376953125,
    "f*": 0.1999969482421875,
    "f,": -0.40000152587890625,
    "f-": 0.12000274658203125,
    "f.": -0.40000152587890625,
    "f/": -0.31999969482421875,
    "f:": 0.12000274658203125,
    "f;": 0.12000274658203125,
    "f?": 0.279998779296875,
    "f\\": 0.23999786376953125,
    "f]": 0.1999969482421875,
    "f_": -0.12000274658203125,
    "fa": -0.04000091552734375,
    "fc": -0.12000274658203125,
    "fd": -0.12000274658203125,
    "fe": -0.12000274658203125,
    "ff": 0.04000091552734375,
    "fg": -0.12000274658203125,
    "fi": -0.0319976806640625,
    "fl": -0.04000091552734375,
    "fo": -0.12000274658203125,
    "fq": -0.12000274658203125,
    "fs": -0.04000091552734375,
    "ft": 0.12000274658203125,
    "fu": -0.12000274658203125,
    "fv": 0.12000274658203125,
    "fw": 0.12000274658203125,
    "fx": 0.04000091552734375,
    "fy": 0.12000274658203125,
    "f}": 0.1999969482421875,
    "gj": 0.0800018310546875,
    "h\"": -0.12000274658203125,
    "h'": -0.12000274658203125,
    "h?": -0.3600006103515625,
    "h\\": -0.5999984741210938,
    "jj": 0.0800018310546875,
    "k)": 0.1999969482421875,
    "k*": 0.12000274658203125,
    "k/": 0.1999969482421875,
    "k\\": -0.1999969482421875,
    "k]": 0.1999969482421875,
    "k_": 0.3600006103515625,
    "ka": -0.04000091552734375,
    "kc": -0.12000274658203125,
    "kd": -0.12000274658203125,
    "ke": -0.12000274658203125,
    "kf": -0.04000091552734375,
    "kg": -0.160003662109375,
    "ko": -0.12000274658203125,
    "kq": -0.12000274658203125,
    "ks": -0.04000091552734375,
    "kt": 0.04000091552734375,
    "ku": -0.12000274658203125,
    "kv": 0.0800018310546875,
    "kw": 0.0800018310546875,
    "kx": 0.0800018310546875,
    "ky": 0.12000274658203125,
    "k}": 0.1999969482421875,
    "m\"": -0.12000274658203125,
    "m'": -0.12000274658203125,
    "m?": -0.3600006103515625,
    "m\\": -0.5999984741210938,
    "n\"": -0.12000274658203125,
    "n'": -0.12000274658203125,
    "n?": -0.3600006103515625,
    "n\\": -0.5999984741210938,
    "o?": -0.279998779296875,
    "o\\": -0.44000244140625,
    "oc": -0.04000091552734375,
    "od": -0.04000091552734375,
    "oe": -0.04000091552734375,
    "oo": -0.04000091552734375,
    "oq": -0.04000091552734375,
    "ox": -0.0800018310546875,
    "oz": -0.0800018310546875,
    "p?": -0.279998779296875,
    "p\\": -0.44000244140625,
    "pc": -0.04000091552734375,
    "pd": -0.04000091552734375,
    "pe": -0.04000091552734375,
    "po": -0.04000091552734375,
    "pq": -0.04000091552734375,
    "px": -0.0800018310546875,
    "pz": -0.0800018310546875,
    "qj": 0.12000274658203125,
    "r!": 0.0800018310546875,
    "r\"": 0.279998779296875,
    "r&": 0.0800018310546875,
    "r'": 0.279998779296875,
    "r*": 0.279998779296875,
    "r,": -0.31999969482421875,
    "r-": 0.0800018310546875,
    "r.": -0.31999969482421875,
    "r/": -0.279998779296875,
    "r:": 0.0800018310546875,
    "r;": 0.0800018310546875,
    "r?": 0.12000274658203125,
    "r\\": -0.160003662109375,
    "r_": -0.23999786376953125,
    "rc": -0.04000091552734375,
    "rd": -0.04000091552734375,
    "re": -0.04000091552734375,
    "rf": 0.12000274658203125,
    "rg": -0.04000091552734375,
    "ro": -0.04000091552734375,
    "rq": -0.04000091552734375,
    "rt": 0.160003662109375,
    "rv": 0.23999786376953125,
    "rw": 0.23999786376953125,
    "rx": 0.12000274658203125,
    "ry": 0.23999786376953125,
    "rz": 0.12000274658203125,
    "s?": -0.23999786376953125,
    "s\\": -0.48000335693359375,
    "sf": -0.04000091552734375,
    "ss": -0.0800018310546875,
    "st": -0.04000091552734375,
    "su": -0.04000091552734375,
    "sv": -0.04000091552734375,
    "sw": -0.04000091552734375,
    "sx": -0.04000091552734375,
    "sz": -0.04000091552734375,
    "t!": 0.12000274658203125,
    "t)": 0.23999786376953125,
    "t,": 0.0800018310546875,
    "t.": 0.0800018310546875,
    "t/": 0.1999969482421875,
    "t:": 0.0800018310546875,
    "t;": 0.0800018310546875,
    "t?": -0.04000091552734375,
    "t\\": -0.23999786376953125,
    "t]": 0.1999969482421875,
    "t_": 0.3600006103515625,
    "tf": -0.04000091552734375,
    "tt": 0.04000091552734375,
    "tv": 0.12000274658203125,
    "tw": 0.12000274658203125,
    "ty": 0.12000274658203125,
    "tz": 0.04000091552734375,
    "t}": 0.1999969482421875,
    "u?": -0.279998779296875,
    "u\\": -0.44000244140625,
    "v!": 0.160003662109375,
    "v\"": 0.12000274658203125,
    "v'": 0.12000274658203125,
    "v*": 0.12000274658203125,
    "v,": -0.23999786376953125,
    "v.": -0.23999786376953125,
    "v:": 0.12000274658203125,
    "v;": 0.12000274658203125,
    "v?": 0.04000091552734375,
    "v\\": -0.12000274658203125,
    "vf": 0.0800018310546875,
    "vt": 0.160003662109375,
    "vv": 0.160003662109375,
    "vw": 0.160003662109375,
    "vx": 0.04000091552734375,
    "vy": 0.160003662109375,
    "w!": 0.160003662109375,
    "w\"": 0.12000274658203125,
    "w'": 0.12000274658203125,
    "w*": 0.12000274658203125,
    "w,": -0.23999786376953125,
    "w.": -0.23999786376953125,
    "w:": 0.12000274658203125,
    "w;": 0.12000274658203125,
    "w?": 0.04000091552734375,
    "w\\": -0.12000274658203125,
    "wf": 0.0800018310546875,
    "wt": 0.160003662109375,
    "wv": 0.160003662109375,
    "ww": 0.160003662109375,
    "wx": 0.04000091552734375,
    "wy": 0.160003662109375,
    "x!": 0.04000091552734375,
    "x)": 0.1999969482421875,
    "x/": 0.23999786376953125,
    "x\\": -0.23999786376953125,
    "x]": 0.12000274658203125,
    "x_": 0.31999969482421875,
    "xa": -0.04000091552734375,
    "xc": -0.0800018310546875,
    "xd": -0.0800018310546875,
    "xe": -0.0800018310546875,
    "xf": -0.04000091552734375,
    "xg": -0.0800018310546875,
    "xo": -0.0800018310546875,
    "xq": -0.0800018310546875,
    "xu": -0.12000274658203125,
    "xv": 0.04000091552734375,
    "xw": 0.04000091552734375,
    "xx": 0.0800018310546875,
    "xy": 0.12000274658203125,
    "x}": 0.1999969482421875,
    "y!": 0.160003662109375,
    "y\"": 0.12000274658203125,
    "y'": 0.12000274658203125,
    "y*": 0.12000274658203125,
    "y,": -0.23999786376953125,
    "y.": -0.23999786376953125,
    "y:": 0.12000274658203125,
    "y;": 0.12000274658203125,
    "y?": 0.04000091552734375,
    "y\\": -0.12000274658203125,
    "yf": 0.0800018310546875,
    "yt": 0.160003662109375,
    "yv": 0.160003662109375,
    "yw": 0.160003662109375,
    "yx": 0.04000091552734375,
    "yy": 0.160003662109375,
    "z/": 0.12000274658203125,
    "z\\": -0.31999969482421875,
    "z_": 0.1999969482421875,
    "za": -0.04000091552734375,
    "zc": -0.12000274658203125,
    "zd": -0.12000274658203125,
    "ze": -0.12000274658203125,
    "zg": -0.04000091552734375,
    "zo": -0.12000274658203125,
    "zq": -0.12000274658203125,
    "zv": 0.04000091552734375,
    "zw": 0.04000091552734375,
    "zy": 0.0800018310546875,
    "zz": -0.04000091552734375,
    "{J": 0.12000274658203125,
    "{T": 0.160003662109375,
    "{V": 0.12000274658203125,
    "{W": 0.12000274658203125,
    "{X": 0.12000274658203125,
    "{Y": 0.12000274658203125,
    "{Z": 0.12000274658203125,
    "{a": -0.12000274658203125,
    "{j": 0.31999969482421875,
    "{u": -0.12000274658203125,
    "{x": 0.1999969482421875
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MultiCharMapRegular = {
    " !": 2.220446049250313e-16,
    " '": 2.220446049250313e-16,
    " ,": 2.220446049250313e-16,
    " .": 2.220446049250313e-16,
    " :": 2.220446049250313e-16,
    " ;": 2.220446049250313e-16,
    " @": -8.881784197001252e-16,
    " H": -8.881784197001252e-16,
    " M": -8.881784197001252e-16,
    " N": -8.881784197001252e-16,
    " O": -8.881784197001252e-16,
    " Q": -8.881784197001252e-16,
    " W": -8.881784197001252e-16,
    " m": -8.881784197001252e-16,
    "! ": 2.220446049250313e-16,
    "\" ": 2.220446049250313e-16,
    "\"J": -1.279998779296875,
    "\"T": 0.31999969482421875,
    "\"V": 0.31999969482421875,
    "\"W": 0.31999969482421875,
    "\"Y": 0.160003662109375,
    "\"Z": 0.23999786376953125,
    "\"g": -0.23999786376953125,
    "\"v": 0.160003662109375,
    "\"w": 0.160003662109375,
    "# ": 2.220446049250313e-16,
    "$ ": 2.220446049250313e-16,
    "% ": -6.661338147750939e-16,
    "& ": 2.220446049250313e-16,
    "&A": 0.23999786376953125,
    "&J": 0.40000152587890625,
    "&T": -0.31999969482421875,
    "&X": 0.23999786376953125,
    "&Y": -0.31999969482421875,
    "&Z": 0.23999786376953125,
    "&x": 0.160003662109375,
    "' ": 2.220446049250313e-16,
    "'J": -1.279998779296875,
    "'T": 0.31999969482421875,
    "'V": 0.31999969482421875,
    "'W": 0.31999969482421875,
    "'Y": 0.160003662109375,
    "'Z": 0.23999786376953125,
    "'g": -0.23999786376953125,
    "'v": 0.160003662109375,
    "'w": 0.160003662109375,
    "( ": 2.220446049250313e-16,
    "(A": 0.23999786376953125,
    "(J": 0.23999786376953125,
    "(T": 0.31999969482421875,
    "(V": 0.160003662109375,
    "(W": 0.160003662109375,
    "(X": 0.160003662109375,
    "(Y": 0.160003662109375,
    "(a": -0.160003662109375,
    "(j": 0.40000152587890625,
    "(u": -0.160003662109375,
    "(x": 0.23999786376953125,
    ") ": 2.220446049250313e-16,
    "* ": 2.220446049250313e-16,
    "*A": -0.23999786376953125,
    "*J": -1.1200027465820312,
    "*T": 0.23999786376953125,
    "*V": 0.23999786376953125,
    "*W": 0.23999786376953125,
    "*a": -0.160003662109375,
    "*v": 0.160003662109375,
    "*w": 0.160003662109375,
    "+ ": 2.220446049250313e-16,
    ", ": 2.220446049250313e-16,
    ",A": 0.23999786376953125,
    ",C": -0.23999786376953125,
    ",G": -0.23999786376953125,
    ",J": 0.23999786376953125,
    ",O": -0.23999786376953125,
    ",Q": -0.23999786376953125,
    ",T": -0.6399993896484375,
    ",U": -0.23999786376953125,
    ",V": -0.40000152587890625,
    ",W": -0.40000152587890625,
    ",Y": -0.6399993896484375,
    ",Z": 0.23999786376953125,
    ",j": 0.160003662109375,
    ",t": -0.40000152587890625,
    ",u": -0.160003662109375,
    ",v": -0.31999969482421875,
    ",w": -0.31999969482421875,
    ",y": -0.23999786376953125,
    ",z": 0.160003662109375,
    "- ": 2.220446049250313e-16,
    "-X": -0.31999969482421875,
    "-Y": -0.40000152587890625,
    "-f": 0.160003662109375,
    "-v": 0.160003662109375,
    "-w": 0.160003662109375,
    ". ": 2.220446049250313e-16,
    ".A": 0.23999786376953125,
    ".C": -0.23999786376953125,
    ".G": -0.23999786376953125,
    ".J": 0.23999786376953125,
    ".O": -0.23999786376953125,
    ".Q": -0.23999786376953125,
    ".T": -0.6399993896484375,
    ".U": -0.23999786376953125,
    ".V": -0.40000152587890625,
    ".W": -0.40000152587890625,
    ".Y": -0.6399993896484375,
    ".Z": 0.23999786376953125,
    ".j": 0.160003662109375,
    ".t": -0.40000152587890625,
    ".u": -0.160003662109375,
    ".v": -0.31999969482421875,
    ".w": -0.31999969482421875,
    ".y": -0.23999786376953125,
    ".z": 0.160003662109375,
    "/ ": 2.220446049250313e-16,
    "/A": -0.55999755859375,
    "/J": -0.9599990844726562,
    "/T": 0.40000152587890625,
    "/V": 0.23999786376953125,
    "/W": 0.23999786376953125,
    "/X": 0.23999786376953125,
    "/Y": 0.31999969482421875,
    "/Z": 0.160003662109375,
    "/a": -0.55999755859375,
    "/c": -0.55999755859375,
    "/d": -0.55999755859375,
    "/e": -0.55999755859375,
    "/f": -0.160003662109375,
    "/g": -0.40000152587890625,
    "/m": -0.55999755859375,
    "/n": -0.55999755859375,
    "/o": -0.55999755859375,
    "/p": -0.55999755859375,
    "/q": -0.55999755859375,
    "/r": -0.55999755859375,
    "/s": -0.55999755859375,
    "/t": -0.160003662109375,
    "/u": -0.55999755859375,
    "/x": -0.23999786376953125,
    "/z": -0.31999969482421875,
    "0 ": 2.220446049250313e-16,
    "1 ": 2.220446049250313e-16,
    "2 ": 2.220446049250313e-16,
    "3 ": 2.220446049250313e-16,
    "4 ": 2.220446049250313e-16,
    "5 ": 2.220446049250313e-16,
    "6 ": 2.220446049250313e-16,
    "7 ": 2.220446049250313e-16,
    "8 ": 2.220446049250313e-16,
    "9 ": 2.220446049250313e-16,
    ": ": 2.220446049250313e-16,
    ":A": 0.23999786376953125,
    ":J": 0.23999786376953125,
    ":Y": -0.23999786376953125,
    ":Z": 0.23999786376953125,
    ":f": 0.160003662109375,
    ":j": 0.31999969482421875,
    ":v": 0.160003662109375,
    ":w": 0.160003662109375,
    ":y": 0.160003662109375,
    ":z": 0.0800018310546875,
    "; ": 2.220446049250313e-16,
    ";A": 0.23999786376953125,
    ";J": 0.23999786376953125,
    ";Y": -0.23999786376953125,
    ";Z": 0.23999786376953125,
    ";f": 0.160003662109375,
    ";j": 0.31999969482421875,
    ";v": 0.160003662109375,
    ";w": 0.160003662109375,
    ";y": 0.160003662109375,
    ";z": 0.0800018310546875,
    "< ": 2.220446049250313e-16,
    "= ": 2.220446049250313e-16,
    "> ": 2.220446049250313e-16,
    "? ": 2.220446049250313e-16,
    "@ ": -6.661338147750939e-16,
    "@T": -0.40000152587890625,
    "@Y": -0.48000335693359375,
    "A ": 2.220446049250313e-16,
    "A)": 0.23999786376953125,
    "A*": -0.23999786376953125,
    "A,": 0.23999786376953125,
    "A.": 0.23999786376953125,
    "A/": 0.31999969482421875,
    "A:": 0.23999786376953125,
    "A;": 0.23999786376953125,
    "A?": -0.40000152587890625,
    "AA": 0.31999969482421875,
    "AJ": 0.31999969482421875,
    "AS": 0.160003662109375,
    "AT": -0.23999786376953125,
    "AV": -0.23999786376953125,
    "AW": -0.0800018310546875,
    "AX": 0.23999786376953125,
    "AY": -0.23999786376953125,
    "AZ": 0.31999969482421875,
    "A\\": -0.6399993896484375,
    "A_": 0.40000152587890625,
    "Ax": 0.160003662109375,
    "Az": 0.160003662109375,
    "B ": 2.220446049250313e-16,
    "B,": -0.23999786376953125,
    "B.": -0.23999786376953125,
    "B?": -0.160003662109375,
    "B@": -0.23999786376953125,
    "BJ": -0.160003662109375,
    "BY": -0.23999786376953125,
    "B\\": -0.23999786376953125,
    "B]": -0.160003662109375,
    "B_": -0.31999969482421875,
    "Ba": -0.0800018310546875,
    "Bs": -0.160003662109375,
    "C ": 2.220446049250313e-16,
    "CA": 0.160003662109375,
    "CC": -0.160003662109375,
    "CG": -0.160003662109375,
    "CO": -0.160003662109375,
    "CQ": -0.160003662109375,
    "CT": 0.160003662109375,
    "CZ": 0.160003662109375,
    "D ": 2.220446049250313e-16,
    "D)": -0.160003662109375,
    "D,": -0.23999786376953125,
    "D.": -0.23999786376953125,
    "D/": -0.23999786376953125,
    "D?": -0.23999786376953125,
    "DJ": -0.31999969482421875,
    "DX": -0.160003662109375,
    "DY": -0.23999786376953125,
    "D\\": -0.31999969482421875,
    "D]": -0.160003662109375,
    "D_": -0.31999969482421875,
    "Ds": -0.160003662109375,
    "D}": -0.160003662109375,
    "E ": 2.220446049250313e-16,
    "E)": 0.160003662109375,
    "EA": 0.31999969482421875,
    "EJ": 0.160003662109375,
    "EV": 0.160003662109375,
    "EW": 0.160003662109375,
    "EZ": 0.160003662109375,
    "E]": 0.160003662109375,
    "E_": 0.31999969482421875,
    "Ea": 0.0800018310546875,
    "E}": 0.160003662109375,
    "F ": 2.220446049250313e-16,
    "F\"": 0.31999969482421875,
    "F'": 0.31999969482421875,
    "F)": 0.160003662109375,
    "F,": -0.6399993896484375,
    "F.": -0.6399993896484375,
    "F/": -0.6399993896484375,
    "F?": 0.23999786376953125,
    "FA": -0.160003662109375,
    "FC": 0.160003662109375,
    "FG": 0.160003662109375,
    "FJ": -0.6399993896484375,
    "FO": 0.160003662109375,
    "FQ": 0.160003662109375,
    "FT": 0.31999969482421875,
    "FV": 0.23999786376953125,
    "FW": 0.23999786376953125,
    "FY": 0.160003662109375,
    "F\\": 0.23999786376953125,
    "F]": 0.23999786376953125,
    "F_": -0.40000152587890625,
    "Fa": -0.160003662109375,
    "Fc": -0.160003662109375,
    "Fd": -0.160003662109375,
    "Fe": -0.160003662109375,
    "Fm": -0.23999786376953125,
    "Fn": -0.23999786376953125,
    "Fo": -0.160003662109375,
    "Fp": -0.160003662109375,
    "Fq": -0.160003662109375,
    "Fr": -0.23999786376953125,
    "Fs": -0.160003662109375,
    "Ft": 0.160003662109375,
    "Fu": -0.160003662109375,
    "Fv": 0.160003662109375,
    "Fw": 0.160003662109375,
    "Fy": 0.160003662109375,
    "F}": 0.160003662109375,
    "G ": 2.220446049250313e-16,
    "G?": -0.23999786376953125,
    "GA": 0.160003662109375,
    "GY": -0.160003662109375,
    "G\\": -0.23999786376953125,
    "H ": -6.661338147750939e-16,
    "I ": 2.220446049250313e-16,
    "J ": 2.220446049250313e-16,
    "J,": -0.23999786376953125,
    "J.": -0.23999786376953125,
    "J_": -0.31999969482421875,
    "K ": 2.220446049250313e-16,
    "K\"": 0.23999786376953125,
    "K'": 0.23999786376953125,
    "K)": 0.31999969482421875,
    "K-": -0.23999786376953125,
    "K/": 0.40000152587890625,
    "KA": 0.31999969482421875,
    "KJ": 0.31999969482421875,
    "KT": 0.160003662109375,
    "KU": -0.160003662109375,
    "KV": 0.160003662109375,
    "KW": 0.160003662109375,
    "KX": 0.160003662109375,
    "KY": 0.0800018310546875,
    "KZ": 0.23999786376953125,
    "K]": 0.160003662109375,
    "K_": 0.48000335693359375,
    "Kc": -0.0800018310546875,
    "Kd": -0.0800018310546875,
    "Ke": -0.0800018310546875,
    "Ko": -0.0800018310546875,
    "Kq": -0.0800018310546875,
    "Kt": -0.160003662109375,
    "Kv": -0.160003662109375,
    "Kw": -0.160003662109375,
    "Kx": 0.160003662109375,
    "Ky": -0.160003662109375,
    "K}": 0.160003662109375,
    "L ": 2.220446049250313e-16,
    "L\"": -0.8799972534179688,
    "L'": -0.8799972534179688,
    "L)": 0.160003662109375,
    "L*": -1.1200027465820312,
    "L-": -0.23999786376953125,
    "L?": -0.55999755859375,
    "LA": 0.40000152587890625,
    "LC": -0.23999786376953125,
    "LG": -0.23999786376953125,
    "LJ": 0.23999786376953125,
    "LO": -0.23999786376953125,
    "LQ": -0.23999786376953125,
    "LT": -0.6399993896484375,
    "LU": -0.160003662109375,
    "LV": -0.48000335693359375,
    "LW": -0.48000335693359375,
    "LY": -0.720001220703125,
    "LZ": 0.160003662109375,
    "L\\": -1.44000244140625,
    "L_": 0.23999786376953125,
    "Lt": -0.160003662109375,
    "Lv": -0.160003662109375,
    "Lw": -0.160003662109375,
    "Lx": 0.160003662109375,
    "Ly": -0.160003662109375,
    "L}": 0.160003662109375,
    "M ": -6.661338147750939e-16,
    "N ": -6.661338147750939e-16,
    "O ": -6.661338147750939e-16,
    "O,": -0.23999786376953125,
    "O.": -0.23999786376953125,
    "OY": -0.160003662109375,
    "O\\": -0.23999786376953125,
    "O_": -0.31999969482421875,
    "Os": -0.160003662109375,
    "Ou": -0.160003662109375,
    "Ox": -0.160003662109375,
    "P ": 2.220446049250313e-16,
    "P*": 0.23999786376953125,
    "P,": -0.6399993896484375,
    "P.": -0.6399993896484375,
    "P/": -0.48000335693359375,
    "PA": -0.23999786376953125,
    "PJ": -0.6399993896484375,
    "PV": 0.160003662109375,
    "PW": 0.160003662109375,
    "PX": -0.31999969482421875,
    "P_": -0.6399993896484375,
    "Pa": -0.160003662109375,
    "Pc": -0.160003662109375,
    "Pd": -0.160003662109375,
    "Pe": -0.160003662109375,
    "Pf": 0.160003662109375,
    "Pg": -0.160003662109375,
    "Pi": -0.160003662109375,
    "Pj": -0.160003662109375,
    "Pm": -0.160003662109375,
    "Pn": -0.160003662109375,
    "Po": -0.160003662109375,
    "Pp": -0.160003662109375,
    "Pq": -0.160003662109375,
    "Pr": -0.160003662109375,
    "Ps": -0.160003662109375,
    "Pt": 0.23999786376953125,
    "Pu": -0.160003662109375,
    "Pv": 0.160003662109375,
    "Pw": 0.160003662109375,
    "Py": 0.160003662109375,
    "Q ": -6.661338147750939e-16,
    "Q,": -0.23999786376953125,
    "Q.": -0.23999786376953125,
    "QY": -0.160003662109375,
    "Q\\": -0.23999786376953125,
    "Q_": -0.31999969482421875,
    "Qs": -0.160003662109375,
    "Qu": -0.160003662109375,
    "Qx": -0.160003662109375,
    "R ": 2.220446049250313e-16,
    "R)": 0.160003662109375,
    "R*": 0.160003662109375,
    "RA": 0.160003662109375,
    "RJ": 0.160003662109375,
    "RY": -0.160003662109375,
    "R_": 0.31999969482421875,
    "Rt": 0.0800018310546875,
    "Rv": 0.160003662109375,
    "Rw": 0.160003662109375,
    "Ry": 0.0800018310546875,
    "S ": 2.220446049250313e-16,
    "T ": 2.220446049250313e-16,
    "T\"": 0.31999969482421875,
    "T'": 0.31999969482421875,
    "T)": 0.31999969482421875,
    "T*": 0.23999786376953125,
    "T,": -0.6399993896484375,
    "T.": -0.6399993896484375,
    "T/": -0.6399993896484375,
    "T?": 0.23999786376953125,
    "T@": -0.40000152587890625,
    "TA": -0.23999786376953125,
    "TJ": -0.40000152587890625,
    "TT": 0.23999786376953125,
    "TV": 0.31999969482421875,
    "TW": 0.31999969482421875,
    "TX": 0.0800018310546875,
    "TY": 0.23999786376953125,
    "T\\": 0.31999969482421875,
    "T]": 0.31999969482421875,
    "T_": -0.40000152587890625,
    "Ta": -0.48000335693359375,
    "Tc": -0.48000335693359375,
    "Td": -0.48000335693359375,
    "Te": -0.48000335693359375,
    "Tg": -0.31999969482421875,
    "Tm": -0.48000335693359375,
    "Tn": -0.48000335693359375,
    "To": -0.48000335693359375,
    "Tp": -0.48000335693359375,
    "Tq": -0.48000335693359375,
    "Tr": -0.48000335693359375,
    "Ts": -0.55999755859375,
    "Tu": -0.48000335693359375,
    "Tv": -0.23999786376953125,
    "Tw": -0.23999786376953125,
    "Tx": -0.40000152587890625,
    "Ty": -0.23999786376953125,
    "Tz": -0.31999969482421875,
    "T}": 0.31999969482421875,
    "U ": 2.220446049250313e-16,
    "U,": -0.23999786376953125,
    "U.": -0.23999786376953125,
    "U_": -0.31999969482421875,
    "V ": 2.220446049250313e-16,
    "V\"": 0.31999969482421875,
    "V'": 0.31999969482421875,
    "V)": 0.160003662109375,
    "V*": 0.23999786376953125,
    "V,": -0.40000152587890625,
    "V.": -0.40000152587890625,
    "V/": -0.23999786376953125,
    "V?": 0.160003662109375,
    "VA": -0.23999786376953125,
    "VJ": -0.160003662109375,
    "VT": 0.31999969482421875,
    "VV": 0.23999786376953125,
    "VW": 0.23999786376953125,
    "VY": 0.23999786376953125,
    "V\\": 0.31999969482421875,
    "V]": 0.160003662109375,
    "V_": -0.31999969482421875,
    "Vf": 0.23999786376953125,
    "Vt": 0.160003662109375,
    "Vu": -0.0800018310546875,
    "Vv": 0.23999786376953125,
    "Vw": 0.23999786376953125,
    "Vx": 0.160003662109375,
    "Vy": 0.0800018310546875,
    "V}": 0.160003662109375,
    "W ": -6.661338147750939e-16,
    "W\"": 0.31999969482421875,
    "W'": 0.31999969482421875,
    "W)": 0.160003662109375,
    "W*": 0.23999786376953125,
    "W,": -0.40000152587890625,
    "W.": -0.40000152587890625,
    "W/": -0.23999786376953125,
    "W?": 0.160003662109375,
    "WA": -0.0800018310546875,
    "WJ": -0.160003662109375,
    "WT": 0.31999969482421875,
    "WV": 0.23999786376953125,
    "WW": 0.23999786376953125,
    "WY": 0.23999786376953125,
    "W\\": 0.31999969482421875,
    "W]": 0.160003662109375,
    "W_": -0.31999969482421875,
    "Wf": 0.23999786376953125,
    "Wt": 0.160003662109375,
    "Wu": -0.0800018310546875,
    "Wv": 0.23999786376953125,
    "Ww": 0.23999786376953125,
    "Wx": 0.160003662109375,
    "Wy": 0.23999786376953125,
    "W}": 0.160003662109375,
    "X ": 2.220446049250313e-16,
    "X)": 0.160003662109375,
    "X-": -0.31999969482421875,
    "X/": 0.23999786376953125,
    "XA": 0.23999786376953125,
    "XJ": 0.23999786376953125,
    "XT": 0.0800018310546875,
    "XZ": 0.160003662109375,
    "X\\": 0.23999786376953125,
    "X]": 0.160003662109375,
    "X_": 0.40000152587890625,
    "X}": 0.160003662109375,
    "Y ": 2.220446049250313e-16,
    "Y\"": 0.160003662109375,
    "Y&": -0.31999969482421875,
    "Y'": 0.160003662109375,
    "Y)": 0.160003662109375,
    "Y,": -0.6399993896484375,
    "Y-": -0.40000152587890625,
    "Y.": -0.6399993896484375,
    "Y/": -0.48000335693359375,
    "Y:": -0.23999786376953125,
    "Y;": -0.23999786376953125,
    "Y@": -0.48000335693359375,
    "YA": -0.23999786376953125,
    "YC": -0.160003662109375,
    "YG": -0.160003662109375,
    "YJ": -0.48000335693359375,
    "YO": -0.160003662109375,
    "YQ": -0.160003662109375,
    "YT": 0.23999786376953125,
    "YV": 0.23999786376953125,
    "YW": 0.23999786376953125,
    "YY": 0.0800018310546875,
    "Y\\": 0.31999969482421875,
    "Y]": 0.160003662109375,
    "Y_": -0.8000030517578125,
    "Ya": -0.6399993896484375,
    "Yc": -0.55999755859375,
    "Yd": -0.55999755859375,
    "Ye": -0.55999755859375,
    "Yg": -0.48000335693359375,
    "Ym": -0.40000152587890625,
    "Yn": -0.40000152587890625,
    "Yo": -0.55999755859375,
    "Yp": -0.40000152587890625,
    "Yq": -0.55999755859375,
    "Yr": -0.40000152587890625,
    "Ys": -0.48000335693359375,
    "Yt": -0.160003662109375,
    "Yu": -0.40000152587890625,
    "Yv": -0.160003662109375,
    "Yw": -0.160003662109375,
    "Yx": -0.23999786376953125,
    "Yy": -0.160003662109375,
    "Yz": -0.31999969482421875,
    "Y}": 0.160003662109375,
    "Z ": 2.220446049250313e-16,
    "Z\"": 0.23999786376953125,
    "Z'": 0.23999786376953125,
    "Z)": 0.160003662109375,
    "Z*": 0.23999786376953125,
    "Z,": 0.23999786376953125,
    "Z.": 0.23999786376953125,
    "Z/": 0.31999969482421875,
    "Z:": 0.23999786376953125,
    "Z;": 0.23999786376953125,
    "Z?": 0.31999969482421875,
    "ZA": 0.31999969482421875,
    "ZJ": 0.31999969482421875,
    "ZS": 0.160003662109375,
    "ZT": 0.23999786376953125,
    "ZV": 0.23999786376953125,
    "ZW": 0.23999786376953125,
    "ZX": 0.160003662109375,
    "ZY": 0.23999786376953125,
    "ZZ": 0.40000152587890625,
    "Z\\": 0.31999969482421875,
    "Z]": 0.160003662109375,
    "Z_": 0.48000335693359375,
    "Za": 0.160003662109375,
    "Zf": 0.160003662109375,
    "Zx": 0.23999786376953125,
    "Zz": 0.160003662109375,
    "Z}": 0.31999969482421875,
    "[ ": 2.220446049250313e-16,
    "[J": 0.160003662109375,
    "[T": 0.31999969482421875,
    "[V": 0.160003662109375,
    "[W": 0.160003662109375,
    "[X": 0.160003662109375,
    "[Y": 0.160003662109375,
    "[a": -0.160003662109375,
    "[j": 0.48000335693359375,
    "[u": -0.160003662109375,
    "[x": 0.160003662109375,
    "\\ ": 2.220446049250313e-16,
    "\\A": 0.40000152587890625,
    "\\C": -0.23999786376953125,
    "\\G": -0.23999786376953125,
    "\\J": 0.40000152587890625,
    "\\O": -0.23999786376953125,
    "\\Q": -0.23999786376953125,
    "\\T": -0.6399993896484375,
    "\\V": -0.31999969482421875,
    "\\W": -0.31999969482421875,
    "\\X": 0.23999786376953125,
    "\\Y": -0.55999755859375,
    "\\Z": 0.31999969482421875,
    "\\f": -0.23999786376953125,
    "\\j": 0.40000152587890625,
    "\\u": -0.0800018310546875,
    "\\x": 0.23999786376953125,
    "\\z": 0.23999786376953125,
    "] ": 2.220446049250313e-16,
    "^ ": 2.220446049250313e-16,
    "_ ": 2.220446049250313e-16,
    "_A": 0.40000152587890625,
    "_C": -0.31999969482421875,
    "_G": -0.31999969482421875,
    "_J": 0.40000152587890625,
    "_O": -0.31999969482421875,
    "_Q": -0.31999969482421875,
    "_T": -0.40000152587890625,
    "_U": -0.31999969482421875,
    "_V": -0.31999969482421875,
    "_W": -0.31999969482421875,
    "_X": 0.40000152587890625,
    "_Y": -0.8000030517578125,
    "_Z": 0.48000335693359375,
    "_g": 0.160003662109375,
    "_j": 0.6399993896484375,
    "_p": 0.23999786376953125,
    "_t": -0.31999969482421875,
    "_u": -0.23999786376953125,
    "_x": 0.40000152587890625,
    "_y": 0.160003662109375,
    "_z": 0.23999786376953125,
    "` ": 2.220446049250313e-16,
    "a ": 2.220446049250313e-16,
    "a\"": -0.160003662109375,
    "a'": -0.160003662109375,
    "a?": -0.48000335693359375,
    "a\\": -0.8000030517578125,
    "b ": 2.220446049250313e-16,
    "b?": -0.31999969482421875,
    "b\\": -0.55999755859375,
    "c ": 2.220446049250313e-16,
    "c?": -0.40000152587890625,
    "c\\": -0.48000335693359375,
    "d ": 2.220446049250313e-16,
    "e ": 2.220446049250313e-16,
    "e?": -0.40000152587890625,
    "e\\": -0.48000335693359375,
    "f ": 2.220446049250313e-16,
    "f!": 0.160003662109375,
    "f\"": 0.23999786376953125,
    "f'": 0.23999786376953125,
    "f)": 0.31999969482421875,
    "f*": 0.23999786376953125,
    "f,": -0.48000335693359375,
    "f-": 0.160003662109375,
    "f.": -0.48000335693359375,
    "f/": -0.40000152587890625,
    "f:": 0.160003662109375,
    "f;": 0.160003662109375,
    "f?": 0.23999786376953125,
    "f\\": 0.31999969482421875,
    "f]": 0.23999786376953125,
    "f_": -0.160003662109375,
    "fg": -0.160003662109375,
    "fi": 0.00000762939453125,
    "fl": 0.00000762939453125,
    "ft": 0.0800018310546875,
    "fv": 0.160003662109375,
    "fw": 0.160003662109375,
    "fx": 0.160003662109375,
    "fy": 0.160003662109375,
    "f}": 0.23999786376953125,
    "g ": 2.220446049250313e-16,
    "gj": 0.160003662109375,
    "h ": 2.220446049250313e-16,
    "h\"": -0.160003662109375,
    "h'": -0.160003662109375,
    "h?": -0.48000335693359375,
    "h\\": -0.8000030517578125,
    "i ": 2.220446049250313e-16,
    "j ": 2.220446049250313e-16,
    "jj": 0.160003662109375,
    "k ": 2.220446049250313e-16,
    "k)": 0.23999786376953125,
    "k*": 0.160003662109375,
    "k/": 0.23999786376953125,
    "k\\": -0.23999786376953125,
    "k]": 0.23999786376953125,
    "k_": 0.48000335693359375,
    "kf": 0.0800018310546875,
    "kt": 0.160003662109375,
    "kv": 0.160003662109375,
    "kw": 0.160003662109375,
    "kx": 0.160003662109375,
    "ky": 0.23999786376953125,
    "k}": 0.23999786376953125,
    "l ": 2.220446049250313e-16,
    "m ": -6.661338147750939e-16,
    "m\"": -0.160003662109375,
    "m'": -0.160003662109375,
    "m?": -0.48000335693359375,
    "m\\": -0.8000030517578125,
    "n ": 2.220446049250313e-16,
    "n\"": -0.160003662109375,
    "n'": -0.160003662109375,
    "n?": -0.48000335693359375,
    "n\\": -0.8000030517578125,
    "o ": 2.220446049250313e-16,
    "o?": -0.31999969482421875,
    "o\\": -0.55999755859375,
    "p ": 2.220446049250313e-16,
    "p?": -0.31999969482421875,
    "p\\": -0.55999755859375,
    "q ": 2.220446049250313e-16,
    "qj": 0.160003662109375,
    "r ": 2.220446049250313e-16,
    "r\"": 0.23999786376953125,
    "r'": 0.23999786376953125,
    "r*": 0.23999786376953125,
    "r,": -0.48000335693359375,
    "r.": -0.48000335693359375,
    "r/": -0.48000335693359375,
    "r\\": -0.31999969482421875,
    "r_": -0.40000152587890625,
    "rf": 0.23999786376953125,
    "rt": 0.1999969482421875,
    "rv": 0.23999786376953125,
    "rw": 0.23999786376953125,
    "ry": 0.23999786376953125,
    "rz": 0.0800018310546875,
    "s ": 2.220446049250313e-16,
    "s?": -0.31999969482421875,
    "s\\": -0.55999755859375,
    "ss": -0.160003662109375,
    "t ": 2.220446049250313e-16,
    "t!": 0.160003662109375,
    "t)": 0.31999969482421875,
    "t/": 0.23999786376953125,
    "t?": -0.160003662109375,
    "t\\": -0.31999969482421875,
    "t]": 0.23999786376953125,
    "t_": 0.40000152587890625,
    "tj": 0.160003662109375,
    "tv": 0.160003662109375,
    "tw": 0.160003662109375,
    "ty": 0.160003662109375,
    "t}": 0.23999786376953125,
    "u ": 2.220446049250313e-16,
    "u?": -0.40000152587890625,
    "u\\": -0.55999755859375,
    "v ": 2.220446049250313e-16,
    "v!": 0.160003662109375,
    "v\"": 0.160003662109375,
    "v'": 0.160003662109375,
    "v*": 0.160003662109375,
    "v,": -0.31999969482421875,
    "v-": 0.160003662109375,
    "v.": -0.31999969482421875,
    "v:": 0.160003662109375,
    "v;": 0.160003662109375,
    "v\\": -0.160003662109375,
    "vf": 0.160003662109375,
    "vt": 0.160003662109375,
    "vv": 0.23999786376953125,
    "vw": 0.23999786376953125,
    "vx": 0.0800018310546875,
    "vy": 0.23999786376953125,
    "w ": 2.220446049250313e-16,
    "w!": 0.160003662109375,
    "w\"": 0.160003662109375,
    "w'": 0.160003662109375,
    "w*": 0.160003662109375,
    "w,": -0.31999969482421875,
    "w-": 0.160003662109375,
    "w.": -0.31999969482421875,
    "w:": 0.160003662109375,
    "w;": 0.160003662109375,
    "w\\": -0.160003662109375,
    "wf": 0.160003662109375,
    "wt": 0.160003662109375,
    "wv": 0.23999786376953125,
    "ww": 0.23999786376953125,
    "wx": 0.0800018310546875,
    "wy": 0.23999786376953125,
    "x ": 2.220446049250313e-16,
    "x)": 0.23999786376953125,
    "x/": 0.31999969482421875,
    "x\\": -0.31999969482421875,
    "x]": 0.160003662109375,
    "x_": 0.40000152587890625,
    "xj": 0.160003662109375,
    "xv": 0.0800018310546875,
    "xw": 0.0800018310546875,
    "xx": 0.160003662109375,
    "xy": 0.160003662109375,
    "x}": 0.23999786376953125,
    "y ": 2.220446049250313e-16,
    "y!": 0.160003662109375,
    "y\"": 0.160003662109375,
    "y'": 0.160003662109375,
    "y*": 0.160003662109375,
    "y,": -0.31999969482421875,
    "y-": 0.160003662109375,
    "y.": -0.31999969482421875,
    "y:": 0.160003662109375,
    "y;": 0.160003662109375,
    "y\\": -0.160003662109375,
    "yf": 0.160003662109375,
    "yt": 0.160003662109375,
    "yv": 0.23999786376953125,
    "yw": 0.23999786376953125,
    "yx": 0.0800018310546875,
    "yy": 0.23999786376953125,
    "z ": 2.220446049250313e-16,
    "z/": 0.160003662109375,
    "z\\": -0.40000152587890625,
    "z_": 0.23999786376953125,
    "zy": 0.0800018310546875,
    "zz": -0.0800018310546875,
    "{ ": 2.220446049250313e-16,
    "{J": 0.160003662109375,
    "{T": 0.31999969482421875,
    "{V": 0.160003662109375,
    "{W": 0.160003662109375,
    "{X": 0.160003662109375,
    "{Y": 0.160003662109375,
    "{Z": 0.160003662109375,
    "{a": -0.160003662109375,
    "{j": 0.40000152587890625,
    "{u": -0.160003662109375,
    "{x": 0.23999786376953125,
    "| ": 2.220446049250313e-16,
    "} ": 2.220446049250313e-16,
    "~ ": 2.220446049250313e-16
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const SingleCharMapRegular = {
    "0": 5,
    "1": 5,
    "2": 5,
    "3": 5,
    "4": 5,
    "5": 5,
    "6": 5,
    "7": 5,
    "8": 5,
    "9": 5,
    " ": 1.8799,
    "!": 1.8159942626953125,
    "\"": 2.4719924926757812,
    "#": 5.791999816894531,
    "$": 4.7039947509765625,
    "%": 8.351997375488281,
    "&": 5.663993835449219,
    "'": 1.4959945678710938,
    "(": 2.7519989013671875,
    ")": 2.7519989013671875,
    "*": 3.33599853515625,
    "+": 4.047996520996094,
    ",": 1.839996337890625,
    "-": 3.447998046875,
    ".": 1.839996337890625,
    "/": 4.047996520996094,
    ":": 1.839996337890625,
    ";": 1.839996337890625,
    "<": 3.9199981689453125,
    "=": 4.047996520996094,
    ">": 3.9199981689453125,
    "?": 4.055999755859375,
    "@": 6.543998718261719,
    "A": 4.9759979248046875,
    "B": 5.5279998779296875,
    "C": 5.5919952392578125,
    "D": 6.023994445800781,
    "E": 5.327995300292969,
    "F": 4.911994934082031,
    "G": 5.943992614746094,
    "H": 6.359992980957031,
    "I": 2.4719924926757812,
    "J": 4.071998596191406,
    "K": 5.127998352050781,
    "L": 5.063995361328125,
    "M": 7.5919952392578125,
    "N": 6.263999938964844,
    "O": 6.2559967041015625,
    "P": 5.375999450683594,
    "Q": 6.23199462890625,
    "R": 5.407997131347656,
    "S": 5.0319976806640625,
    "T": 4.5679931640625,
    "U": 6.015998840332031,
    "V": 4.9279937744140625,
    "W": 7.287994384765625,
    "X": 5.071998596191406,
    "Y": 4.879997253417969,
    "Z": 4.55999755859375,
    "[": 2.7119979858398438,
    "\\": 4.0879974365234375,
    "]": 2.7119979858398438,
    "^": 3.4719924926757812,
    "_": 3.839996337890625,
    "`": 4.799995422363281,
    "a": 4.575996398925781,
    "b": 4.911994934082031,
    "c": 4.2559967041015625,
    "d": 4.911994934082031,
    "e": 4.375999450683594,
    "f": 2.8239974975585938,
    "g": 4.903999328613281,
    "h": 5.0399932861328125,
    "i": 2.2079925537109375,
    "j": 2.2079925537109375,
    "k": 4.191993713378906,
    "l": 2.2079925537109375,
    "m": 7.431999206542969,
    "n": 5.0399932861328125,
    "o": 4.687995910644531,
    "p": 4.911994934082031,
    "q": 4.911994934082031,
    "r": 3.0479965209960938,
    "s": 4.0879974365234375,
    "t": 2.8799972534179688,
    "u": 5.00799560546875,
    "v": 4.015998840332031,
    "w": 5.855995178222656,
    "x": 4.0319976806640625,
    "y": 4.015998840332031,
    "z": 3.9119949340820312,
    "{": 2.7759933471679688,
    "|": 2.3759994506835938,
    "}": 2.7759933471679688,
    "~": 4.2559967041015625
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const SingleCharMapCondensed = {
    "0": 4.279998779296875,
    "1": 4.279998779296875,
    "2": 4.279998779296875,
    "3": 4.279998779296875,
    "4": 4.279998779296875,
    "5": 4.279998779296875,
    "6": 4.279998779296875,
    "7": 4.279998779296875,
    "8": 4.279998779296875,
    "9": 4.279998779296875,
    " ": 1.37,
    "!": 1.3279953002929688,
    "\"": 1.8799972534179688,
    "#": 4.3679962158203125,
    "$": 3.4639968872070312,
    "%": 6.167999267578125,
    "&": 4.247993469238281,
    "'": 1.11199951171875,
    "(": 2.1199951171875,
    ")": 2.1199951171875,
    "*": 2.4319992065429688,
    "+": 3,
    ",": 1.343994140625,
    "-": 2.55999755859375,
    ".": 1.33599853515625,
    "/": 2.9439926147460938,
    ":": 1.33599853515625,
    ";": 1.3519973754882812,
    "<": 2.7999954223632812,
    "=": 3,
    ">": 2.7999954223632812,
    "?": 3.0479965209960938,
    "@": 4.9199981689453125,
    "A": 3.7119979858398438,
    "B": 4.079994201660156,
    "C": 4.1999969482421875,
    "D": 4.487998962402344,
    "E": 3.9599990844726562,
    "F": 3.67999267578125,
    "G": 4.407997131347656,
    "H": 4.736000061035156,
    "I": 1.8079986572265625,
    "J": 3.0719985961914062,
    "K": 3.8639984130859375,
    "L": 3.7519989013671875,
    "M": 5.6719970703125,
    "N": 4.67999267578125,
    "O": 4.6479949951171875,
    "P": 4.055999755859375,
    "Q": 4.6479949951171875,
    "R": 4.0399932861328125,
    "S": 3.6719970703125,
    "T": 3.4639968872070312,
    "U": 4.487998962402344,
    "V": 3.7039947509765625,
    "W": 5.503997802734375,
    "X": 3.8479995727539062,
    "Y": 3.6959991455078125,
    "Z": 3.4959945678710938,
    "[": 2.0799942016601562,
    "\\": 2.9839935302734375,
    "]": 2.0879974365234375,
    "^": 2.503997802734375,
    "_": 2.8799972534179688,
    "`": 3.615997314453125,
    "a": 3.3839950561523438,
    "b": 3.67999267578125,
    "c": 3.2239990234375,
    "d": 3.6719970703125,
    "e": 3.3039932250976562,
    "f": 2.1599960327148438,
    "g": 3.6639938354492188,
    "h": 3.7360000610351562,
    "i": 1.5839996337890625,
    "j": 1.5839996337890625,
    "k": 3.1599960327148438,
    "l": 1.5839996337890625,
    "m": 5.5359954833984375,
    "n": 3.7360000610351562,
    "o": 3.5279998779296875,
    "p": 3.67999267578125,
    "q": 3.6719970703125,
    "r": 2.1919937133789062,
    "s": 2.8879928588867188,
    "t": 2.1839981079101562,
    "u": 3.7199935913085938,
    "v": 2.9839935302734375,
    "w": 4.383995056152344,
    "x": 3.0399932861328125,
    "y": 3,
    "z": 2.8879928588867188,
    "{": 2.1439971923828125,
    "|": 1.7439956665039062,
    "}": 2.1439971923828125,
    "~": 3.11199951171875
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FontWidthMultipliers = new Map([
    ["font-family:FortCondensedLight", 1],
    ["font-family:FortCondensedBold", 1.0675],
    ["font-family:FortBook", 1],
    ["font-family:FortBold", 1.04],
    ["font-family:FortExtraBold", 1.058],
    ["font-weight:400", 1],
    ["font-weight:bold", 1.01],
    ["font-weight:600", 1.01],
    ["font-weight:800", 1.01]
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Strategy that has pre-generated text sizes and font width proportions, to avoid expensive DOM and bbox calculations.
 */
class MemoisedTextSizeStrategy {
    constructor() {
        this.singleCharMapRegular = SingleCharMapRegular;
        this.singleCharMapCondensed = SingleCharMapCondensed;
        this.multiCharMapRegular = MultiCharMapRegular;
        this.multiCharMapCondensed = MultiCharMapCondensed;
        // Contains multipliers for different Fort fonts and font weights
        this.fontWidthMultipliers = FontWidthMultipliers;
        // Font size weights grow linearly by n * 0.125
        this.FONT_SIZE_WIDTH_CONSTANT = 0.125;
        this.DEFAULT_FONT_SIZE = 8;
        this.DEFAULT_CHAR_WIDTH = 3.5;
    }
    /**
     * Width calculation
     * @param {?} text string to calculate width for
     * @param {?} attr list of text attributes i.e. font-size, font-family, font-weight
     * @return {?}
     */
    calculateWidth(text, attr) {
        this.setCharMaps(attr);
        /** @type {?} */
        const multiplier = this.calculateFontMultiplier(attr);
        /** @type {?} */
        let runningWidth = 0;
        for (let i = 0; i < text.length; i++) {
            /** @type {?} */
            const currChar = text.charAt(i);
            /** @type {?} */
            const nextChar = text.charAt(i + 1);
            runningWidth += get(this.singleCharMap, `${currChar}`, this.DEFAULT_CHAR_WIDTH);
            if (i !== text.length - 1) {
                runningWidth += get(this.multiCharMap, `${currChar}${nextChar}`, 0);
            }
        }
        return runningWidth * multiplier;
    }
    /**
     * @param {?} attr
     * @return {?}
     */
    setCharMaps(attr) {
        /** @type {?} */
        const fontFamily = get(attr, 'font-family');
        if (fontFamily && fontFamily.includes('FortCondensed')) {
            this.singleCharMap = this.singleCharMapCondensed;
            this.multiCharMap = this.multiCharMapCondensed;
        }
        else {
            this.singleCharMap = this.singleCharMapRegular;
            this.multiCharMap = this.multiCharMapRegular;
        }
    }
    /**
     * Takes text attributes and gives back a magic constant which gets added to base width to return the correct width calculation
     * @private
     * @param {?} attr : list of text attributes i.e. font-size, font-family, font-weight
     * @return {?}
     */
    calculateFontMultiplier(attr) {
        /** @type {?} */
        let multiplier = 1;
        /** @type {?} */
        const fontFamily = `font-family:${attr['font-family']}`;
        /** @type {?} */
        const fontWeight = `font-weight:${attr['font-weight']}`;
        /** @type {?} */
        const fontSizeMult = parseInt(get(attr, 'font-size', this.DEFAULT_FONT_SIZE), 10) * this.FONT_SIZE_WIDTH_CONSTANT;
        /** @type {?} */
        const fontFamilyMult = this.fontWidthMultipliers.get(fontFamily) ? +this.fontWidthMultipliers.get(fontFamily) : 1;
        /** @type {?} */
        const fontWeightMult = this.fontWidthMultipliers.get(fontWeight) ? +this.fontWidthMultipliers.get(fontWeight) : 1;
        multiplier *= fontSizeMult * fontFamilyMult * fontWeightMult;
        return multiplier;
    }
    /**
     * Unused method that is here just to document how files singleChars.json and multiChars.json were produced in case we need to re-generate when changing fonts for PDF
     * @private
     * @param {?=} fontSize
     * @return {?}
     */
    generateMemoisedLetterSizes(fontSize = 8) {
        /** @type {?} */
        let i;
        /** @type {?} */
        let j;
        /** @type {?} */
        const originalOneLetterRef = {};
        /** @type {?} */
        const twoLetterRef = {};
        for (i = 32; i <= 126; i++) {
            /** @type {?} */
            const character = String.fromCharCode(i);
            /** @type {?} */
            const w = new PhantomSVGText(character, { 'font-size': fontSize, 'font-family': 'FortBook' }).getWidth();
            originalOneLetterRef[character] = w;
        }
        // Pre-checked size of the space
        originalOneLetterRef[' '] = 1.8799;
        for (i = 32; i <= 126; i++) {
            for (j = 32; j <= 126; j++) {
                /** @type {?} */
                const c1 = String.fromCharCode(i);
                /** @type {?} */
                const c2 = String.fromCharCode(j);
                /** @type {?} */
                const twoLetters = `${c1}${c2}`;
                /** @type {?} */
                let twoWidth;
                if (c1 === ' ' && c2 === ' ') {
                    twoWidth = 2 * originalOneLetterRef[' '];
                }
                else if (c1 === ' ') {
                    twoWidth = originalOneLetterRef[' '] + new PhantomSVGText(c2, { 'font-size': fontSize, 'font-family': 'FortBook' }).getWidth();
                }
                else if (c2 === ' ') {
                    twoWidth = originalOneLetterRef[' '] + new PhantomSVGText(c1, { 'font-size': fontSize, 'font-family': 'FortBook' }).getWidth();
                }
                else {
                    twoWidth = new PhantomSVGText(twoLetters, { 'font-size': fontSize, 'font-family': 'FortBook' }).getWidth();
                }
                twoLetterRef[twoLetters] = twoWidth - originalOneLetterRef[c1] - originalOneLetterRef[c2];
            }
        }
        /** @type {?} */
        const singleChars = JSON.stringify(originalOneLetterRef);
        /** @type {?} */
        const multiChars = JSON.stringify(twoLetterRef);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * SvgTextRenderer class is turning lines of HtmlTextElem objects into an SVG text structure and returns it back as a ContentBox.
 */
class SvgTextRenderer {
    /**
     * render method will convert lines into the SVG text element structure
     * @param {?} lines a 2d array of HtmlTextElem objects where each top level array represents a line of text.
     * @param {?} actualWidth the actual width of text - used for alignment & ContentBox creation
     * @param {?} attr formatting attributes to be applied at the top level
     * @param {?} hAlign horizontal text alignment
     * @param {?=} lineHeight
     * @param {?=} linesPerBreak determines the limit of lines in a single svg element / ContentBox pair.
     * @return {?}
     */
    render(lines, actualWidth, attr, hAlign, lineHeight = 1.375, linesPerBreak = 5) {
        /** @type {?} */
        const result = [];
        /** @type {?} */
        let textEl;
        /** @type {?} */
        let currEl;
        /** @type {?} */
        const classes = [];
        /** @type {?} */
        let runningHeight = 0;
        /** @type {?} */
        let maxWordHeight = 0;
        lines.forEach((/**
         * @param {?} line
         * @param {?} i
         * @return {?}
         */
        (line, i) => {
            if (i % linesPerBreak === 0) {
                if (i > 0) {
                    // removing last child if it is empty because batik doesn't recognise element
                    if (textEl.lastChild.textContent.match(/^\s*$/)) {
                        textEl.removeChild(textEl.lastChild);
                    }
                    result.push(new ContentBox(textEl, actualWidth, runningHeight));
                }
                textEl = (/** @type {?} */ (document.createElementNS(SVG_NS, 'text')));
                runningHeight = 0;
                currEl = textEl;
                SVGUtils.applyAttributes(textEl, attr);
                this.realignText(textEl, hAlign, actualWidth);
            }
            /** @type {?} */
            const lineSpan = (/** @type {?} */ (document.createElementNS(SVG_NS, 'tspan')));
            textEl.appendChild(lineSpan);
            lineSpan.setAttribute('y', (i % linesPerBreak) * lineHeight + 1 + 'em');
            lineSpan.setAttribute('x', '0');
            currEl = lineSpan;
            maxWordHeight = Number.parseInt(attr['font-size'] || CLASS_LIST['text-defaults']['font-size']);
            // recreate nested tspan class attributes structure
            classes.forEach((/**
             * @param {?} clazz
             * @return {?}
             */
            clazz => {
                /** @type {?} */
                const tspan = (/** @type {?} */ (document.createElementNS(SVG_NS, 'tspan')));
                currEl.appendChild(tspan);
                SVGUtils.applyAttributes(tspan, CLASS_LIST[clazz]);
                maxWordHeight = Math.max(maxWordHeight, Number.parseInt(CLASS_LIST[clazz]['font-size'] || CLASS_LIST['text-defaults']['font-size']));
                currEl = tspan;
            }));
            runningHeight += maxWordHeight * lineHeight;
            line.forEach((/**
             * @param {?} word
             * @param {?} i
             * @return {?}
             */
            (word, i) => {
                if (word instanceof HtmlWord) {
                    currEl.appendChild(document.createTextNode(word.word));
                }
                else if (word instanceof HtmlSpace && i !== 0) {
                    currEl.appendChild(document.createTextNode(' '));
                }
                else if (word instanceof HtmlClassStart) {
                    classes.push(word.clazz);
                    /** @type {?} */
                    const tspan = (/** @type {?} */ (document.createElementNS(SVG_NS, 'tspan')));
                    currEl.appendChild(tspan);
                    SVGUtils.applyAttributes(tspan, CLASS_LIST[word.clazz]);
                    currEl = tspan;
                }
                else if (word instanceof HtmlClassEnd) {
                    /** @type {?} */
                    const removed = classes.pop();
                    if (currEl.parentNode instanceof SVGElement) {
                        currEl = currEl.parentNode;
                    }
                    else {
                        console.error('Text rendering failed - unmatched class end tag');
                        currEl = textEl;
                    }
                    if (removed !== word.clazz) {
                        console.warn(`Expected closing tag for '${removed}' got '${word.clazz}' there might be rendering issues!`);
                    }
                }
            }));
        }));
        // push the last elem into results
        result.push(new ContentBox(textEl, actualWidth, runningHeight));
        return result;
    }
    /**
     * @private
     * @param {?} textWrapper
     * @param {?} hAlign
     * @param {?} width
     * @return {?}
     */
    realignText(textWrapper, hAlign, width) {
        // define horizontal alignment
        switch (hAlign) {
            case Alignment.Horizontal.Left:
                textWrapper.setAttribute('text-anchor', 'start');
                // SVGUtils.updateTranslate(sidePaddingOffset + offset, textYOffset, textWrapper);
                break;
            case Alignment.Horizontal.Center:
                textWrapper.setAttribute('text-anchor', 'middle');
                SVGUtils.updateTranslate(width / 2, 0, textWrapper);
                break;
            case Alignment.Horizontal.Right:
                textWrapper.setAttribute('text-anchor', 'end');
                SVGUtils.updateTranslate(width, 0, textWrapper);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * TextBreakStrategy controls how to break text represented as a list of HtmlTextElem objects into separate lines based on the available width.
 * @abstract
 */
class TextBreakStrategy {
}
/**
 * SimpleTextBreakStrategy uses text size strategy to calculate the text width used and split the text into lines of fixed width
 * to ensure a maximum amount of text fits into each line. This strategy will break words if a word doesn't fit in a line.
 */
class SimpleTextBreakStrategy {
    /**
     * @param {?} sizeStrategy
     * @param {?} tolerance
     */
    constructor(sizeStrategy, tolerance) {
        this.sizeStrategy = sizeStrategy;
        this.tolerance = tolerance;
    }
    /**
     * @param {?} element
     * @param {?} availableWidth
     * @param {?} sizeStrategy
     * @param {?} pivot
     * @return {?}
     */
    breakWord(element, availableWidth, sizeStrategy, pivot) {
        /** @type {?} */
        const newWord = pivot === element.word.length ? element : new HtmlWord(element.word.substr(0, pivot), element.attributes);
        /** @type {?} */
        const width = newWord.getWidth(sizeStrategy);
        /** @type {?} */
        const newPivot = Math.max(Math.floor(pivot * (availableWidth / width)), 1);
        if (width <= availableWidth || newWord.word.length === 1 || newPivot === pivot) {
            if (pivot < element.word.length) {
                return [newWord, new HtmlWord(element.word.substr(pivot), element.attributes)];
            }
            else {
                return [newWord];
            }
        }
        else {
            return this.breakWord(element, availableWidth, sizeStrategy, newPivot);
        }
    }
    /**
     * @param {?} content
     * @param {?} availableWidth
     * @return {?}
     */
    breakLines(content, availableWidth) {
        /** @type {?} */
        const lines = [[]];
        /** @type {?} */
        const sizeStrategy = this.sizeStrategy;
        /** @type {?} */
        let runningWidth = 0;
        /** @type {?} */
        let maxWidth = 0;
        /** @type {?} */
        let previousElemWasNewLine = false;
        while (content.length > 0) {
            /** @type {?} */
            const element = content.shift();
            /** @type {?} */
            const width = element.getWidth(sizeStrategy);
            if (element instanceof HtmlNewLine || runningWidth + width > availableWidth) {
                if (element instanceof HtmlNewLine) {
                    /** @type {?} */
                    const previousVal = previousElemWasNewLine;
                    previousElemWasNewLine = true;
                    if (!previousVal && lines[lines.length - 1].length === 0) {
                        continue; // if line break coincides with the line width limit skip to avoid double new lines
                    }
                }
                else if (width > availableWidth + this.tolerance && element instanceof HtmlWord && element.word.length > 1) {
                    /** @type {?} */
                    const wordSplit = this.breakWord(element, availableWidth, sizeStrategy, Math.floor(element.word.length * (availableWidth / width)));
                    content.unshift(...wordSplit);
                    continue; // If the word is too long just we need to break and try again
                }
                lines.push([]);
                runningWidth = 0;
            }
            else {
                previousElemWasNewLine = false;
            }
            if (!(element instanceof HtmlNewLine)) {
                lines[lines.length - 1].push(element);
            }
            runningWidth += width;
            maxWidth = Math.max(maxWidth, runningWidth);
        }
        // Remove trailing new lines maybe we shouldn't?
        for (let i = lines.length - 1; i >= 0; i--) {
            if (lines[i].length) {
                break;
            }
            lines.pop();
        }
        return [lines, maxWidth];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ParagraphComposer is a util class that effectively renders text as SVG / ContentBox(s).
 * This class supports rich formatted HTML as input but will only support a limited subset of formatting however unsupported formatting features shouldn't cause any errors.
 * Furthermore this class allows for page breaking of text - the text will be grouped into blocks
 *
 */
class ParagraphComposer {
    /**
     * @param {?=} textBreakStrategy
     * @param {?=} textRenderer
     */
    constructor(textBreakStrategy = new SimpleTextBreakStrategy(ParagraphComposer.sizeStrategy, 0.5), textRenderer = new SvgTextRenderer()) {
        this.textBreakStrategy = textBreakStrategy;
        this.textRenderer = textRenderer;
    }
    /**
     * @param {?} sizeStrategy
     * @return {?}
     */
    static setSizeStrategy(sizeStrategy) {
        ParagraphComposer.sizeStrategy = sizeStrategy;
    }
    /**
     * @param {?} text
     * @param {?} attr
     * @param {?} hAlign
     * @param {?} availableWidth
     * @param {?} availableHeight
     * @param {?} useFullWidth
     * @param {?=} linesPerBreak
     * @param {?=} lineHeight
     * @param {?=} tolerance
     * @return {?}
     */
    compose(text, attr, hAlign, availableWidth, availableHeight, useFullWidth, linesPerBreak = 5, lineHeight = 1.375, tolerance = 0.5) {
        /** @type {?} */
        const parser = new HtmlTextParser();
        /** @type {?} */
        const content = parser.parse(text, attr);
        const [lines, maxWidth] = this.textBreakStrategy.breakLines(content, availableWidth);
        /** @type {?} */
        const actualWidth = useFullWidth ? availableWidth : Math.min(availableWidth, maxWidth);
        if (maxWidth > actualWidth) {
            console.warn('Text doesn\'t fit inside given space');
        }
        return this.textRenderer.render(lines, actualWidth, attr, hAlign, lineHeight, linesPerBreak);
    }
}
ParagraphComposer.sizeStrategy = new MemoisedTextSizeStrategy();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DataError extends Error {
    /**
     * @param {?} message
     */
    constructor(message) {
        super(message);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LayoutError extends Error {
    /**
     * @param {?} message
     */
    constructor(message) {
        super(message);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class BusinessComponent {
    /**
     * Business Component constructor
     *
     * @param {?} name name of the component
     * @param {?} type type of the component which can be 'BusinessComponent'
     * @param {?=} businessComponentOptions this object contains parameters that we want to use on BusinessComponent such as visibility and can be overriden in your application
     */
    constructor(name, type, businessComponentOptions = { visible: true, repeatComponentOptions: { isRepeatComponent: false, skipPages: [] } }) {
        this.name = name;
        this.type = type;
        this.businessComponentOptions = businessComponentOptions;
    }
    /**
     * checks if the Business Component data is visible
     * this is a default method that can be adapted depending on your own visibility rules for data per component
     *
     * @param {?} componentData object
     * @return {?} boolean
     */
    isComponentDataVisible(componentData) {
        return !!componentData;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BoxModelConstraint {
    /**
     * Creates an instance of BoxModelConstraint.
     * The measurement unit are implicitly px.
     * If defined, all dimension values should be >=0.
     * In cases where one or more dimensions are not provided, the box will attempt to accommodate its content for the respective dimension.
     * \@memberof BoxModelConstraint
     * @param {?=} width
     * @param {?=} height
     * @param {?=} paddingTop
     * @param {?=} paddingBottom
     * @param {?=} paddingLeft
     * @param {?=} paddingRight
     * @param {?=} marginTop
     * @param {?=} marginBottom
     * @param {?=} marginLeft
     * @param {?=} marginRight
     * @param {?=} borderTop
     * @param {?=} borderTopColor
     * @param {?=} borderBottom
     * @param {?=} borderBottomColor
     * @param {?=} borderLeft
     * @param {?=} borderLeftColor
     * @param {?=} borderRight
     * @param {?=} borderRightColor
     * @param {?=} proportion
     * @param {?=} backgroundColor
     * @param {?=} backgroundShape
     * @param {?=} borderRadius
     * @param {?=} useFullWidth
     * @param {?=} useFullHeight
     * @param {?=} newPage
     */
    constructor(width, height, paddingTop = 0, paddingBottom = 0, paddingLeft = 0, paddingRight = 0, marginTop = 0, marginBottom = 0, marginLeft = 0, marginRight = 0, borderTop = 0, borderTopColor = BoxModelConstants.DEFAULT_BORDER_COLOR, borderBottom = 0, borderBottomColor = BoxModelConstants.DEFAULT_BORDER_COLOR, borderLeft = 0, borderLeftColor = BoxModelConstants.DEFAULT_BORDER_COLOR, borderRight = 0, borderRightColor = BoxModelConstants.DEFAULT_BORDER_COLOR, proportion, backgroundColor, backgroundShape = 'rect', borderRadius, useFullWidth = false, useFullHeight = false, newPage = false) {
        this.width = width;
        this.height = height;
        this.paddingTop = paddingTop;
        this.paddingBottom = paddingBottom;
        this.paddingLeft = paddingLeft;
        this.paddingRight = paddingRight;
        this.marginTop = marginTop;
        this.marginBottom = marginBottom;
        this.marginLeft = marginLeft;
        this.marginRight = marginRight;
        this.borderTop = borderTop;
        this.borderTopColor = borderTopColor;
        this.borderBottom = borderBottom;
        this.borderBottomColor = borderBottomColor;
        this.borderLeft = borderLeft;
        this.borderLeftColor = borderLeftColor;
        this.borderRight = borderRight;
        this.borderRightColor = borderRightColor;
        this.proportion = proportion;
        this.backgroundColor = backgroundColor;
        this.backgroundShape = backgroundShape;
        this.borderRadius = borderRadius;
        this.useFullWidth = useFullWidth;
        this.useFullHeight = useFullHeight;
        this.newPage = newPage;
    }
    /**
     * @param {?} constraints
     * @param {?=} overrides
     * @return {?}
     */
    static merge(constraints, overrides) {
        if (!constraints) {
            constraints = {};
        }
        if (!overrides) {
            overrides = {};
        }
        return Object.assign(Object.assign({}, constraints), overrides);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const LayoutStrategy = {
    ROW: 0,
    COLUMN: 1,
};
LayoutStrategy[LayoutStrategy.ROW] = 'ROW';
LayoutStrategy[LayoutStrategy.COLUMN] = 'COLUMN';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *  Borders are draw top to bottom / left to right for the sake of simplicity.
 *  There are 2 important considerations to be aware of:
 *  1)	The SVG stroke-width property used to draw the border renders to/from an origin of stoke-width / 2.
 * 		The implication of this for SVG elements is that half the border stroke-width may be cropped by the viewbox,
 * 		hence you will see a lot of width / 2 type calculations used to offset the x,y coordinates of
 * 		a stoke such that the full width of the border / stroke is visible to the user.
 *  2) 	Any border should be drawn to a length that allows it to either:
 * 		a) Completely overlap any adjacent border(s) in order to render a contiguous corner.
 * 		b) Align with the content size for a given dimension.
 * @type {?}
 */
const setupBorders = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @return {?}
 */
function (contentBox, constraint) {
    /** @type {?} */
    const boarderGroup = setUpBorderGroup(contentBox, constraint);
    contentBox = applyTopBorder(contentBox, constraint, boarderGroup);
    contentBox = applyRightBorder(contentBox, constraint, boarderGroup);
    contentBox = applyBottomBorder(contentBox, constraint, boarderGroup);
    contentBox = applyLeftBorder(contentBox, constraint, boarderGroup);
    return contentBox;
});
/** @type {?} */
const setUpBorderGroup = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @return {?}
 */
function (contentBox, constraint) {
    if (constraint.borderBottom > 0 || constraint.borderLeft > 0 || constraint.borderTop > 0 || constraint.borderRight > 0) {
        contentBox.element.setAttribute('style', 'overflow: visible;');
        /** @type {?} */
        const group = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        group.setAttribute('class', BoxModelConstants.BORDER_GROUP_CLASS);
        contentBox.element.appendChild(group);
        return group;
    }
    else {
        return null;
    }
});
/** @type {?} */
const applyTopBorder = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @param {?} borderGroup
 * @return {?}
 */
function (contentBox, constraint, borderGroup) {
    /** @type {?} */
    const topBorderWidth = get(constraint, 'borderTop', 0);
    if (!borderGroup || !(topBorderWidth !== undefined && topBorderWidth > 0))
        return contentBox;
    /** @type {?} */
    const leftBorderWidth = constraint['borderLeft'] ? constraint['borderLeft'] : 0;
    /** @type {?} */
    const rightBorderWidth = constraint['borderRight'] ? constraint['borderRight'] : 0;
    /** @type {?} */
    const topBorder = (/** @type {?} */ (document.createElementNS(SVG_NS, 'line')));
    topBorder.setAttribute('x1', `${0}`);
    topBorder.setAttribute('y1', `${topBorderWidth / 2.0}`);
    topBorder.setAttribute('x2', `${leftBorderWidth + contentBox.width + rightBorderWidth}`);
    topBorder.setAttribute('y2', `${topBorderWidth / 2.0}`);
    topBorder.setAttribute('stroke-width', topBorderWidth.toString());
    topBorder.setAttribute('stroke', get(constraint, 'borderTopColor', BoxModelConstants.DEFAULT_BORDER_COLOR));
    borderGroup.appendChild(topBorder);
    return contentBox;
});
/** @type {?} */
const applyBottomBorder = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @param {?} borderGroup
 * @return {?}
 */
function (contentBox, constraint, borderGroup) {
    /** @type {?} */
    const bottomBorderWidth = constraint['borderBottom'] ? constraint['borderBottom'] : 0;
    if (!borderGroup || !(bottomBorderWidth !== undefined && bottomBorderWidth > 0))
        return contentBox;
    /** @type {?} */
    const topBorderWidth = constraint['borderTop'] ? constraint['borderTop'] : 0;
    /** @type {?} */
    const leftBorderWidth = constraint['borderLeft'] ? constraint['borderLeft'] : 0;
    /** @type {?} */
    const rightBorderWidth = constraint['borderRight'] ? constraint['borderRight'] : 0;
    /** @type {?} */
    const borderLength = leftBorderWidth + contentBox.width + rightBorderWidth;
    /** @type {?} */
    const bottomBorder = (/** @type {?} */ (document.createElementNS(SVG_NS, 'line')));
    bottomBorder.setAttribute('x1', `${0}`);
    bottomBorder.setAttribute('y1', `${topBorderWidth + contentBox.height + bottomBorderWidth / 2.0}`);
    bottomBorder.setAttribute('x2', `${leftBorderWidth + contentBox.width + rightBorderWidth}`);
    bottomBorder.setAttribute('y2', `${topBorderWidth + contentBox.height + bottomBorderWidth / 2.0}`);
    bottomBorder.setAttribute('stroke-width', bottomBorderWidth.toString());
    bottomBorder.setAttribute('stroke', get(constraint, 'borderBottomColor', BoxModelConstants.DEFAULT_BORDER_COLOR));
    borderGroup.appendChild(bottomBorder);
    return contentBox;
});
/** @type {?} */
const applyLeftBorder = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @param {?} borderGroup
 * @return {?}
 */
function (contentBox, constraint, borderGroup) {
    /** @type {?} */
    const leftBorderWidth = constraint['borderLeft'];
    if (!borderGroup || !(leftBorderWidth !== undefined && leftBorderWidth > 0))
        return contentBox;
    /** @type {?} */
    const topBorderWidth = constraint['borderTop'] ? constraint['borderTop'] : 0;
    /** @type {?} */
    const bottomBorderWidth = constraint['borderBottom'] ? constraint['borderBottom'] : 0;
    /** @type {?} */
    const borderLength = topBorderWidth + contentBox.height + bottomBorderWidth;
    /** @type {?} */
    const leftBorder = (/** @type {?} */ (document.createElementNS(SVG_NS, 'line')));
    leftBorder.setAttribute('x1', `${leftBorderWidth / 2.0}`);
    leftBorder.setAttribute('y1', '0');
    leftBorder.setAttribute('x2', `${leftBorderWidth / 2.0}`);
    leftBorder.setAttribute('y2', `${topBorderWidth + contentBox.height + bottomBorderWidth}`);
    leftBorder.setAttribute('stroke-width', leftBorderWidth.toString());
    leftBorder.setAttribute('stroke', get(constraint, 'borderLeftColor', BoxModelConstants.DEFAULT_BORDER_COLOR));
    borderGroup.appendChild(leftBorder);
    return contentBox;
});
/** @type {?} */
const applyRightBorder = (/**
 * @template T
 * @param {?} contentBox
 * @param {?} constraint
 * @param {?} borderGroup
 * @return {?}
 */
function (contentBox, constraint, borderGroup) {
    /** @type {?} */
    const rightBorderWidth = constraint['borderRight'] ? constraint['borderRight'] : 0;
    if (!borderGroup || !(rightBorderWidth !== undefined && rightBorderWidth > 0))
        return contentBox;
    /** @type {?} */
    const leftBorderWidth = constraint['borderLeft'] ? constraint['borderLeft'] : 0;
    /** @type {?} */
    const topBorderWidth = constraint['borderTop'] ? constraint['borderTop'] : 0;
    /** @type {?} */
    const bottomBorderWidth = constraint['borderBottom'] ? constraint['borderBottom'] : 0;
    /** @type {?} */
    const borderLength = topBorderWidth + contentBox.height + bottomBorderWidth;
    /** @type {?} */
    const rightBorder = (/** @type {?} */ (document.createElementNS(SVG_NS, 'line')));
    rightBorder.setAttribute('x1', `${leftBorderWidth + contentBox.width + rightBorderWidth / 2.0}`);
    rightBorder.setAttribute('y1', `${0}`);
    rightBorder.setAttribute('x2', `${leftBorderWidth + contentBox.width + rightBorderWidth / 2.0}`);
    rightBorder.setAttribute('y2', `${topBorderWidth + contentBox.height + bottomBorderWidth}`);
    rightBorder.setAttribute('stroke-width', rightBorderWidth.toString());
    rightBorder.setAttribute('stroke', get(constraint, 'borderRightColor', BoxModelConstants.DEFAULT_BORDER_COLOR));
    borderGroup.appendChild(rightBorder);
    return contentBox;
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConstraintValidationResponse {
    /**
     * @param {?=} isValid
     * @param {?=} messageQueue
     */
    constructor(isValid = false, messageQueue = []) {
        this.isValid = isValid;
        this.messageQueue = messageQueue;
    }
}
class BoxModel {
    /**
     * Creates an instance of an object that provides functionality semantically equivalent to a subset of the Basic Box Model.
     * \@memberof BoxModel
     * @param {?=} boxConstraints
     */
    constructor(boxConstraints) {
        /** @type {?} */
        const constraint = Object.assign(Object.assign((/** @type {?} */ ({})), new BoxModelConstraint()), boxConstraints);
        /** @type {?} */
        const validationResponse = this.isConstraintInvalid(constraint);
        if (!validationResponse.isValid && validationResponse.messageQueue.length) {
            /** @type {?} */
            let errorMessage = '';
            validationResponse.messageQueue.forEach((/**
             * @param {?} messageFragment
             * @return {?}
             */
            messageFragment => (errorMessage = errorMessage.concat(messageFragment))));
            throw new Error(errorMessage);
        }
        this.constraint = constraint;
    }
    /**
     * @param {?} parent
     * @param {?} overrides
     * @return {?}
     */
    evaluateContext(parent, overrides) {
        if (!parent) {
            parent = {};
        }
        /** @type {?} */
        const context = Object.assign(Object.assign(Object.assign({}, parent), { useFullWidth: this.constraint.useFullWidth, useFullHeight: this.constraint.useFullHeight }), overrides);
        context.parentConstraints = this.constraint;
        return context;
    }
    /**
     * Checks that the supplied constraint object is not configured with unacceptable values.
     * \@memberof BoxModel
     * @private
     * @param {?} constraint
     * @return {?}
     */
    isConstraintInvalid(constraint) {
        /** @type {?} */
        const validationResponse = new ConstraintValidationResponse(true);
        /**
         * It is valid that there are no constraints to manage.
         * For example if no padding / boarders / margins are required and the
         * authors intent is that height and width are driven by accommodating
         * content dimensions.
         */
        if (!constraint)
            return validationResponse;
        Object.keys(constraint).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            /** @type {?} */
            const val = constraint[key];
            if (typeof val === 'undefined' && !this.isOptional(key)) {
                validationResponse.isValid = false;
                validationResponse.messageQueue.push(`Bad input encountered while validating box model constraint:\nProperty ${key} was undefined but is mandatory.\n`);
            }
            else if (!this.isStringBased(key)) {
                /** @type {?} */
                const valNum = constraint[key];
                if (valNum < 0) {
                    validationResponse.isValid = false;
                    validationResponse.messageQueue.push(`Bad input encountered while validating box model constraint:\nProperty ${key} had value: ${valNum}.\n`);
                }
            }
        }));
        if (!validationResponse.isValid) {
            validationResponse.messageQueue.push(`Permitted values are either undefined or a non-negative pixel value 0 ... 10.5 etc.\nNote:
				Fractional pixel values are only tolerated since some values are computed based on division of remaining space.\n`);
        }
        return validationResponse;
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    isOptional(key) {
        return key === 'width' || key === 'height' || key === 'proportion' || key === 'backgroundColor' || key === 'borderRadius';
    }
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    isStringBased(key) {
        return key === 'backgroundColor';
    }
    /**
     * @template T
     * @param {?} contentBox
     * @param {?=} isCellPanel
     * @return {?}
     */
    applyTo(contentBox, isCellPanel) {
        if (contentBox.isEmpty()) {
            return new PublicContentBox(contentBox.element, 0, 0, this.constraint);
        }
        /** @type {?} */
        let r = 150 + Math.random() * 105;
        /** @type {?} */
        let g = 150 + Math.random() * 105;
        /** @type {?} */
        let b = 150 + Math.random() * 105;
        /** @type {?} */
        let newContentBox = contentBox;
        if (BoxModel.PDF_DEBUG) {
            newContentBox = this.createBoxShadow(newContentBox, `rgba(${r},${g},${b},0.2`, undefined, 'content');
            r -= 75;
            g -= 75;
            b -= 75;
        }
        newContentBox = this.applyPadding(newContentBox);
        if (BoxModel.PDF_DEBUG) {
            newContentBox = this.createBoxShadow(newContentBox, `rgba(${r},${g},${b},0.6`, undefined, 'padding');
            r -= 75;
            g -= 75;
            b -= 75;
        }
        newContentBox = this.applyBorderAndBackground(newContentBox, isCellPanel);
        newContentBox = this.applyMargin(newContentBox);
        if (BoxModel.PDF_DEBUG) {
            newContentBox = this.createBoxShadow(newContentBox, `rgba(${r},${g},${b},1`, undefined, 'margin');
        }
        return new PublicContentBox(newContentBox.element, newContentBox.width, newContentBox.height, this.constraint);
    }
    /**
     * @private
     * @template T
     * @param {?} contentBox
     * @param {?} backgroundString
     * @param {?=} radius
     * @param {?=} classname
     * @param {?=} backgroundShape
     * @return {?}
     */
    createBoxShadow(contentBox, backgroundString, radius, classname, backgroundShape = 'rect') {
        /** @type {?} */
        const group = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        /** @type {?} */
        const background = (/** @type {?} */ (document.createElementNS(SVG_NS, backgroundShape)));
        background.setAttribute('width', contentBox.width.toFixed(1));
        background.setAttribute('height', contentBox.height.toFixed(1));
        if (backgroundShape === 'rect') {
            background.setAttribute('style', `fill:${backgroundString}`);
            if (radius > 0) {
                background.setAttribute('rx', radius.toFixed(1));
                background.setAttribute('ry', radius.toFixed(1));
            }
        }
        else if (backgroundShape === 'circle') {
            background.setAttribute('style', `fill:${backgroundString}`);
            if (radius > 0 && (radius <= contentBox.width / 2 && radius <= contentBox.height / 2)) {
                background.setAttribute('cx', String(contentBox.width / 2));
                background.setAttribute('cy', String(contentBox.height / 2));
                background.setAttribute('r', String(radius));
            }
            else {
                console.warn('You need to pass a borderRadius to the BoxModelConstraint if you want a circle as backgroundShape. The borderRadius should not be bigger than half of the width/height of the contentBox getting passed');
            }
        }
        group.appendChild(background);
        group.appendChild(contentBox.element);
        if (classname) {
            background.setAttribute('class', classname);
        }
        return (/** @type {?} */ (new ContentBox(group, contentBox.width, contentBox.height)));
    }
    /**
     * @template T
     * @param {?} contentBox
     * @param {?=} isCellPanel
     * @return {?}
     */
    applyBackground(contentBox, isCellPanel) {
        if (this.constraint.backgroundColor) {
            contentBox = this.createBoxShadow((/** @type {?} */ (contentBox)), this.constraint.backgroundColor, this.constraint.borderRadius, 'background', this.constraint.backgroundShape);
            // Keep positional sync of the background to border translations
            /** @type {?} */
            let additionalHeight = 0;
            /** @type {?} */
            let additionalWidth = 0;
            if (has(this.constraint, 'borderTop')) {
                additionalHeight += this.constraint['borderTop'];
            }
            if (has(this.constraint, 'borderLeft')) {
                additionalWidth += this.constraint['borderLeft'];
            }
            // CellPanel hardcodes padding constraints to 1,1,1,1 so updating translation here
            if (isCellPanel) {
                additionalHeight += 1;
                additionalWidth += 1;
            }
            if (additionalHeight > 0 || additionalWidth > 0) {
                SVGUtils.updateTranslate(additionalWidth, additionalHeight, contentBox.element.firstElementChild);
            }
            return contentBox;
        }
        else {
            return contentBox;
        }
    }
    /**
     * @param {?=} outerWidthConstraint
     * @param {?=} outerHeightConstraint
     * @return {?}
     */
    getChildViewConstraints(outerWidthConstraint, outerHeightConstraint) {
        /** @type {?} */
        const childWidthConstraint = this.getWidthConstraints(outerWidthConstraint);
        /** @type {?} */
        const childHeightConstraint = this.getHeightConstraints(outerHeightConstraint);
        return [childWidthConstraint, childHeightConstraint];
    }
    /**
     * @private
     * @param {?} outerHeightConstraint
     * @return {?}
     */
    getHeightConstraints(outerHeightConstraint) {
        /** @type {?} */
        let childHeightConstraint = null;
        if (typeof outerHeightConstraint === 'number' && outerHeightConstraint >= 0) {
            if (typeof this.constraint.height === 'number') {
                childHeightConstraint = Math.min(outerHeightConstraint, this.constraint.height);
            }
            else {
                childHeightConstraint = outerHeightConstraint;
            }
        }
        else if (typeof this.constraint.height === 'number') {
            childHeightConstraint = this.constraint.height;
        }
        if (typeof childHeightConstraint !== 'number') {
            throw new Error('Constraint undefined');
        }
        childHeightConstraint -=
            this.constraint.borderTop +
                this.constraint.borderBottom +
                this.constraint.paddingTop +
                this.constraint.paddingBottom +
                this.constraint.marginTop +
                this.constraint.marginBottom;
        return isNaN(childHeightConstraint) || childHeightConstraint === undefined ? undefined : childHeightConstraint;
    }
    /**
     * @private
     * @param {?} outerWidthConstraint
     * @return {?}
     */
    getWidthConstraints(outerWidthConstraint) {
        /** @type {?} */
        let childWidthConstraint = null;
        if (typeof outerWidthConstraint === 'number' && outerWidthConstraint >= 0) {
            if (typeof this.constraint.width === 'number') {
                childWidthConstraint = Math.min(outerWidthConstraint, this.constraint.width);
            }
            else {
                childWidthConstraint = outerWidthConstraint;
            }
        }
        else if (typeof this.constraint.width === 'number') {
            childWidthConstraint = this.constraint.width;
        }
        if (typeof childWidthConstraint !== 'number') {
            throw new Error('Constraint undefined');
        }
        childWidthConstraint -=
            this.constraint.borderLeft +
                this.constraint.borderRight +
                this.constraint.paddingLeft +
                this.constraint.paddingRight +
                this.constraint.marginLeft +
                this.constraint.marginRight;
        return isNaN(childWidthConstraint) || childWidthConstraint === undefined ? undefined : childWidthConstraint;
    }
    /**
     * @private
     * @template T
     * @param {?} contentBox
     * @return {?}
     */
    applyPadding(contentBox) {
        /** @type {?} */
        let additionalHeight = 0;
        /** @type {?} */
        let additionalWidth = 0;
        if (has(this.constraint, 'paddingTop')) {
            additionalHeight += this.constraint['paddingTop'];
        }
        if (has(this.constraint, 'paddingLeft')) {
            additionalWidth += this.constraint['paddingLeft'];
        }
        if (additionalHeight > 0 || additionalWidth > 0) {
            if (contentBox.element.tagName !== 'G') {
                /** @type {?} */
                const g = document.createElementNS(SVG_NS, 'g');
                g.appendChild(contentBox.element);
                contentBox = (/** @type {?} */ (new ContentBox(g, contentBox.width, contentBox.height)));
            }
            SVGUtils.updateTranslate(additionalWidth, additionalHeight, contentBox.element);
        }
        if (has(this.constraint, 'paddingBottom')) {
            additionalHeight += this.constraint['paddingBottom'];
        }
        if (has(this.constraint, 'paddingRight')) {
            additionalWidth += this.constraint['paddingRight'];
        }
        return ContentBoxBuilder.with(contentBox)
            .addDimensions(additionalWidth, additionalHeight)
            .get();
    }
    /**
     * @private
     * @template T
     * @param {?} contentBox
     * @param {?=} isCellPanel
     * @return {?}
     */
    applyBorderAndBackground(contentBox, isCellPanel) {
        /** @type {?} */
        const contentWithBorder = setupBorders(contentBox, this.constraint);
        contentBox = this.applyBackground(contentWithBorder, isCellPanel);
        /** @type {?} */
        let additionalHeight = 0;
        /** @type {?} */
        let additionalWidth = 0;
        if (has(this.constraint, 'borderTop')) {
            additionalHeight += this.constraint['borderTop'];
        }
        if (has(this.constraint, 'borderLeft')) {
            additionalWidth += this.constraint['borderLeft'];
        }
        if (additionalHeight > 0 || additionalWidth > 0) {
            if (contentBox.element.tagName !== 'G') {
                /** @type {?} */
                const g = document.createElementNS(SVG_NS, 'g');
                g.appendChild(contentBox.element);
                contentBox = (/** @type {?} */ (new ContentBox(g, contentBox.width, contentBox.height)));
            }
            SVGUtils.updateTranslate(additionalWidth, additionalHeight, contentBox.element);
        }
        if (has(this.constraint, 'borderBottom')) {
            additionalHeight += this.constraint['borderBottom'];
        }
        if (has(this.constraint, 'borderRight')) {
            additionalWidth += this.constraint['borderRight'];
        }
        return ContentBoxBuilder.with(contentBox)
            .addDimensions(additionalWidth, additionalHeight)
            .get();
    }
    /**
     * @private
     * @template T
     * @param {?} contentBox
     * @return {?}
     */
    applyMargin(contentBox) {
        /** @type {?} */
        let additionalHeight = 0;
        /** @type {?} */
        let additionalWidth = 0;
        if (has(this.constraint, 'marginTop')) {
            additionalHeight += this.constraint['marginTop'];
        }
        if (has(this.constraint, 'marginLeft')) {
            additionalWidth += this.constraint['marginLeft'];
        }
        if (additionalHeight > 0 || additionalWidth > 0) {
            if (contentBox.element.tagName !== 'G') {
                /** @type {?} */
                const g = document.createElementNS(SVG_NS, 'g');
                g.appendChild(contentBox.element);
                contentBox = (/** @type {?} */ (new ContentBox(g, contentBox.width, contentBox.height)));
            }
            SVGUtils.updateTranslate(additionalWidth, additionalHeight, contentBox.element);
        }
        if (has(this.constraint, 'marginBottom')) {
            additionalHeight += this.constraint['marginBottom'];
        }
        if (has(this.constraint, 'marginRight')) {
            additionalWidth += this.constraint['marginRight'];
        }
        return ContentBoxBuilder.with(contentBox)
            .addDimensions(additionalWidth, additionalHeight)
            .get();
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getConstraintValue(name) {
        return this.constraint[name];
    }
}
BoxModel.PDF_DEBUG = window.location.href.indexOf('pdfBoundaries') > 0;
BoxModel.PDF_TIME = window.location.href.indexOf('pdfTime') > 0 || window.location.href.indexOf('localhost') > 0;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
/**
 * @abstract
 * @template T
 */
class AbstractRenderer {
    /**
     * @param {?=} constraint max width, max height, borders, margins, padding. they are all optional. If undefined, width and height will be defined at the page content sizes.
     */
    constructor(constraint) {
        // To enable when we are finalising abstract renderers that have useFullHeight
        this._finalising = false;
        this._boxModel = new BoxModel(constraint);
    }
    /**
     * @param {?} svc
     * @return {?}
     */
    static set contentProvider(svc) {
        AbstractRenderer._contentProviderInstance = svc;
    }
    /**
     * @return {?}
     */
    get contentProvider() {
        return AbstractRenderer._contentProviderInstance;
    }
    /**
     * This is the main public method allowing for rendering of the renderer, it'll yield rendered SVG Dom element along with it's dimension.
     *
     * **NOTE** this method is strictly final - do NOT override this method.
     * @param {?} context
     * @return {?}
     */
    render(context) {
        const [childWidthConstraint, childHeightConstraint] = this._boxModel.getChildViewConstraints(context.availableWidth, context.availableHeight);
        /** @type {?} */
        let result;
        if (Math.min(childWidthConstraint, childHeightConstraint) <= 0) {
            throw new Error(`The generated content doesn't fit within set constraints ${childWidthConstraint}x${childHeightConstraint}.`);
        }
        else {
            /** @type {?} */
            const overrides = {
                availableWidth: childWidthConstraint,
                availableHeight: childHeightConstraint
            };
            /** @type {?} */
            const startTime = new Date();
            /** @type {?} */
            const innerContent = this.renderContent(this._boxModel.evaluateContext(context, overrides));
            /** @type {?} */
            const endTime = new Date();
            /** @type {?} */
            const timeTaken = endTime.getTime() - startTime.getTime();
            if (BoxModel.PDF_TIME && timeTaken > 50) {
                console.warn(`PDF Rendering time ${this.constructor.name} took ${timeTaken}ms.`, innerContent.element);
            }
            if (Math.floor(innerContent.width) > childWidthConstraint || Math.floor(innerContent.height) > childHeightConstraint) {
                throw new Error(`The generated content ${innerContent.width}x${innerContent.height} doesn't fit within set constraints ${childWidthConstraint}x${childHeightConstraint}.`);
            }
            result = this._boxModel.applyTo(innerContent, !!this['_isCellPanel']);
        }
        if (BoxModel.PDF_DEBUG) {
            result.element.setAttribute('data-type', this.constructor.name);
        }
        return result;
    }
    /**
     * @return {?}
     */
    get useFullHeight() {
        return !!this._boxModel.getConstraintValue('useFullHeight');
    }
    /**
     * @return {?}
     */
    get useFullWidth() {
        return !!this._boxModel.getConstraintValue('useFullHeight');
    }
    /**
     * @return {?}
     */
    get newPage() {
        return !!this._boxModel.getConstraintValue('newPage');
    }
    /**
     * @return {?}
     */
    get finalising() {
        try {
            return this._finalising;
        }
        finally {
            // set to false after flag is returned if flag was true to avoid side effects
            if (this._finalising) {
                this._finalising = false;
            }
        }
    }
    /**
     * @return {?}
     */
    finalise() {
        this._finalising = true;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlignmentStore {
    /**
     * @param {?} hAlign
     * @param {?} vAlign
     * @param {?} contentBox
     * @param {?} widthConstraint
     * @param {?} abstractRenderer
     * @param {?=} xOffset
     * @param {?=} yOffset
     */
    constructor(hAlign, vAlign, contentBox, widthConstraint, abstractRenderer, xOffset, yOffset) {
        this.hAlign = hAlign;
        this.vAlign = vAlign;
        this.contentBox = contentBox;
        this.widthConstraint = widthConstraint;
        this.abstractRenderer = abstractRenderer;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
    }
}
class LayoutManager {
    /**
     * @param {?} layoutStrategy
     */
    constructor(layoutStrategy // private horizontalAlignment: Alignment.Horizontal = Alignment.Horizontal.Center, // private verticalAlignment: Alignment.Vertical = Alignment.Vertical.Top
    ) {
        this.layoutStrategy = layoutStrategy;
        this.cursorX = 0;
        this.cursorY = 0;
        this.usedWidth = 0;
        this.usedHeight = 0;
        // Maximum content height
        this.alignmentStoreArray = [];
    }
    /**
     * @param {?} proposedComponent
     * @param {?=} remainingWidth
     * @param {?=} remainingHeight
     * @return {?}
     */
    canAccommodateContentBox(proposedComponent, remainingWidth = this.getRemainingWidth(), remainingHeight = this.getRemainingHeight()) {
        return Math.floor(proposedComponent.height) <= remainingHeight && Math.floor(proposedComponent.width) <= remainingWidth;
    }
    /**
     * @param {?} proposedComponent
     * @param {?=} hAlign
     * @param {?=} vAlign
     * @param {?=} withUseFullHeight
     * @param {?=} context
     * @return {?}
     */
    updatePositionAndCursor(proposedComponent, hAlign = Alignment.Horizontal.Left, vAlign = Alignment.Vertical.Top, withUseFullHeight = false, context) {
        this.throwIfUndefined(proposedComponent);
        if (this.canAccommodateContentBox(proposedComponent)) {
            if (withUseFullHeight) {
                // Applies for both ROW and COLUMN
                SVGUtils.updateTranslate(this.getXOffset(hAlign, proposedComponent), this.getYOffset(vAlign, proposedComponent, context.availableHeight), proposedComponent.element);
                this.usedHeight = context.availableHeight;
                this.usedWidth = Math.max(this.usedWidth, this.getXOffset(hAlign, proposedComponent) + proposedComponent.width);
            }
            else {
                switch (this.layoutStrategy) {
                    case LayoutStrategy.ROW: {
                        /** @type {?} */
                        const xTranslation = this.cursorX + get(context, 'parentConstraints.borderLeft', 0);
                        SVGUtils.updateTranslate(xTranslation, this.getYOffset(vAlign, proposedComponent), proposedComponent.element);
                        this.usedHeight = Math.max(this.usedHeight, this.getYOffset(vAlign, proposedComponent) + proposedComponent.height);
                        this.usedWidth = Math.max(this.usedWidth, this.cursorX + proposedComponent.width);
                        break;
                    }
                    case LayoutStrategy.COLUMN: {
                        /** @type {?} */
                        const yTranslation = this.cursorY + get(context, 'parentConstraints.borderTop', 0);
                        SVGUtils.updateTranslate(this.getXOffset(hAlign, proposedComponent), yTranslation, proposedComponent.element);
                        this.usedHeight = Math.max(this.usedHeight, this.cursorY + proposedComponent.height);
                        this.usedWidth = Math.max(this.usedWidth, this.getXOffset(hAlign, proposedComponent) + proposedComponent.width);
                        break;
                    }
                    default: {
                        throw new LayoutError(`Unhandled layout strategy of: ${this.layoutStrategy}, please update the layout manager for best layout results.`);
                    }
                }
            }
            this.updateRemainingSpace(proposedComponent);
            return proposedComponent;
        }
    }
    /**
     * @param {?} proposedComponent
     * @param {?} hAlign
     * @param {?} vAlign
     * @param {?} cellPanel
     * @param {?} fixedWidthDimension
     * @return {?}
     */
    updatePositionAndCursorForTable(proposedComponent, hAlign, vAlign, cellPanel, fixedWidthDimension) {
        this.throwIfUndefined(proposedComponent);
        if (this.canAccommodateContentBox(proposedComponent, fixedWidthDimension)) {
            switch (this.layoutStrategy) {
                case LayoutStrategy.ROW: {
                    /** @type {?} */
                    const xOffset = this.getXOffset(hAlign, proposedComponent, fixedWidthDimension);
                    this.alignmentStoreArray.push(new AlignmentStore(hAlign, vAlign, proposedComponent, fixedWidthDimension, cellPanel, xOffset));
                    break;
                }
                case LayoutStrategy.COLUMN: {
                    // TODO haven't looked yet
                    break;
                }
                default: {
                    throw new LayoutError(`Unhandled layout strategy of: ${this.layoutStrategy}, please update the layout manager for best layout results.`);
                }
            }
            this.updateFixedSpace(fixedWidthDimension);
            return proposedComponent;
        }
    }
    /**
     * To be used when we are not using fixed proportions for panel rendering, and we use elements' real widths/heights to stack them
     * @private
     * @param {?} component contentBox of the element that we have rendered
     * @param {?=} context
     * @return {?}
     */
    updateRemainingSpace(component, context) {
        switch (this.layoutStrategy) {
            case LayoutStrategy.ROW: {
                this.cursorX += component.width;
                break;
            }
            case LayoutStrategy.COLUMN: {
                if (context) {
                    this.cursorY += context.availableHeight;
                }
                else {
                    this.cursorY += component.height;
                }
                break;
            }
            default: {
                throw new LayoutError(`Unhandled layout strategy of: ${this.layoutStrategy}, please update the layout manager for best layout results.`);
            }
        }
    }
    /**
     * To be used when we are not updating spaces by contentBoxes' real size, but when we are dealing with proportional/fixed dimensions calculated by convertProportionsIntoPixels
     * @param {?} fixedDimension
     * @return {?}
     */
    updateFixedSpace(fixedDimension) {
        switch (this.layoutStrategy) {
            case LayoutStrategy.ROW: {
                this.cursorX += fixedDimension;
                break;
            }
            case LayoutStrategy.COLUMN: {
                this.cursorY += fixedDimension;
                break;
            }
            default: {
                throw new LayoutError(`Unhandled layout strategy of: ${this.layoutStrategy}, please update the layout manager for best layout results.`);
            }
        }
    }
    /**
     * @return {?}
     */
    resetSpace() {
        this.cursorX = 0;
        this.cursorY = 0;
    }
    /**
     * @return {?}
     */
    getUsedSpace() {
        switch (this.layoutStrategy) {
            case LayoutStrategy.ROW: {
                return {
                    usedWidth: this.usedWidth,
                    usedHeight: this.usedHeight // TODO This is wrong for row panels - need to revisit
                };
            }
            case LayoutStrategy.COLUMN: {
                return {
                    usedWidth: this.usedWidth,
                    usedHeight: this.usedHeight
                };
            }
            default: {
                throw new LayoutError(`Unhandled layout strategy of: ${this.layoutStrategy}, please update the layout manager for best layout results.`);
            }
        }
    }
    /**
     * @private
     * @param {?} alignment
     * @param {?} proposedComponent
     * @param {?=} widthConstraint
     * @return {?}
     */
    getXOffset(alignment, proposedComponent, widthConstraint = this.getRemainingWidth()) {
        switch (alignment) {
            case Alignment.Horizontal.Left: {
                return this.cursorX;
            }
            case Alignment.Horizontal.Center: {
                return Math.floor((widthConstraint - proposedComponent.width) / 2) + this.cursorX;
            }
            case Alignment.Horizontal.Right: {
                return widthConstraint - proposedComponent.width + this.cursorX;
            }
            default: {
                console.warn(`Alignment property: ${alignment} not handled, defaulting to left alignment!`);
                return 0;
            }
        }
    }
    /**
     * @private
     * @param {?} alignment
     * @param {?} proposedComponent
     * @param {?=} heightConstraint
     * @return {?}
     */
    getYOffset(alignment, proposedComponent, heightConstraint = this.getRemainingHeight()) {
        switch (alignment) {
            case Alignment.Vertical.Top: {
                return 0;
            }
            case Alignment.Vertical.Middle: {
                return Math.floor((heightConstraint - proposedComponent.height) / 2);
            }
            case Alignment.Vertical.Bottom: {
                return heightConstraint - proposedComponent.height;
            }
            default: {
                console.warn(`Alignment property: ${alignment} not handled, defaulting to left alignment!`);
                return 0;
            }
        }
    }
    /**
     * Sets the layout manager's maximum content width and height. Must be called before using the layout manager;
     * @param {?} maxWidth maximum allowed content width on the page
     * @param {?} maxHeight maximum allowed content height on the page
     * @return {?}
     */
    setLayoutSize(maxWidth, maxHeight) {
        this.maxHeight = maxHeight;
        this.maxWidth = maxWidth;
    }
    /**
     * @return {?}
     */
    getRemainingHeight() {
        return this.maxHeight - this.cursorY;
    }
    /**
     * @return {?}
     */
    getRemainingWidth() {
        return this.maxWidth - this.cursorX;
    }
    /**
     * @param {?} context
     * @param {?} proportions
     * @return {?}
     */
    convertProportionsIntoPixels(context, proportions) {
        /** @type {?} */
        const proportionsInPixels = [];
        /** @type {?} */
        const proportionsSum = proportions.reduce((/**
         * @param {?} sum
         * @param {?} proportion
         * @return {?}
         */
        (sum, proportion) => sum + proportion), 0);
        if (proportionsSum < 99.999 || proportionsSum > 100.001) {
            throw new Error(`Proportions of childArtefacts within a panel needs to either not be defined at all, or sum up to 100, current sum is ${proportionsSum}`);
        }
        proportions.forEach((/**
         * @param {?} proportion
         * @return {?}
         */
        proportion => {
            switch (this.layoutStrategy) {
                case LayoutStrategy.ROW:
                    proportionsInPixels.push((proportion * context.availableWidth) / 100);
                    break;
                case LayoutStrategy.COLUMN:
                    proportionsInPixels.push((proportion * context.availableHeight) / 100);
                    break;
            }
        }));
        return [proportionsInPixels, this.layoutStrategy];
    }
    /**
     * @param {?} element
     * @param {?} context
     * @param {?} vAlignment
     * @param {?} hAlignment
     * @return {?}
     */
    finaliseAlignment(element, context, vAlignment, hAlignment) {
        switch (this.layoutStrategy) {
            case LayoutStrategy.ROW:
                /** @type {?} */
                let rerenderOccured = false;
                this.alignmentStoreArray.forEach((/**
                 * @param {?} cell
                 * @param {?} i
                 * @return {?}
                 */
                (cell, i) => {
                    if (cell.abstractRenderer.useFullHeight) {
                        cell.abstractRenderer.childArtifacts[0].finalise();
                        /** @type {?} */
                        const contentBox = cell.abstractRenderer.render(Object.assign(Object.assign({}, context), {
                            availableWidth: cell.widthConstraint,
                            availableHeight: this.getHighestCell(),
                            verticalAlign: vAlignment,
                            horizontalAlign: hAlignment
                        }));
                        element.appendChild(contentBox.element);
                        this.alignmentStoreArray[i].contentBox = contentBox;
                        rerenderOccured = true;
                    }
                    // TODO maybe move appendCHild logic for all elements here
                    cell.yOffset = this.getYOffset(cell.vAlign, cell.contentBox, this.getHighestCell());
                    SVGUtils.updateTranslate(cell.xOffset, cell.yOffset, (/** @type {?} */ (Array.from(element.childNodes).filter((/**
                     * @param {?} node
                     * @return {?}
                     */
                    node => node.nodeType === 1))[i])));
                    this.usedHeight = Math.max(this.usedHeight, cell.yOffset + cell.contentBox.height);
                    this.usedWidth = Math.max(this.usedWidth, cell.xOffset + cell.contentBox.width);
                }));
                if (rerenderOccured) {
                    this.usedHeight = Math.max(...this.alignmentStoreArray.map((/**
                     * @param {?} cell
                     * @return {?}
                     */
                    cell => cell.contentBox.height + cell.yOffset)));
                    this.usedWidth = Math.max(...this.alignmentStoreArray.map((/**
                     * @param {?} cell
                     * @return {?}
                     */
                    cell => cell.contentBox.width + cell.xOffset)));
                }
                break;
        }
        return element;
    }
    /**
     * @return {?}
     */
    getHighestCell() {
        /** @type {?} */
        let maxHeightElementY = 0;
        /** @type {?} */
        const everyRowUseFullHeight = this.alignmentStoreArray.every((/**
         * @param {?} elem
         * @return {?}
         */
        elem => elem.abstractRenderer.useFullHeight));
        this.alignmentStoreArray.forEach((/**
         * @param {?} cell
         * @return {?}
         */
        cell => {
            if (maxHeightElementY < cell.contentBox.height && (!cell.abstractRenderer.useFullHeight || everyRowUseFullHeight)) {
                maxHeightElementY = cell.contentBox.height;
            }
        }));
        // TODO fall back to fullHeight to cover for if we only encounter hasFullHeight = true
        return maxHeightElementY;
    }
    /**
     * @private
     * @param {?} proposedComponent
     * @return {?}
     */
    throwIfUndefined(proposedComponent) {
        if (!proposedComponent) {
            throw new LayoutError('Proposed components were undefined!');
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Panel class
 *
 * **DO NOT USE THIS CLASS DIRECTLY IN YOUR CODE** please use RowPanel or ColumnPanel directly.
 *
 * Please consider this class final for regular component usage and shouldn't be extended other than extending framework.
 * The goal of this class is to correctly position, manage a layout composition of nested children components and calculate
 * the size used of all the child renderers within the specified layout.
 *
 */
class Panel extends AbstractRenderer {
    /**
     * @param {?} name The name of the panel.
     * @param {?} layoutStrategy
     * @param {?=} childArtifacts The children of this panel - for example other panels that further segment the view,
     * or AbstractRenderers that could be considered leaf nodes of the layout tree.
     * @param {?=} boxModelConstraints
     * @param {?=} horizontalAlignment Specifies whether children of this layout should be Left / Center / Right aligned (Defaults to Center).
     * @param {?=} verticalAlignment Specifies whether children of this layout should be Top / Middle / Bottom aligned (Defaults to Middle).
     * @param {?=} _isCellPanel
     */
    constructor(name, layoutStrategy, childArtifacts, boxModelConstraints, horizontalAlignment = Alignment.Horizontal.Center, verticalAlignment = Alignment.Vertical.Top, _isCellPanel = false) {
        super(boxModelConstraints);
        this.layoutStrategy = layoutStrategy;
        this.horizontalAlignment = horizontalAlignment;
        this.verticalAlignment = verticalAlignment;
        this._isCellPanel = _isCellPanel;
        /**
         * The children of this panel - for example other panels that further segment the view, or AbstractRenderers that could be considered leaf nodes of the layout tree.
         */
        this.childArtifacts = [];
        this._proportion = BoxModelConstraint.merge({}, boxModelConstraints).proportion;
        this.name = name;
        this.childArtifacts = childArtifacts ? childArtifacts : [];
        if (this.childArtifacts.length && this.childArtifacts.every(this.itHasProportionParam) === false) {
            if (this.childArtifacts.some(this.itHasProportionParam) === true) {
                throw new Error('Please use proportions for either ALL childArtefacts (you might want to do that to create a table) OR for no childArtefacts at all');
            }
        }
    }
    /**
     * To check if an childArtifact element is an instance of AbstractRenderer and if it has proportion defined
     * @private
     * @param {?} child
     * @return {?}
     */
    itHasProportionParam(child) {
        return child instanceof Panel && ((/** @type {?} */ (child)))._proportion > 0;
    }
    /**
     * Once all AbstractRenderers have been rendered, finalise the template by applying used width and used height
     * @private
     * @param {?} g SVG G Element rendered
     * @return {?}
     */
    finalizePanelTemplate(g) {
        if (!g || (!g.attributes || g.attributes.length > 0) || Array.from(g.childNodes).filter((/**
         * @param {?} node
         * @return {?}
         */
        node => node.nodeType === 1)).length !== 1 || g.tagName !== 'G') {
            return g;
        }
        else {
            return this.finalizePanelTemplate((/** @type {?} */ (Array.from(g.childNodes).filter((/**
             * @param {?} node
             * @return {?}
             */
            node => node.nodeType === 1))[0])));
        }
    }
    /**
     * @return {?}
     */
    finalise() {
        super.finalise();
        this.childArtifacts.forEach((/**
         * @param {?} child
         * @return {?}
         */
        child => {
            child.finalise();
        }));
    }
    /**
     * @return {?}
     */
    getChildArtifacts() {
        return this.childArtifacts;
    }
    /**
     *
     * @param {?} component
     * @param {?} panelTemplate
     * @param {?} abstractRenderer
     * @param {?} context
     * @param {?=} fixedDimension
     * @return {?}
     */
    addContextBox(component, panelTemplate, abstractRenderer, context, fixedDimension) {
        if (component.isEmpty() && fixedDimension) {
            this.layoutManager.updateFixedSpace(fixedDimension);
            return;
        }
        if (this.layoutManager.canAccommodateContentBox(component)) {
            /** @type {?} */
            let updatedComponent;
            try {
                // if we are using proportions
                if (this.childArtifacts.length && this.childArtifacts.every(this.itHasProportionParam)) {
                    updatedComponent = this.layoutManager.updatePositionAndCursorForTable(component, this.horizontalAlignment, this.verticalAlignment, (/** @type {?} */ (abstractRenderer)), fixedDimension);
                }
                else {
                    updatedComponent = this.layoutManager.updatePositionAndCursor(component, this.horizontalAlignment, this.verticalAlignment, false, context);
                }
                // If useFullHeight is true don't append yet - don't apply this logic for non panels
                if (!abstractRenderer.useFullHeight || !(abstractRenderer instanceof Panel) || abstractRenderer.finalising) {
                    panelTemplate.appendChild(updatedComponent.element);
                }
            }
            catch (error) {
                throw new Error(`The ${this.name} panel encountered a layout error:_
				${error.message}`);
            }
        }
        else {
            throw new Error(`Panel: ${this.name} could not accommodate contentBox
			Available Width: ${this.layoutManager.getRemainingWidth()}
			Required Width: ${component.width}
			Available Height: ${this.layoutManager.getRemainingHeight()}
			Required Height: ${component.height}
			`);
        }
    }
    /**
     * @param {?} component
     * @param {?} panelTemplate
     * @param {?} panelContext
     * @return {?}
     */
    addFullHeightContentBox(component, panelTemplate, panelContext) {
        if (this.layoutManager.canAccommodateContentBox(component)) {
            /** @type {?} */
            let updatedComponent;
            try {
                updatedComponent = this.layoutManager.updatePositionAndCursor(component, this.horizontalAlignment, this.verticalAlignment, true, panelContext);
                panelTemplate.appendChild(updatedComponent.element);
            }
            catch (error) {
                throw new Error(`The ${this.name} panel encountered a layout error:_
				${error.message}`);
            }
        }
        else {
            throw new Error(`Panel: ${this.name} could not accommodate contentBox
			Available Width: ${this.layoutManager.getRemainingWidth()}
			Required Width: ${component.width}
			Available Height: ${this.layoutManager.getRemainingHeight()}
			Required Height: ${component.height}
			`);
        }
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        /** @type {?} */
        let panelTemplate = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        this.layoutManager = new LayoutManager(this.layoutStrategy);
        this.layoutManager.setLayoutSize(context.availableWidth, context.availableHeight);
        /** @type {?} */
        let fixedDimensions = [];
        /** @type {?} */
        let layoutStrategy;
        /** @type {?} */
        let usedFullWidth = false;
        if (this.childArtifacts.length && this.childArtifacts.every(this.itHasProportionParam)) {
            [fixedDimensions, layoutStrategy] = this.layoutManager.convertProportionsIntoPixels(context, this.childArtifacts.map((/**
             * @param {?} panel
             * @return {?}
             */
            panel => panel['_proportion'])));
            this.childArtifacts.forEach((/**
             * @param {?} child
             * @param {?} i
             * @return {?}
             */
            (child, i) => {
                switch (layoutStrategy) {
                    case LayoutStrategy.ROW: {
                        /** @type {?} */
                        const contentBox = child.render(Object.assign(Object.assign({}, context), {
                            availableWidth: fixedDimensions[i],
                            availableHeight: this.layoutManager.getRemainingHeight(),
                            useFullWidth: true,
                            verticalAlign: this.verticalAlignment,
                            horizontalAlign: this.horizontalAlignment
                        }));
                        this.addContextBox(contentBox, panelTemplate, child, context, fixedDimensions[i]);
                        break;
                    }
                    case LayoutStrategy.COLUMN: {
                        throw new Error('Proportions for Column Panel has not been implemented yet');
                    }
                }
            }));
            panelTemplate = this.layoutManager.finaliseAlignment(panelTemplate, context, this.verticalAlignment, this.horizontalAlignment);
            usedFullWidth = true;
        }
        else {
            this.childArtifacts.forEach((/**
             * @param {?} child
             * @return {?}
             */
            child => {
                if (child.useFullHeight && child.finalising) {
                    /** @type {?} */
                    const contentBox = child.render(Object.assign(Object.assign({}, context), {
                        availableWidth: this.layoutManager.getRemainingWidth(),
                        availableHeight: context.availableHeight,
                        verticalAlign: this.verticalAlignment,
                        horizontalAlign: this.horizontalAlignment
                    }));
                    this.addFullHeightContentBox(contentBox, panelTemplate, context);
                }
                else {
                    /** @type {?} */
                    const contentBox = child.render(Object.assign(Object.assign({}, context), {
                        availableWidth: this.layoutManager.getRemainingWidth(),
                        availableHeight: this.layoutManager.getRemainingHeight(),
                        verticalAlign: this.verticalAlignment,
                        horizontalAlign: this.horizontalAlignment
                    }));
                    this.addContextBox(contentBox, panelTemplate, child, context);
                }
            }));
        }
        const { usedWidth, usedHeight } = this.layoutManager.getUsedSpace();
        panelTemplate = this.finalizePanelTemplate(panelTemplate);
        if (usedFullWidth) {
            return new ContentBox(panelTemplate, context.availableWidth, usedHeight);
        }
        else {
            return new ContentBox(panelTemplate, usedWidth, usedHeight);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ColumnPanel class - this class allows to position child renderers vertically according to the specified alignment.
 *
 * Please consider this class final for regular component usage and shouldn't be extended other than extending framework.
 * The goal of this class is to correctly position, manage a layout composition of nested children components
 * and calculate the size used of all the child renderers within the specified layout.
 *
 * Sample usage :
 * ```
 * new ColumnPanel('sample table row with 3 equal width cells',[
 * new StaticContentParagraph(null, 'Hello'),new StaticContentParagraph(null, 'World'), new StaticContentParagraph(null, '!')
 * ]);
 * ```
 * Will render as
 * ```
 * Hello
 * World
 * !
 * ```
 * **NOTE:** This class DOES NOT currently support fixed grid layout
 *
 */
class ColumnPanel extends Panel {
    /**
     * @param {?} name
     * @param {?} childArtifacts
     * @param {?=} boxModelConstraint
     * @param {?=} horizontalAlignment
     * @param {?=} verticalAlignment
     */
    constructor(name, childArtifacts, boxModelConstraint, horizontalAlignment = Alignment.Horizontal.Center, verticalAlignment = Alignment.Vertical.Top) {
        super(name, LayoutStrategy.COLUMN, childArtifacts, boxModelConstraint, horizontalAlignment, verticalAlignment);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *  **DO NOT USE THIS CLASS DIRECTLY IN YOUR CODE** unless you are building a table component - this render should always be used as a child renderer of a RowPanel.
 *
 * *Please consider this class final for regular component usage and shouldn't be extended other than extending framework.*
 * *The goal of this class is to correctly position, manage a layout composition of nested children components and calculate
 *  the size used of all the child renderers within the specified layout.*
 *
 * See [[RowPanel]] for more details
 *
 * Sample usage :
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new StaticContentParagraph(null, 'Hello'),new StaticContentParagraph(null, 'World'), new StaticContentParagraph(null, '!')
 * ]);
 * ```
 * Will render as HelloWorld! (with some minor spacing)
 *
 *
 * This class supports fixed grid layout where if all the child renderers are CellPanels & have a proportion constraint specified it will render them accordingly
 *  ie.
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new CellPanel([new StaticContentParagraph(null, 'Cell 1')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 2')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 3')], { proportion: 100 / 3 }, Alignment.Horizontal.Center)
 * ]);
 * ```
 * Furthermore the fixed grid layout has special support for the useFullHeight used by the CellPanels which will allow the designated cell
 * height to be aligned to the tallest cell in the row that doesn't use full height.
 * ie.
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new CellPanel([new StaticContentParagraph(null, 'Cell 1 - let say it has height of 200px')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 2 - let say it has height of 100px')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 3 - this cell will render twice and second time it\'ll receive 200px availableHeight constraint value')],
 * { proportion: 100 / 3, useFullHeight: true }, Alignment.Horizontal.Center)
 * ]);
 * ```
 */
class CellPanel extends Panel {
    /**
     * @param {?} renderers
     * @param {?=} boxModelConstraint
     * @param {?=} horizontalAlignment
     * @param {?=} layout
     * @param {?=} verticalAlignment
     */
    constructor(renderers, boxModelConstraint, horizontalAlignment = Alignment.Horizontal.Center, layout = LayoutStrategy.COLUMN, verticalAlignment = Alignment.Vertical.Top // Vertical Alignment is managed at row level - this is used only for child with useFullHeight
    ) {
        if (!(boxModelConstraint.proportion > 0 && boxModelConstraint.proportion <= 100)) {
            throw new Error(`CellPanel must have a valid proportion constraint 0<${boxModelConstraint.proportion}<100`);
        }
        /** @type {?} */
        const constraints = BoxModelConstraint.merge(boxModelConstraint, { useFullWidth: true, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1 });
        /** @type {?} */
        const childConstraint = {};
        /** @type {?} */
        let childrenRenderers;
        if (constraints.useFullHeight !== undefined) {
            childConstraint.useFullHeight = constraints.useFullHeight;
        }
        if (constraints.useFullWidth !== undefined) {
            childConstraint.useFullWidth = constraints.useFullWidth;
        }
        if (layout === LayoutStrategy.COLUMN) {
            // Once we add the fix to support proportion for column, we can get rid of the wrapper columnPanel
            childrenRenderers = [new ColumnPanel('CellBody', renderers, childConstraint, horizontalAlignment, verticalAlignment)];
        }
        else {
            childrenRenderers = renderers;
        }
        super('Cell', LayoutStrategy.ROW, childrenRenderers, constraints, horizontalAlignment, Alignment.Vertical.Top, // Vertical Alignment is managed at row level, or child ColumnPanel level for AbstractRenderers with useFullHeight - therefore CellPanel is set to Top by default
        true);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Can be used to page break. Has to be used outside of a Panel
 */
class PageBreak extends AbstractRenderer {
    constructor() {
        super();
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        console.warn(`PageBreak.renderContent() Method not implemented -
      if you see this error you might have placed PageBreak in a Panel, which will not trigger a page break.
      PageBreak can only be used outside of a panel`);
        return new ContentBox((/** @type {?} */ (document.createElementNS(SVG_NS, 'g'))), 0, 0);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageType {
}
PageType.LetterPortrait = (/** @type {?} */ ({
    pageWidth: LetterDimensions.WIDTH,
    pageHeight: LetterDimensions.LENGTH,
    contentWidth: LetterDimensions.WIDTH_CONTENT,
    contentHeight: LetterDimensions.LENGTH_CONTENT,
    headerTransform: 'translate(36, 20)',
    footerTransform: `translate(36, 749)`,
    contentHeightPositionOffset: -16
}));
PageType.LetterLandscape = (/** @type {?} */ ({
    pageWidth: LetterDimensions.LENGTH,
    pageHeight: LetterDimensions.WIDTH,
    contentWidth: LetterDimensions.LANDSCAPE_WIDTH_CONTENT,
    contentHeight: LetterDimensions.LANDSCAPE_HEIGHT_CONTENT,
    headerTransform: 'translate(36, 42.5)',
    footerTransform: `translate(36, 579)`,
    contentHeightPositionOffset: 5
}));
PageType.NilePortrait = (/** @type {?} */ ({
    pageWidth: LetterDimensions.WIDTH,
    pageHeight: LetterDimensions.LENGTH,
    contentWidth: LetterDimensions.WIDTH_CONTENT,
    contentHeight: LetterDimensions.NILE_LENGTH_CONTENT,
    headerTransform: 'translate(36, 16)',
    footerTransform: `translate(36, 760)`,
    contentHeightPositionOffset: -7
}));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * RowPanel class - this class allows to position child renderers horizontally according to the specified alignment.
 *
 * Please consider this class final for regular component usage and shouldn't be extended other than extending framework.
 * The goal of this class is to correctly position,
 * manage a layout composition of nested children components and calculate the size used of all the child renderers within the specified layout.
 *
 * Sample usage :
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new StaticContentParagraph(null, 'Hello'),new StaticContentParagraph(null, 'World'), new StaticContentParagraph(null, '!')
 * ]);
 * ```
 * Will render as HelloWorld! (with some minor spacing)
 *
 *
 * This class supports fixed grid layout where if all the child renderers are CellPanels & have a proportion constraint specified it will render them accordingly
 *  ie.
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new CellPanel([new StaticContentParagraph(null, 'Cell 1')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 2')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 3')], { proportion: 100 / 3 }, Alignment.Horizontal.Center)
 * ]);
 * ```
 * Furthermore the fixed grid layout has special support for the useFullHeight used by the CellPanels
 * which will allow the designated cell height to be aligned to the tallest cell in the row that doesn't use full height.
 * ie.
 * ```
 * new RowPanel('sample table row with 3 equal width cells',[
 * new CellPanel([new StaticContentParagraph(null, 'Cell 1 - let say it has height of 200px')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 2 - let say it has height of 100px')], { proportion: 100 / 3 }, Alignment.Horizontal.Center),
 * new CellPanel([new StaticContentParagraph(null, 'Cell 3 - this cell will render twice and second time it\'ll receive 200px availableHeight constraint value')],
 * { proportion: 100 / 3, useFullHeight: true }, Alignment.Horizontal.Center)
 * ]);
 * ```
 *
 */
class RowPanel extends Panel {
    /**
     * @param {?} name
     * @param {?} childArtifacts
     * @param {?=} boxModelConstraint
     * @param {?=} horizontalAlignment
     * @param {?=} verticalAlignment
     */
    constructor(name, childArtifacts, boxModelConstraint, horizontalAlignment = Alignment.Horizontal.Center, verticalAlignment = Alignment.Vertical.Top) {
        super(name, LayoutStrategy.ROW, childArtifacts, boxModelConstraint, horizontalAlignment, verticalAlignment);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BusinessComponentOptions {
    /**
     * @param {?=} componentId
     * @param {?=} visible
     * @param {?=} repeatComponentOptions
     */
    constructor(componentId, visible = true, repeatComponentOptions = { isRepeatComponent: false, skipPages: [] }) {
        this.componentId = componentId;
        this.visible = visible;
        this.repeatComponentOptions = repeatComponentOptions;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    static merge(options) {
        return Object.assign({ visible: true, repeatComponentOptions: { isRepeatComponent: false, skipPages: [] } }, options);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Note: constraints will be only applied in case where this component is rendered in the non breakable mode.
 * The page break logic will only be applied if this component is a root level component returned from the business component.
 * In case this renderer is nested in another component it'll behave like a ColumnPanel
 *
 * This component in a breakable mode allows to handle a page break condition by inserting a component in case of page break intra rendering (i.e repeat headers)
 *
 * To control the minimum number of rows rendered adjust the minRowsBucket constructor param -
 * it'll bucket rows into groups of rows (by default 2) so that a minimal number is always rendered
 * @abstract
 */
class AbstractBreakableRenderer extends AbstractRenderer {
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        /** @type {?} */
        const body = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        /** @type {?} */
        let i = 0;
        /** @type {?} */
        let runningHeight = 0;
        /** @type {?} */
        let actualWidth = 0;
        while (this.hasNext()) {
            /** @type {?} */
            const box = this.renderNext(i++, context);
            if (!box.isEmpty()) {
                body.appendChild(box.element);
                SVGUtils.updateTranslate(0, runningHeight, box.element);
                runningHeight += box.height;
                actualWidth = Math.max(actualWidth, box.width);
            }
        }
        this.reset();
        return new ContentBox(body, actualWidth, runningHeight);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClassList {
    /**
     * @param {?} name
     * @param {?} properties
     */
    constructor(name, properties) {
        this.name = name;
        this.properties = properties;
    }
}
/**
 * This class iterates an HTML document element, trying to match its classList with ones
 * found in `CLASS_LIST` and adding attributes of same names upon matching.
 */
class ClassListParser {
    constructor() {
        this.allClasses = [];
        Object.keys(CLASS_LIST).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            this.allClasses.push(new ClassList(key, CLASS_LIST[key]));
        }));
    }
    /**
     * @param {?} names
     * @param {?=} attrs
     * @return {?}
     */
    getAttributesForClassNames(names, attrs = {}) {
        if (names && names.length) {
            /** @type {?} */
            const list = this.allClasses.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => names.includes(item.name)));
            /** @type {?} */
            const properties = list.map((/**
             * @param {?} klass
             * @return {?}
             */
            klass => klass.properties));
            return Object.assign(Object.assign({}, attrs), ...properties);
        }
        return attrs;
    }
    /**
     * @param {?} elem
     * @return {?}
     */
    addAttributesToElement(elem) {
        if (elem.childNodes && elem.childNodes.length) {
            Array.from(elem.childNodes)
                .filter((/**
             * @param {?} node
             * @return {?}
             */
            node => node.nodeType === 1))
                .forEach((/**
             * @param {?} node
             * @return {?}
             */
            node => {
                this.addAttributesToElement((/** @type {?} */ (node)));
            }));
        }
        /** @type {?} */
        const classNames = Array.from(elem.classList);
        /** @type {?} */
        const attributes = this.getAttributesForClassNames(classNames);
        Object.keys(attributes).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            elem.setAttribute(key, attributes[key]);
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FreeFormTextComponent extends AbstractBreakableRenderer {
    /**
     * @param {?} dcrKey
     * @param {?=} defaultText
     * @param {?=} substitutions
     * @param {?=} constraints
     * @param {?=} textClasses
     * @param {?=} classListParser
     */
    constructor(dcrKey, defaultText, substitutions = {}, constraints, textClasses, classListParser = new ClassListParser()) {
        // Override the padding, border & margin settings so that they're not double applied
        super(BoxModelConstraint.merge(constraints, {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            borderBottom: 0,
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0
        }));
        this.dcrKey = dcrKey;
        this.defaultText = defaultText;
        this.substitutions = substitutions;
        this.constraints = constraints;
        this.textClasses = textClasses;
        this.classListParser = classListParser;
        this.index = 0;
        this.generalBoxModel = new BoxModel(constraints);
        this.firstBoxModel = new BoxModel(BoxModelConstraint.merge(constraints, { paddingBottom: 0, marginBottom: 0, borderBottom: 0 }));
        this.middleBoxModel = new BoxModel(BoxModelConstraint.merge(constraints, { paddingBottom: 0, marginBottom: 0, borderBottom: 0, paddingTop: 0, marginTop: 0, borderTop: 0 }));
        this.lastBoxModel = new BoxModel(BoxModelConstraint.merge(constraints, { paddingTop: 0, marginTop: 0, borderTop: 0 }));
    }
    /**
     * @private
     * @param {?} context
     * @return {?}
     */
    initContent(context) {
        /** @type {?} */
        const attrs = this.textClasses ? this.classListParser.getAttributesForClassNames([...this.textClasses]) : {};
        /** @type {?} */
        let text = this.dcrKey ? this.contentProvider.get(this.dcrKey, this.defaultText) : this.defaultText;
        for (const key of Object.keys(this.substitutions)) {
            text = text.replace(new RegExp(`[{]${key}[}]`, 'g'), this.substitutions[key]);
        }
        if (text === undefined || text === null) {
            console.error('Error occurred while rendering', this);
            text = '';
        }
        const [childWidthConstraint, childHeightConstraint] = this.generalBoxModel.getChildViewConstraints(context.availableWidth, context.availableHeight);
        /** @type {?} */
        const overrides = {
            availableWidth: childWidthConstraint,
            availableHeight: childHeightConstraint
        };
        /** @type {?} */
        const startTime = new Date();
        /** @type {?} */
        const finalContext = this.generalBoxModel.evaluateContext(context, overrides);
        // FIXME: Hack for use full width = true ... our code is broken somewhere and when text isn't greedy the layouts are off all over
        this.textParagraphs = FreeFormTextComponent.composer.compose(text, attrs, finalContext.horizontalAlign, finalContext.availableWidth, finalContext.availableHeight, true);
        /** @type {?} */
        const endTime = new Date();
        if (this.textParagraphs.length <= 1) {
            this.textParagraphs = this.textParagraphs.map((/**
             * @param {?} box
             * @return {?}
             */
            box => this.generalBoxModel.applyTo(box)));
        }
        else {
            /** @type {?} */
            const firstBox = this.firstBoxModel.applyTo(this.textParagraphs[0]);
            /** @type {?} */
            const middleBox = this.textParagraphs.slice(1, this.textParagraphs.length - 1).map((/**
             * @param {?} box
             * @return {?}
             */
            box => this.middleBoxModel.applyTo(box)));
            /** @type {?} */
            const lastBox = this.lastBoxModel.applyTo(this.textParagraphs[this.textParagraphs.length - 1]);
            this.textParagraphs = [firstBox, ...middleBox, lastBox];
        }
        /** @type {?} */
        const timeTaken = endTime.getTime() - startTime.getTime();
        if (BoxModel.PDF_TIME && timeTaken > 50) {
            console.warn(`PDF Text Rendering time ${this.constructor.name} took ${timeTaken}ms.`, this.textParagraphs);
        }
    }
    /**
     * @param {?} index
     * @param {?} context
     * @return {?}
     */
    renderNext(index, context) {
        if (!this.textParagraphs) {
            this.initContent(context);
        }
        if (this.index < this.textParagraphs.length) {
            SVGUtils.setupEditMode(this.textParagraphs[this.index], this.dcrKey, this.defaultText, this.contentProvider);
            return this.textParagraphs[this.index++];
        }
        else {
            return ContentBox.EMPTY;
        }
    }
    /**
     * @return {?}
     */
    break() {
        this.index--;
    }
    /**
     * @return {?}
     */
    hasNext() {
        return !this.textParagraphs || this.index < this.textParagraphs.length;
    }
    /**
     * @return {?}
     */
    reset() {
        this.textParagraphs = null;
        this.index = 0;
    }
}
FreeFormTextComponent.composer = new ParagraphComposer();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StaticParagraphComponent extends FreeFormTextComponent {
    /**
     * @param {?} dcrKey
     * @param {?=} defaultText
     * @param {?=} substitutions
     * @param {?=} constraints
     * @param {?=} textClasses
     */
    constructor(dcrKey, defaultText, substitutions = {}, constraints, textClasses) {
        super(dcrKey, defaultText, substitutions, constraints, textClasses);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TextRenderer {
    /**
     * @param {?} cell
     * @param {?} hAlign
     * @param {?} vAlign
     * @param {?} widthProportion
     * @param {?=} textClasses
     * @param {?=} constraints
     * @param {?=} cellConstraints
     */
    constructor(cell, hAlign, vAlign, widthProportion, textClasses, constraints, cellConstraints) {
        this.cell = cell;
        this.hAlign = hAlign;
        this.vAlign = vAlign;
        this.widthProportion = widthProportion;
        this.textClasses = textClasses;
        this.constraints = constraints;
        this.cellConstraints = cellConstraints;
    }
    /**
     * @return {?}
     */
    render() {
        /** @type {?} */
        const text = this.cell && this.cell.toString();
        return new CellPanel([new StaticParagraphComponent(null, text === undefined ? '-' : text, {}, BoxModelConstraint.merge(this.constraints), this.textClasses)], BoxModelConstraint.merge(this.cellConstraints, { proportion: this.widthProportion }), this.hAlign, LayoutStrategy.COLUMN, this.vAlign);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class that allows to provide a primary header, secondary header and body. If the secondary header is not needed, can provide an empty array.
 *
 * Example of how to use:
 * new MultipleHeaderColumnCompositions(primaryHeaderArray, secondaryHeaderArray, bodyArray);
 *
 * where each one of the provided arrays are Array<ColumnComposition>.
 */
class MultipleHeaderColumnCompositions {
    /**
     * @param {?} primaryHeaders
     * @param {?} secondaryHeaders
     * @param {?} body
     */
    constructor(primaryHeaders, secondaryHeaders, body) {
        this.primaryHeaders = primaryHeaders;
        this.secondaryHeaders = secondaryHeaders;
        this.body = body;
    }
}
class ColumnCompositions {
    /**
     * @param {?} headers
     * @param {?} body
     */
    constructor(headers, body) {
        this.headers = headers;
        this.body = body;
    }
}
class ColumnComposition {
    /**
     * @param {?} init
     */
    constructor(init) {
        this.horizontalAlignment = Alignment.Horizontal.Right;
        Object.assign(this, init);
        /** @type {?} */
        const cell = this.cells instanceof Array ? this.cells && this.cells[0] : this.cells;
        this.renderer =
            init.renderer ||
                new TextRenderer(cell, this.horizontalAlignment, this.verticalAlignment, this.widthProportion, this.textClasses, this.boxModelConstraint, this.cellBoxModelConstraint);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * This component in a breakable mode allows to handle multiple column text that will automatically break the text in multiple column and handle the page break
 * The step is as follow:
 * 1. We render the text in context box like in free-form-text-component with the tweak to max width of the box to be divide by columns number
 * 2. render column by column and using layout panel to get the layout out of the box
 * 3. in case of page break, we create a new panel with the new available height from the new page
 * 4. repeat step 2-3 until all the lines are render
 */
class MultiColumnsBreakableTextComponent extends AbstractBreakableRenderer {
    /**
     * @param {?} contentKey
     * @param {?=} numberOfColumns
     * @param {?=} defaultText
     * @param {?=} substitutions
     * @param {?=} constraints
     * @param {?=} textClasses
     * @param {?=} classListParser
     * @param {?=} spaceBetweenColumn
     */
    constructor(contentKey, numberOfColumns = 1, defaultText, substitutions = {}, constraints, textClasses = DEFAULT_CONDENSED_TEXT_CLASSES, classListParser = new ClassListParser(), spaceBetweenColumn = DEFAULT_MULTI_COLUMNS_TEXT_PADDING) {
        super(BoxModelConstraint.merge(constraints, {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingTop: 0,
            paddingRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            borderBottom: 0,
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0
        }));
        this.contentKey = contentKey;
        this.numberOfColumns = numberOfColumns;
        this.defaultText = defaultText;
        this.substitutions = substitutions;
        this.constraints = constraints;
        this.textClasses = textClasses;
        this.classListParser = classListParser;
        this.spaceBetweenColumn = spaceBetweenColumn;
        this.availableHeight = 0;
        this.index = 0;
        this.retryCounter = 0;
        if (numberOfColumns <= 0 || numberOfColumns > 24) {
            console.error('MultiColumnsBreakableTextComponent Error:Invalid number of column, use default value of 1');
            this.numberOfColumns = 1;
        }
        this.generalBoxModel = new BoxModel(constraints);
    }
    /**
     * init text paragraph, reset the page constrain and create box model
     * @private
     * @return {?}
     */
    initContent() {
        /** @type {?} */
        const textClassAttributes = this.textClasses ? this.classListParser.getAttributesForClassNames([...this.textClasses]) : {};
        /** @type {?} */
        const text = this.getTextFromKey();
        this.composeParagraph(text, textClassAttributes);
    }
    /**
     * generate text to render from dcr
     * @private
     * @return {?}
     */
    getTextFromKey() {
        /** @type {?} */
        let textResult = this.contentKey ? this.contentProvider.get(this.contentKey, this.defaultText) : this.defaultText;
        if (textResult === undefined || textResult === null) {
            console.warn('MultiColumnsBreakableTextComponent Error:Error occurred while rendering', this);
            textResult = '';
        }
        for (const key of Object.keys(this.substitutions)) {
            textResult = textResult.replace(new RegExp(`[{]${key}[}]`, 'g'), this.substitutions[key]);
        }
        return textResult;
    }
    /**
     * reset available height and width
     * @private
     * @param {?} context Initial box model, either the whole page or child container
     * @param {?} remainingWidth
     * @param {?} remainingHeight
     * @return {?}
     */
    resetContext(context, remainingWidth, remainingHeight) {
        this.finalContext = cloneDeep(context);
        if (remainingWidth)
            this.finalContext.availableWidth = remainingWidth;
        if (remainingHeight)
            this.finalContext.availableHeight = remainingHeight;
        const [childWidthConstraint, childHeightConstraint] = this.generalBoxModel.getChildViewConstraints(this.finalContext.availableWidth, this.finalContext.availableHeight);
        /** @type {?} */
        const overrides = {
            availableWidth: (childWidthConstraint - (this.numberOfColumns - 1) * this.spaceBetweenColumn) / this.numberOfColumns,
            availableHeight: childHeightConstraint
        };
        this.finalContext = this.generalBoxModel.evaluateContext(context, overrides);
        this.availableHeight = this.finalContext.availableHeight;
    }
    /**
     * generate paragraph with paragraph composer
     * @private
     * @param {?} text text in HTML format
     * @param {?} textClassAttributes box model attributes
     * @return {?}
     */
    composeParagraph(text, textClassAttributes) {
        /** @type {?} */
        const startTime = new Date();
        this.textParagraphs = MultiColumnsBreakableTextComponent.composer.compose(text, textClassAttributes, this.finalContext.horizontalAlign, this.finalContext.availableWidth, this.finalContext.availableHeight, true, 1);
        /** @type {?} */
        const endTime = new Date();
        /** @type {?} */
        const timeTaken = endTime.getTime() - startTime.getTime();
        if (BoxModel.PDF_TIME && timeTaken > 50) {
            console.warn(`PDF Text Rendering time ${this.constructor.name} took ${timeTaken}ms.`, this.textParagraphs);
        }
    }
    /**
     * to be called by renderer to render next panel
     * @param {?} index component index
     * @param {?} context initial page constrain
     * @param {?} remainingWidth
     * @param {?} remainingHeight
     * @return {?}
     */
    renderNext(index, context, remainingWidth, remainingHeight) {
        this.resetContext(context, remainingWidth, remainingHeight);
        if (!this.textParagraphs) {
            this.initContent();
        }
        if (this.renderNextOverrideReturn) {
            this.renderNextOverrideReturn = null;
            return this.cache;
        }
        if (this.index < this.textParagraphs.length) {
            return this.getMultiColumnsTextPanel(context);
        }
        return ContentBox.EMPTY;
    }
    /**
     * method to render content in non-page-breakable container. e.g. panel
     * @protected
     * @param {?} context initial page constrain
     * @return {?}
     */
    renderContent(context) {
        /** @type {?} */
        const body = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        /** @type {?} */
        let runningHeight = 0;
        /** @type {?} */
        let actualWidth = 0;
        /** @type {?} */
        const box = this.renderNext(0, context, context.availableWidth, context.availableHeight);
        if (!box.isEmpty()) {
            body.appendChild(box.element);
            SVGUtils.updateTranslate(0, runningHeight, box.element);
            runningHeight += box.height;
            actualWidth = Math.max(actualWidth, box.width);
        }
        if (this.hasNext()) {
            throw new Error('MultiColumnsBreakableTextComponent Error:Not enough space to render all the contents in non breakable container');
        }
        this.reset();
        return new ContentBox(body, actualWidth, runningHeight);
    }
    /**
     * method to generate panel contain text columns
     * @private
     * @param {?} context initial page constrain
     * @return {?}
     */
    getMultiColumnsTextPanel(context) {
        if (this.textParagraphs[this.index] && this.textParagraphs[this.index].height > this.availableHeight) {
            if (this.retryCounter++) {
                throw new Error(`MultiColumnsBreakableTextComponent Error: Can not render any content with the height of ${this.textParagraphs[this.index].height} each in the given height of ${this.availableHeight}`);
            }
            this.resetContext(context, context.availableWidth, context.availableHeight);
        }
        /** @type {?} */
        let remainingColumn = this.numberOfColumns;
        /** @type {?} */
        const textColumns = [];
        while (remainingColumn) {
            // have start height equal to remaining space of the page/container
            /** @type {?} */
            let usedHeight = 0;
            /** @type {?} */
            const currentColumnContent = [];
            // append text paragraph if it can fit the remaining height
            while (this.textParagraphs[this.index] && usedHeight + this.textParagraphs[this.index].height <= this.availableHeight) {
                SVGUtils.setupEditMode(this.textParagraphs[this.index], this.contentKey, this.defaultText, this.contentProvider);
                usedHeight += this.textParagraphs[this.index].height;
                currentColumnContent.push(new StaticContentBoxRenderer(this.textParagraphs[this.index++]));
            }
            // break column when reach the end of page
            textColumns.push(new ColumnPanel('text column', currentColumnContent, { marginRight: remainingColumn > 1 ? this.spaceBetweenColumn : 0 }, Alignment.Horizontal.Left, Alignment.Vertical.Top));
            // start a new column
            remainingColumn--;
        }
        this.cache = new RowPanel('row', textColumns, this.constraints, Alignment.Horizontal.Left, Alignment.Vertical.Top).render(context);
        if (!this.cache.isEmpty()) {
            // successfully render content, reset the counter
            this.retryCounter = 0;
        }
        // return multiple columns as one row panel.
        return this.cache;
    }
    /**
     * @return {?}
     */
    break() {
        this.renderNextOverrideReturn = cloneDeep(this.cache);
    }
    /**
     * @return {?}
     */
    hasNext() {
        return (this.renderNextOverrideReturn && !this.renderNextOverrideReturn.isEmpty()) || !this.textParagraphs || this.index < this.textParagraphs.length;
    }
    /**
     * @return {?}
     */
    reset() {
        this.retryCounter = 0;
        this.textParagraphs = null;
        this.index = 0;
    }
}
MultiColumnsBreakableTextComponent.composer = new ParagraphComposer();
// a hack to use panel with content box, only for this component, do not try to export and reuse this.
class StaticContentBoxRenderer extends AbstractRenderer {
    /**
     * @param {?} contentBox
     * @param {?=} constraints
     */
    constructor(contentBox, constraints) {
        super(constraints);
        this.contentBox = contentBox;
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        if (this.contentBox) {
            return this.contentBox;
        }
        return ContentBox.EMPTY;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Options used to enable repeating components
 * isRepeatComponent - set to true if you want this component to repeat
 * skipPages - 	add the page numbers of the parent report section where you do not want this component to repeat
 *              in its current implementation, repeating components will not appear on page 0 of the section
 *              regardless of what you put in the array.
 * Example:
 * 	{
 * 		isRepeatComponent: true,
 * 		skipPages: [0, 1]
 * 	}
 * These properties will allow a repeating component to show on all report section pages after the first and second
 * This will skip a cover page and the first normal page of the section. Useful if you want to repeat the page
 * heading, but you've also configured it to appear on the first normal page (1).
 *
 * NOTE: Also set hasRepeatingComponent in the ReportSection to true
 */
class RepeatComponentOptions {
    constructor() {
        this.isRepeatComponent = false;
        this.skipPages = [];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportConfiguration {
    /**
     * @param {?} pages
     * @param {?=} pageTemplate
     */
    constructor(pages, pageTemplate) {
        this.pages = pages;
        this.pageTemplate = pageTemplate;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SvgParser {
    /**
     * @param {?=} parser
     */
    constructor(parser = new DOMParser()) {
        this.parser = parser;
    }
    /**
     * @param {?} markup
     * @return {?}
     */
    parseG(markup) {
        /** @type {?} */
        const tmpDoc = this.parser.parseFromString(markup, 'image/svg+xml');
        /** @type {?} */
        const res = tmpDoc.getElementsByTagName('g')[0];
        return res;
    }
    /**
     * @param {?} markup
     * @return {?}
     */
    parseSVG(markup) {
        /** @type {?} */
        const tmpDoc = this.parser.parseFromString(markup, 'text/html');
        return tmpDoc.getElementsByTagName('svg')[0];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportPageTemplate {
    /**
     * @param {?} header
     * @param {?} footer
     * @param {?=} dimensions
     */
    constructor(header, footer, dimensions = PageType.LetterPortrait) {
        this.header = header;
        this.footer = footer;
        this.dimensions = dimensions;
    }
    /**
     * @return {?}
     */
    createTemplate() {
        /** @type {?} */
        const defaultTemplate = (/** @type {?} */ (document.createElementNS(SVG_NS, 'svg')));
        defaultTemplate.setAttribute('version', '1.1');
        defaultTemplate.setAttribute('width', `${this.dimensions.pageWidth}px`);
        defaultTemplate.setAttribute('height', `${this.dimensions.pageHeight}px`);
        /** @type {?} */
        const templateBackground = (/** @type {?} */ (document.createElementNS(SVG_NS, 'rect')));
        templateBackground.setAttribute('width', `${this.dimensions.pageWidth}px`);
        templateBackground.setAttribute('height', `${this.dimensions.pageHeight}px`);
        templateBackground.setAttribute('fill', `#fff`);
        defaultTemplate.appendChild(templateBackground);
        defaultTemplate.appendChild(this.createContentArea());
        defaultTemplate.appendChild(this.createHeader());
        defaultTemplate.appendChild(this.createFooter());
        this.pageComponentIndex = 0;
        this.page = defaultTemplate;
    }
    /**
     * @private
     * @return {?}
     */
    createContentArea() {
        this.contentArea = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        this.contentArea.setAttribute('id', `contentArea`);
        this.contentArea.setAttribute('transform', `translate(${(this.dimensions.pageWidth - this.dimensions.contentWidth) / 2} ${(this.dimensions.pageHeight - this.dimensions.contentHeight) / 2 +
            this.dimensions.contentHeightPositionOffset})`);
        this.contentArea.setAttribute('width', `${this.dimensions.contentWidth}px`);
        this.contentArea.setAttribute('height', `${this.dimensions.contentHeight}px`);
        Object.keys(CLASS_LIST['text-defaults']).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            this.contentArea.setAttribute(key, CLASS_LIST['text-defaults'][key]);
        }));
        /** @type {?} */
        const contentBackground = (/** @type {?} */ (document.createElementNS(SVG_NS, 'rect')));
        contentBackground.setAttribute('width', `${this.dimensions.contentWidth}px`);
        contentBackground.setAttribute('height', `${this.dimensions.contentHeight}px`);
        contentBackground.setAttribute('fill', `#FFF`);
        this.contentArea.appendChild(contentBackground);
        return this.contentArea;
    }
    /**
     * @private
     * @return {?}
     */
    createHeader() {
        /** @type {?} */
        const headerElement = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        headerElement.setAttribute('transform', this.dimensions.headerTransform);
        /** @type {?} */
        const parser = new SvgParser();
        /** @type {?} */
        const headerG = (/** @type {?} */ (parser.parseG(this.header)));
        headerElement.appendChild(headerG);
        return headerElement;
    }
    /**
     * @private
     * @return {?}
     */
    createFooter() {
        /** @type {?} */
        const pageNumberingText = (/** @type {?} */ (document.createElementNS(SVG_NS, 'g')));
        pageNumberingText.setAttribute('transform', this.dimensions.footerTransform);
        /** @type {?} */
        const parser = new SvgParser();
        /** @type {?} */
        const footerG = parser.parseG(this.footer);
        pageNumberingText.appendChild(footerG);
        return pageNumberingText;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    addElement(element) {
        this.incrementComponentIndex();
        this.contentArea.appendChild(element);
    }
    /**
     * Return a BoxModelContext object with the available width and height limits set to
     * template's limits
     * @return {?}
     */
    getContext() {
        return {
            availableWidth: this.getContentWidth(),
            availableHeight: this.getContentHeight()
        };
    }
    /**
     * Return the template page with all elements that have been added to it
     * @return {?}
     */
    commitPage() {
        /** @type {?} */
        const fullPage = this.page;
        this.createTemplate();
        return fullPage;
    }
    /**
     * @return {?}
     */
    getContentHeight() {
        return this.dimensions.contentHeight;
    }
    /**
     * @return {?}
     */
    getContentWidth() {
        return this.dimensions.contentWidth;
    }
    /**
     * @return {?}
     */
    checkEmpty() {
        return this.pageComponentIndex === 0;
    }
    /**
     * @return {?}
     */
    getComponentIndex() {
        return this.pageComponentIndex;
    }
    /**
     * @return {?}
     */
    incrementComponentIndex() {
        this.pageComponentIndex++;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportSection {
    /**
     * @param {?} components
     * @param {?=} name
     * @param {?=} order
     * @param {?=} visible
     * @param {?=} hasRepeatingComponent
     */
    constructor(components, name, order, visible = true, hasRepeatingComponent = false // components to repeat after every page break in this section
    ) {
        this.components = components;
        this.name = name;
        this.order = order;
        this.visible = visible;
        this.hasRepeatingComponent = hasRepeatingComponent;
        this.layoutManager = new LayoutManager(LayoutStrategy.COLUMN);
    }
    /**
     * @return {?}
     */
    getComponentIds() {
        return this.components
            .filter((/**
         * @param {?} c
         * @return {?}
         */
        c => c instanceof BusinessComponent))
            .map((/**
         * @param {?} c
         * @return {?}
         */
        c => ((/** @type {?} */ (c))).businessComponentOptions.componentId))
            .filter((/**
         * @param {?} id
         * @return {?}
         */
        id => id))
            .sort();
    }
    /**
     * @param {?} component
     * @param {?} pageTemplate
     * @return {?}
     */
    tryAddContentBox(component, pageTemplate) {
        if (component.isEmpty()) {
            pageTemplate.incrementComponentIndex();
            return true;
        }
        if (this.layoutManager.canAccommodateContentBox(component)) {
            try {
                /** @type {?} */
                const updatedComponent = this.layoutManager.updatePositionAndCursor(component);
                pageTemplate.addElement(updatedComponent.element);
                return true;
            }
            catch (error) {
                throw new Error(`The panel encountered a layout error: ${error.message}`);
            }
        }
        return false;
    }
    /**
     * @private
     * @param {?} pageTemplate
     * @return {?}
     */
    commitPage(pageTemplate) {
        /** @type {?} */
        const fullPage = pageTemplate.commitPage();
        this.layoutManager.resetSpace();
        return fullPage;
    }
    /**
     * @param {?} componentDataMap
     * @param {?} contentProvider
     * @param {?} pageTemplate
     * @param {?=} applicationState
     * @return {?}
     */
    generate(componentDataMap, contentProvider, pageTemplate, applicationState) {
        /** @type {?} */
        const pages = (/** @type {?} */ ([]));
        /** @type {?} */
        const repeatingComponents = this.getRepeatingComponents();
        this.layoutManager.setLayoutSize(pageTemplate.getContentWidth(), pageTemplate.getContentHeight());
        pageTemplate.createTemplate();
        this.components.forEach((/**
         * @param {?} child
         * @return {?}
         */
        child => {
            if (child instanceof Panel) {
                /** @type {?} */
                const contentBox = child.render(pageTemplate.getContext());
                this.tryAddContentBox(contentBox, pageTemplate);
            }
            else if (child instanceof BusinessComponent && child.businessComponentOptions.visible) {
                /** @type {?} */
                const componentData = !child.businessComponentOptions.componentId
                    ? { id: 'empty', error: null, visible: true }
                    : componentDataMap.get(child.businessComponentOptions.componentId);
                if (!componentData) {
                    throw new Error(`Unknown component ${child.businessComponentOptions.componentId}`);
                }
                if (!componentData.error) {
                    try {
                        // TODO add new state props
                        /** @type {?} */
                        const childArtifacts = child.buildComponent(componentData, contentProvider, applicationState);
                        childArtifacts.forEach((/**
                         * @param {?} artifact
                         * @return {?}
                         */
                        artifact => {
                            if (artifact instanceof AbstractBreakableRenderer) {
                                // Breakable renderers
                                while (artifact.hasNext()) {
                                    this.insertRepeatingComponents(pageTemplate, pages, repeatingComponents, componentDataMap, contentProvider, applicationState);
                                    /** @type {?} */
                                    const box = artifact.renderNext(pageTemplate.getComponentIndex(), pageTemplate.getContext(), this.layoutManager.getRemainingWidth(), this.layoutManager.getRemainingHeight());
                                    if (!this.tryAddContentBox(box, pageTemplate)) {
                                        if (pageTemplate.checkEmpty()) {
                                            throw new Error(`Unable to render BreakableRenderer: Failed to add 1st component on the page content \
												remainingWidth,remainingHeight : ${this.layoutManager.getRemainingWidth()} x ${this.layoutManager.getRemainingHeight()} \
												used space: ${box.width} x ${box.height} `);
                                        }
                                        // Handle page break
                                        pages.push(this.commitPage(pageTemplate));
                                        artifact.break();
                                    }
                                }
                            }
                            else if (artifact instanceof PageBreak) {
                                pages.push(this.commitPage(pageTemplate));
                                this.insertRepeatingComponents(pageTemplate, pages, repeatingComponents, componentDataMap, contentProvider, applicationState);
                            }
                            else {
                                // Non breakable renderers
                                this.renderNonBreakableArtifact(artifact, pageTemplate, pages, repeatingComponents, componentDataMap, applicationState);
                            }
                        }));
                    }
                    catch (err) {
                        console.error(`PDF: Can't generate component ${child.name} componentDataId: ${child.businessComponentOptions.componentId} - error occurred during generation`, err);
                        return [];
                    }
                }
                else {
                    console.warn(`PDF: Can't generate component ${child.name} componentDataId: ${child.businessComponentOptions.componentId} - data unavailable`, componentData.error);
                    return [];
                }
            }
            else {
                console.warn(`PDF: Can't generate component - Unsupported component`);
                return [];
            }
        }));
        if (!pageTemplate.checkEmpty()) {
            pages.push(this.commitPage(pageTemplate));
        }
        return pages;
    }
    /**
     * @private
     * @param {?} artifact
     * @param {?} pageTemplate
     * @param {?} pages
     * @param {?=} repeatingComponents
     * @param {?=} componentDataMap
     * @param {?=} contentProvider
     * @param {?=} applicationState
     * @return {?}
     */
    renderNonBreakableArtifact(artifact, pageTemplate, pages, repeatingComponents, componentDataMap, contentProvider, applicationState) {
        /** @type {?} */
        const contentBox = artifact.render(pageTemplate.getContext());
        if (artifact.newPage || !this.tryAddContentBox(contentBox, pageTemplate)) {
            pages.push(this.commitPage(pageTemplate));
            this.insertRepeatingComponents(pageTemplate, pages, repeatingComponents, componentDataMap, contentProvider, applicationState);
            if (!this.tryAddContentBox(contentBox, pageTemplate)) {
                throw new Error(`Unable to add component \
					remainingWidth,remainingHeight : ${this.layoutManager.getRemainingWidth()} x ${this.layoutManager.getRemainingHeight()} \
					used space: ${contentBox.width} x ${contentBox.height} `);
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    getRepeatingComponents() {
        return this.components
            .filter((/**
         * @param {?} component
         * @return {?}
         */
        (component) => component instanceof BusinessComponent))
            .filter((/**
         * @param {?} component
         * @return {?}
         */
        (component) => component.businessComponentOptions.repeatComponentOptions.isRepeatComponent));
    }
    /**
     * @private
     * @param {?} pageTemplate
     * @param {?} pages
     * @param {?} repeatingComponents
     * @param {?} componentDataMap
     * @param {?} contentProvider
     * @param {?} applicationState
     * @return {?}
     */
    insertRepeatingComponents(pageTemplate, pages, repeatingComponents, componentDataMap, contentProvider, applicationState) {
        if (repeatingComponents) {
            /** @type {?} */
            const pageNumber = pages.length;
            repeatingComponents.forEach((/**
             * @param {?} repeatingComponent
             * @return {?}
             */
            (repeatingComponent) => {
                if (pageTemplate.getComponentIndex() === 0 && !repeatingComponent.businessComponentOptions.repeatComponentOptions.skipPages.includes(pageNumber)) {
                    /** @type {?} */
                    const componentData = !repeatingComponent.businessComponentOptions.componentId
                        ? { id: 'empty', error: null, visible: true }
                        : componentDataMap.get(repeatingComponent.businessComponentOptions.componentId);
                    if (!componentData.error) {
                        /** @type {?} */
                        const repeatingComponentArtifacts = repeatingComponent.buildComponent(componentData, contentProvider, applicationState);
                        repeatingComponentArtifacts.forEach((/**
                         * @param {?} repeatingArtifact
                         * @return {?}
                         */
                        repeatingArtifact => this.renderNonBreakableArtifact(repeatingArtifact, pageTemplate, pages)));
                    }
                }
            }));
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DotRenderer extends AbstractRenderer {
    /**
     * @param {?} color
     * @param {?=} constraints
     * @param {?=} params
     */
    constructor(color, constraints, params = { size: 5 }) {
        super(constraints);
        this.color = color;
        this.params = params;
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        /** @type {?} */
        const element = (/** @type {?} */ (document.createElementNS(SVG_NS, 'circle')));
        element.setAttribute('fill', this.color);
        element.setAttribute('cx', String(this.params.size / 2));
        element.setAttribute('cy', String(this.params.size / 2));
        element.setAttribute('r', String(this.params.size / 2));
        if (this.params.stroke) {
            element.setAttribute('stroke', String(this.params.stroke));
        }
        if (this.params.strokeWidth) {
            element.setAttribute('stroke-width', String(this.params.strokeWidth));
        }
        return new ContentBox(element, this.params.size, this.params.size);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageRenderer extends AbstractRenderer {
    /**
     * @param {?} imageMarkup
     * @param {?=} constraints
     */
    constructor(imageMarkup, constraints) {
        super(constraints);
        this.imageMarkup = imageMarkup;
        this.constraints = constraints;
        this.parser = new SvgParser();
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        if (this.imageMarkup && this.imageMarkup.length) {
            /** @type {?} */
            const svg = (/** @type {?} */ (this.parser.parseSVG(this.imageMarkup)));
            /** @type {?} */
            const initialHeight = Number.parseInt(svg.getAttribute('height'));
            /** @type {?} */
            const viewBoxHeight = Number.parseInt(svg.getAttribute('viewBox').split(' ')[3]);
            /** @type {?} */
            let imageHeight = (initialHeight * initialHeight) / viewBoxHeight;
            /** @type {?} */
            const initialWidth = Number.parseInt(svg.getAttribute('width'));
            /** @type {?} */
            const viewBoxWidth = Number.parseInt(svg.getAttribute('viewBox').split(' ')[2]);
            /** @type {?} */
            let imageWidth = (initialWidth * initialWidth) / viewBoxWidth;
            /** @type {?} */
            const aspectRatio = imageWidth / imageHeight;
            if (context.useFullWidth || imageWidth > context.availableWidth) {
                imageWidth = context.availableWidth;
                imageHeight = imageWidth / aspectRatio;
            }
            if (imageHeight > context.availableHeight) {
                imageHeight = context.availableHeight;
                imageWidth = imageHeight * aspectRatio;
            }
            svg.setAttribute('width', imageWidth.toFixed(1));
            svg.setAttribute('height', imageHeight.toFixed(1));
            return new ContentBox(svg, imageWidth, imageHeight);
        }
        else {
            return new ContentBox((/** @type {?} */ (document.createElementNS(SVG_NS, 'svg'))), 0, 0);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageAndTextRenderer {
    /**
     * @param {?} cell
     * @param {?} imageMarkup
     * @param {?} hAlign
     * @param {?} widthProportion
     * @param {?} childrenProportions
     * @param {?=} textClasses
     * @param {?=} constraints
     * @param {?=} rowPanelConstraints
     */
    constructor(cell, imageMarkup, hAlign, widthProportion, childrenProportions, textClasses, constraints, rowPanelConstraints) {
        this.cell = cell;
        this.imageMarkup = imageMarkup;
        this.hAlign = hAlign;
        this.widthProportion = widthProportion;
        this.childrenProportions = childrenProportions;
        this.textClasses = textClasses;
        this.constraints = constraints;
        this.rowPanelConstraints = rowPanelConstraints;
        if (!childrenProportions || childrenProportions.length !== 2) {
            throw new Error(`ImageAndTextRenderer : Width proportions are either not defined or are not correct.`);
        }
    }
    /**
     * @return {?}
     */
    render() {
        return new CellPanel([
            new RowPanel('Image And Text Row', [
                new CellPanel([new ImageRenderer(this.imageMarkup)], { proportion: this.childrenProportions[0], width: 28.84, height: 28.84 }, this.hAlign),
                new CellPanel([new StaticParagraphComponent(null, this.cell.toString(), {}, BoxModelConstraint.merge(this.constraints), this.textClasses)], { proportion: this.childrenProportions[1] }, this.hAlign)
            ], this.rowPanelConstraints, Alignment.Horizontal.Left, Alignment.Vertical.Middle)
        ], { proportion: this.widthProportion }, this.hAlign);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaddedTextRenderer {
    /**
     * @param {?} cell
     * @param {?} hAlign
     * @param {?} widthProportion
     * @param {?=} textClasses
     * @param {?=} constraints
     */
    constructor(cell, hAlign, widthProportion, textClasses, constraints) {
        this.cell = cell;
        this.hAlign = hAlign;
        this.widthProportion = widthProportion;
        this.textClasses = textClasses;
        this.constraints = constraints;
    }
    /**
     * @return {?}
     */
    render() {
        return new CellPanel([
            new ColumnPanel('Padded Text Column', [new StaticParagraphComponent(null, this.cell.toString(), {}, {}, this.textClasses)], BoxModelConstraint.merge(this.constraints), Alignment.Horizontal.Left, Alignment.Vertical.Middle)
        ], { proportion: this.widthProportion }, this.hAlign);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SquareRenderer extends AbstractRenderer {
    /**
     * @param {?} color
     * @param {?=} constraints
     * @param {?=} width
     * @param {?=} height
     */
    constructor(color, constraints, width = 5, height) {
        super(constraints);
        this.color = color;
        this.width = width;
        this.height = height;
    }
    /**
     * @protected
     * @param {?} context
     * @return {?}
     */
    renderContent(context) {
        /** @type {?} */
        const element = (/** @type {?} */ (document.createElementNS(SVG_NS, 'rect')));
        element.setAttribute('fill', this.color);
        element.setAttribute('width', String(this.width));
        element.setAttribute('height', String(this.height ? this.height : this.width));
        return new ContentBox(element, this.width, this.height ? this.height : this.width);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Renderer that allows multiple text lines.
 *
 * Example of how to use it in ColumnComposition:
 * const columnComposition = new ColumnComposition({
 * widthProportion: 100,
 * renderer: new MultipleLineTextRenderer(
 * [
 * {
 * cell: 'this is the first line',
 * textClasses: ['text-8'],
 * constraints: { paddingTop: 9, paddingLeft: 12, paddingRight: 12 }
 * },
 * {
 * cell: 'this is the second line',
 * textClasses: ['text-7'],
 * constraints: { paddingBottom: 9, paddingLeft: 12, paddingRight: 12 }
 * }
 * ],
 * Alignment.Horizontal.Right,
 * Alignment.Vertical.Middle,
 * 100,
 * { borderLeft: 1, borderRight: 0.25 }
 * )
 * });
 */
class MultipleLineTextRenderer {
    /**
     * @param {?} cells
     * @param {?} hAlign
     * @param {?} vAlign
     * @param {?} widthProportion
     * @param {?=} cellConstraints
     */
    constructor(cells, hAlign, vAlign, widthProportion, cellConstraints) {
        this.cells = cells;
        this.hAlign = hAlign;
        this.vAlign = vAlign;
        this.widthProportion = widthProportion;
        this.cellConstraints = cellConstraints;
    }
    /**
     * Returns a CellPanel based on the args provided in the constructor:
     * - cells: array of CellToRenderConfig - this is equivalent to the config of each line we want to render (value, text classes and constraints)
     * - hAlign: the horizontal alignment of the whole cell
     * - vAlign: the vertical alignment of the whole cell
     * - widthProportion: the width proportion of the whole cell
     * - cellConstraints: the constraints of the whole cell
     * @return {?}
     */
    render() {
        return new CellPanel(this.cells.map((/**
         * @param {?} cellObject
         * @return {?}
         */
        cellObject => {
            /** @type {?} */
            const text = cellObject.cell && cellObject.cell.toString();
            /** @type {?} */
            const textClasses = cellObject.textClasses;
            /** @type {?} */
            const constraints = cellObject.constraints;
            return new StaticParagraphComponent(null, text === undefined ? '-' : text, {}, BoxModelConstraint.merge(constraints), textClasses);
        })), BoxModelConstraint.merge(this.cellConstraints, { proportion: this.widthProportion }), this.hAlign, LayoutStrategy.COLUMN, this.vAlign);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageCellRenderer {
    /**
     * @param {?} imageMarkup
     * @param {?} widthProportion
     * @param {?} hAlign
     * @param {?} vAlign
     * @param {?=} cellConstraints
     * @param {?=} rowPanelConstraints
     * @param {?=} imageWidth
     * @param {?=} imageHeight
     */
    constructor(imageMarkup, widthProportion, hAlign, vAlign, cellConstraints, rowPanelConstraints, imageWidth, imageHeight) {
        this.imageMarkup = imageMarkup;
        this.widthProportion = widthProportion;
        this.hAlign = hAlign;
        this.vAlign = vAlign;
        this.cellConstraints = cellConstraints;
        this.rowPanelConstraints = rowPanelConstraints;
        this.imageWidth = imageWidth;
        this.imageHeight = imageHeight;
    }
    /**
     * @return {?}
     */
    render() {
        return new CellPanel([
            new RowPanel('Image Row', [
                new CellPanel([new ImageRenderer(this.imageMarkup)], { proportion: 100, width: this.imageWidth, height: this.imageHeight }, this.hAlign)
            ], this.rowPanelConstraints, this.hAlign, this.vAlign)
        ], BoxModelConstraint.merge(this.cellConstraints, { proportion: this.widthProportion }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Note: constraints will be only applied in case where this component is rendered in the non breakable mode.
 * The page break logic will only be applied if this component is a root level component returned from the business component.
 * In case this renderer is nested in another component it'll behave like a ColumnPanel
 *
 * This component in a breakable mode allows to handle a page break condition by inserting a component in case of page break intra rendering (i.e repeat headers)
 *
 * To control the minimum number of rows rendered adjust the minRowsBucket constructor param -
 * it'll bucket rows into groups of rows (by default 2) so that a minimal number is always rendered
 */
class BreakableRenderer extends AbstractBreakableRenderer {
    /**
     * @param {?} rows
     * @param {?=} constraints
     * @param {?=} pageBreak
     * @param {?=} minRowsBucket
     */
    constructor(rows, constraints, pageBreak, minRowsBucket = 2) {
        super(constraints);
        this.rows = rows;
        this.pageBreak = pageBreak;
        this.minRowsBucket = minRowsBucket;
        this.currentItemNo = 0;
        this.cache = [];
        this._groupedRows = null;
        this.triggerOnPageBreak = false;
    }
    /**
     * @private
     * @return {?}
     */
    groupRows() {
        /** @type {?} */
        const groupedRows = [];
        if (this.minRowsBucket > 1) {
            for (let i = 0; i < this.rows.length; i += this.minRowsBucket) {
                groupedRows.push(new ColumnPanel('row', this.rows.slice(i, i + this.minRowsBucket)));
            }
        }
        else {
            groupedRows.push(...this.rows);
        }
        return groupedRows;
    }
    /**
     * @private
     * @return {?}
     */
    getGroupedRows() {
        if (!this._groupedRows) {
            this._groupedRows = this.groupRows();
        }
        return this._groupedRows;
    }
    /**
     * Render next content box of this page breakable component
     * @param {?} index This is the index of the component on the current page, the number must start
     *  from 0 for the first component and be incremented for each component added to the page
     * @param {?} context the rendering context for this component
     * @return {?}
     */
    renderNext(index, context) {
        if (this.triggerOnPageBreak && this.currentItemNo !== 0) {
            this.triggerOnPageBreak = false;
            /** @type {?} */
            const pageBreak = this.onPageBreak(context);
            if (pageBreak !== ContentBox.EMPTY) {
                return pageBreak;
            }
        }
        else if (this.triggerOnPageBreak) { // reset triggerOnPageBreak if currentItemNo was 0
            this.triggerOnPageBreak = false;
        }
        /** @type {?} */
        const grouped = this.getGroupedRows();
        if (grouped.length > this.currentItemNo) {
            if (!this.cache[this.currentItemNo]) {
                this.cache[this.currentItemNo] = grouped[this.currentItemNo].render(context);
            }
            return this.cache[this.currentItemNo++];
        }
        else {
            throw new Error(`There are no rows left to render, index out of bounds ${this.currentItemNo}`);
        }
    }
    /**
     * @return {?}
     */
    break() {
        this.currentItemNo--;
        if (this.currentItemNo < 0) {
            this.currentItemNo = 0;
        }
        this.triggerOnPageBreak = true;
    }
    /**
     * @return {?}
     */
    hasNext() {
        /** @type {?} */
        const grouped = this.getGroupedRows();
        return grouped.length > this.currentItemNo;
    }
    /**
     * @return {?}
     */
    reset() { }
    /**
     * @private
     * @param {?} context
     * @return {?}
     */
    onPageBreak(context) {
        if (this.pageBreak) {
            if (!this._pageBreakContent) {
                this._pageBreakContent = this.pageBreak.render(context);
            }
            return new ContentBox((/** @type {?} */ (this._pageBreakContent.element.cloneNode(true))), this._pageBreakContent.width, this._pageBreakContent.height);
        }
        else {
            return ContentBox.EMPTY;
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportComposerService {
    constructor() {
        this.classListParser = new ClassListParser();
    }
    /**
     * @param {?} reportConfig
     * @param {?} componentDataLookup
     * @param {?} contentProvider
     * @param {?=} applicationState
     * @return {?}
     */
    generateReport(reportConfig, componentDataLookup, contentProvider, applicationState) {
        /** @type {?} */
        const finalPageMarkup = [];
        // Init contentService global
        AbstractRenderer.contentProvider = contentProvider;
        try {
            /** @type {?} */
            const pageTemplates = this.getPageTemplates(reportConfig, componentDataLookup, contentProvider, applicationState);
            /** @type {?} */
            let index;
            for (index = 0; index < pageTemplates.length; index++) {
                /** @type {?} */
                const pageSvg = pageTemplates[index];
                /** @type {?} */
                const componentDoc = new DOMParser().parseFromString(pageSvg, 'text/html');
                finalPageMarkup.push(componentDoc.body.innerHTML.trim());
            }
        }
        catch (e) {
            console.error(`${ReportComposerService.LOGGER_PREFIX} Error encountered during report generation`, e);
            throw new Error('Report generation failed');
        }
        return of(finalPageMarkup);
    }
    /**
     * @param {?} reportConfig
     * @param {?} componentDataLookup
     * @param {?} contentProvider
     * @param {?=} applicationState
     * @return {?}
     */
    getPageTemplates(reportConfig, componentDataLookup, contentProvider, applicationState) {
        /** @type {?} */
        const pageTemplates = [];
        /** @type {?} */
        let pageIndex;
        for (pageIndex = 0; pageIndex < reportConfig.pages.length; pageIndex++) {
            // TODO pass down state props
            /** @type {?} */
            const generatedElements = reportConfig.pages[pageIndex].generate(componentDataLookup, contentProvider, reportConfig.pageTemplate, applicationState);
            if (generatedElements && generatedElements.length) {
                generatedElements.forEach((/**
                 * @param {?} generatedElement
                 * @return {?}
                 */
                generatedElement => {
                    /** @type {?} */
                    const pageElement = generatedElement;
                    this.classListParser.addAttributesToElement(pageElement);
                    /** @type {?} */
                    const parser = new DOMParser();
                    /** @type {?} */
                    const doc = parser.parseFromString('<svg></svg>', 'text/xml');
                    doc.removeChild(doc.firstChild);
                    doc.appendChild(pageElement);
                    /** @type {?} */
                    let xmlString = new XMLSerializer().serializeToString(doc);
                    xmlString = xmlString.replace(/ xmlns="" /g, ' ');
                    pageTemplates.push(xmlString);
                }));
            }
            else {
                console.warn(`${ReportComposerService.LOGGER_PREFIX} Report page skipped nothing was generated.`);
            }
        }
        return pageTemplates;
    }
}
ReportComposerService.ɵfac = function ReportComposerService_Factory(t) { return new (t || ReportComposerService)(); };
ReportComposerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ReportComposerService, factory: ReportComposerService.ɵfac });
ReportComposerService.ID_PAGE_NO = 'pageNo';
ReportComposerService.DATA_LOAD_DELAY = 500;
ReportComposerService.LOGGER_PREFIX = '(ReportComposerService)';
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReportComposerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class ContentProvider {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReportComposerModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ReportComposerModule,
            providers: [ReportComposerService]
        };
    }
}
ReportComposerModule.ɵfac = function ReportComposerModule_Factory(t) { return new (t || ReportComposerModule)(); };
ReportComposerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ReportComposerModule });
ReportComposerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReportComposerModule, [{
        type: NgModule
    }], null, null); })();

export { AbstractBreakableRenderer, AbstractRenderer, Alignment, AlignmentStore, BoxModel, BoxModelConstants, BoxModelConstraint, BreakableRenderer, BusinessComponent, BusinessComponentOptions, CLASS_LIST, CellPanel, ClassList, ClassListParser, ColumnComposition, ColumnCompositions, ColumnPanel, ContentBox, ContentBoxBuilder, ContentProvider, DEFAULT_CONDENSED_TEXT_CLASSES, DEFAULT_MULTI_COLUMNS_TEXT_PADDING, DataError, DomCalcElement, DomTextSizeStrategy, DotRenderer, ElementPositionRange, FreeFormTextComponent, HighChartsSVGUtil, HtmlClassEnd, HtmlClassStart, HtmlNewLine, HtmlSpace, HtmlTextElem, HtmlTextParser, HtmlWord, ImageAndTextRenderer, ImageCellRenderer, ImageRenderer, LayoutDimensions, LayoutError, LayoutManager, LayoutStrategy, LetterDimensions, LineComposer, MemoisedTextSizeStrategy, MultiColumnsBreakableTextComponent, MultipleHeaderColumnCompositions, MultipleLineTextRenderer, PaddedTextRenderer, PageBreak, PageType, Panel, ParagraphComposer, ParagraphMap, PhantomSVGText, PublicContentBox, RepeatComponentOptions, ReportComposerModule, ReportComposerService, ReportConfiguration, ReportPageTemplate, ReportSection, RowPanel, SVGUtils, SVG_NS, SimpleTextBreakStrategy, SquareRenderer, StaticParagraphComponent, SvgParser, SvgTextRenderer, TRANSLATE_PATTERN, TRANSLATE_PATTERN_PREFIX, TRANSLATE_PATTERN_SUFFIX, TRANSLATE_PATTERN_X_INDEX, TRANSLATE_PATTERN_Y_INDEX, TextBreakStrategy, TextHighlightingCases, TextRenderer, TextSVGRendererError, TextSvgConfig, TextSvgRendererUtils, setupBorders, ReportComposerService as ɵa };

